{
	"F-is-a-wildcard-for-any-character": "'F' est un caractère générique pour \"n'importe quelle valeur\".",
	"REMOTE_READ_ONLY": "Lire",
	"REMOTE_READ_WRITE": "Lire et Écrire",
	"_box": "box",
	"_boxes": "boxes",
	"_generic": "generic",
	"_generic-plural": "genericPlural",
	"_hub": "hub",
	"_hubs": "hubs",
	"about-commands": "À propos des commandes",
	"about-events": "À propos des événements",
	"about-routing-table": "À propos de la table de routage",
	"access-point-name": "Nom du point d'accès (APN)",
	"access-the-schedule": "Accéder au planning",
	"access-token": "Access token",
	"access-type": "Type d'accès",
	"access-type-error": "Type d'accès incorrect",
	"access-type-is-remote": "Accéder à distance à la propriété et à ses valeurs",
	"access-type-is-remote-help": "Sélectionnez oui pour que les valeurs remontées par cette propriété soient envoyées vers le cloud ou pour pouvoir écrire depuis le cloud la valeur de la propriété. Les valeurs sont toujours disponibles en lecture et en écriture à l'intérieur de l'appareil (local)",
	"access-type-is-remote-hub": "Accéder à distance à la propriété et à ses valeurs si la réception des données est activée",
	"acknowledge-alert": "Acquitter l'alerte",
	"acknowledged": "Acquittée",
	"acted-as": "en tant que",
	"action-time": "Temps de l'action",
	"actions": "Actions",
	"activate": "Activer",
	"activate-account": "Activez votre compte ici",
	"activate-box-hub": "Activer la {box}",
	"activate-bulk-actions": "Sélectionner des lignes pour \ndes actions en masse",
	"activate-reception-property-data-60-minutes": "Activer la réception des valeurs des propriétés des équipements pendant 60 minutes",
	"activate-reception-property-data-eth.active.1": "@.capitalize:box connectée à la console.",
	"activate-reception-property-data-sim": "Activer la communication via la carte SIM pour connecter la @.lower:box à la console et réceptionner les valeurs des propriétés (limité à 30 activations sur 7 jours consécutifs).",
	"activate-reception-property-data-sim.active.1": "@.capitalize:box connectée à la console via la carte SIM.",
	"activate-reception-property-data-sim.duration": "Durée de connexion : 60 minutes.",
	"activate-reception-property-data.active.2": "Les données des propriétés sont réceptionnées.",
	"activate-reception-property-data.error.rate-limit.1": "Les données ne peuvent plus être réceptionnées.",
	"activate-reception-property-data.error.rate-limit.2": "Vous avez atteint la limite d'activations de réception de données (30 fois sur 7 jours calendaires)",
	"activation-method": "Méthode d'activation",
	"activation-method-tooltip": "Méthode à utiliser pour activer le périphérique (fournie par le fabricant), généralement OTAA",
	"active": "Active",
	"add": "Ajouter",
	"add-a-box": "Ajouter des @.clientname:_box",
	"add-a-condition": "Ajouter une condition",
	"add-a-connector": "Ajouter un connecteur",
	"add-a-property": "Ajouter une propriété",
	"add-a-recipient": "Ajouter un destinataire",
	"add-a-route": "Ajouter une route",
	"add-a-slot": "Ajouter un créneau",
	"add-a-trigger": "Ajouter un trigger",
	"add-alarm": "Ajouter une alarme",
	"add-an-action": "Ajouter une action",
	"add-another-device": "Ajouter un autre appareil",
	"add-another-equipment": "Ajouter un autre équipement",
	"add-another-licence": "Ajouter une autre licence",
	"add-archive-recurring-request": "Demander une archive récurrente",
	"add-archive-request": "Demander une archive",
	"add-bacnet-server-property": "Rediriger un planning stocké dans un régulateur",
	"add-boxes": "Ajouter des @.lower:boxes",
	"add-boxes-to-the-trigger": "Ajouter les @.lower:boxes au trigger",
	"add-config-link": "Ajouter un lien vers la configuration",
	"add-custom-slug": "Ajouter un slug personnalisé",
	"add-dashboard": "Ajouter un dashboard",
	"add-device": "Ajouter un appareil",
	"add-equipment": "Ajouter un équipement",
	"add-equipment-to-network": "ajouter de l'équipement au réseau",
	"add-equipment.advanced-description": "Ajoutez un équipement manuellement.",
	"add-equipment.bulk-creation": "Ajout en masse",
	"add-equipment.bulk-creation.bacnet": "Import fichier EDE BACnet",
	"add-equipment.bulk-creation.bacnet-description": "Utilisez le résultat d’un précédent scan BACnet au format EDE.",
	"add-equipment.bulk-creation.knx": "Ajout à partir du logiciel ETS (KNX)",
	"add-equipment.bulk-creation.knx-description": "Exportez les “group address” depuis le logiciel ETS et importez le fichier XML.",
	"add-equipment.bulk-creation.lorawan": "Ajout en masse d'équipements LoRaWAN",
	"add-equipment.bulk-creation.lorawan-description": "Déposez un fichier CSV contenant tous les équipements LoRaWAN à ajouter.",
	"add-equipment.preconfigured-description": "Les propriétés de l'équipement seront immédiatement disponibles. Compatible avec les protocoles : LoRaWAN, LPB (RVL), KNX (Synco) et Modbus (RTU et TCP/IP).",
	"add-equipment.preconfigured-list": "Bibliothèque d'équipements décodés",
	"add-equipment.preconfigured-pick": "Choisir un équipement décodé",
	"add-equipment.scan": "Scan",
	"add-equipment.scan.bacnet": "Scan d'un réseau BACnet",
	"add-equipment.scan.bacnet-description": "Lancez un scan sur un réseau BACnet. Les équipements et leurs propriétés seront automatiquement détectés.",
	"add-equipment.scan.mbus": "Scan d'un réseau M-Bus",
	"add-equipment.scan.mbus-description": "Lancez un scan sur un réseau M-Bus. Les équipements et leurs propriétés seront automatiquement détectés.",
	"add-event": "Créer un évènement",
	"add-graph": "Ajouter un graphique",
	"add-history-link": "Ajouter un lien vers l'historique",
	"add-licence": "Ajouter une licence",
	"add-network": "Ajouter un réseau",
	"add-network-to-equipment": "Ajouter un réseau à l'équipement",
	"add-new-box-privileges": "Ajouter une @.lower:box",
	"add-new-dashboard": "Dashboard",
	"add-new-tag": "Ajouter un nouveau Tag",
	"add-properties": "Ajouter des propriétés",
	"add-property": "Ajouter une propriété",
	"add-property-bulk": "Ajouter en masse des propriétés {type}",
	"add-property-bulk.instructions.decimals": "Utilisez le point (0.01) comme séparateur pour les nombres décimaux",
	"add-property-bulk.instructions.template": "{template} et complétez le avec les propriétés désirées.",
	"add-property-bulk.instructions.value-list": "Valeur à indiquer",
	"add-property-from-list": "Ajouter une propriété depuis la liste",
	"add-property-to-graph": "Ajouter la propriété à un graphique",
	"add-recipient": "Ajouter un autre destinataire",
	"add-tag": "Ajouter un Tag",
	"add-to-graph": "Ajouter aux graphiques",
	"add-user": "Ajouter un utilisateur",
	"add-user-to-organization": "Ajouter un utilisateur à l'organisation",
	"add-widget": "Ajouter un élément",
	"added": "ajoutée",
	"addons": "Addons",
	"address": "Adresse",
	"address-mbus-range-1-to-250": "Adresse des équipements M-Bus dans une plage de 1 à 250",
	"admin-account-details-for-new-organization": "Détails du compte administrateur pour la nouvelle organisation",
	"advanced": "Avancée",
	"advanced-mode": "Mode avancé",
	"advanced-settings": "Paramètres avancés",
	"aggregation-picker-tooltip-with-interval": "Veuillez désactiver l'application d'un delta pour appliquer une aggrégation",
	"alarm": "Alarme",
	"alarm-SMS-notification-frequency-error-msg": "Doit être au minimum de 24 heures",
	"alarm-boolean-constraint-OFF-tooltip": "L'alarme sera déclenchée lorsque la valeur est False",
	"alarm-boolean-constraint-ON-tooltip": "L'alarme sera déclenchée lorsque la valeur est True",
	"alarm-box_connection_status-OFF": "@.capitalize:box déconnectée",
	"alarm-condition-help-text": "L'alarme se déclenche si...",
	"alarm-deleted": "Alarme supprimée",
	"alarm-equipment-down-scenario": "Aucune donnée reçue",
	"alarm-equipment-status-notification-frequency-error-msg": "Doit être au minimum de 6 heures",
	"alarm-event-updated": "Événement d'alarme mis à jour",
	"alarm-history-status-ACKNOWLEDGED": "Acquittée",
	"alarm-history-status-ARCHIVED": "Archivée",
	"alarm-history-status-CLOSED": "Fermée",
	"alarm-history-status-DISABLED": "Non activée",
	"alarm-history-status-OPEN": "Ouverte",
	"alarm-map-banner-msg": "Une ou plusieurs alarmes ont été déclenchées. Accédez aux \"{clickhere}\" pour les identifier",
	"alarm-maximum-more-than-minimum": "La limite supérieure de cette plage doit être supérieure à la limite inférieure",
	"alarm-minimum-more-than-previous-maximum": "La limite inférieure de cette plage doit être supérieure à la limite supérieure de la plage précédente",
	"alarm-multirange-help-msg": "Si la limite supérieure de la plage précédente est égale à la limite inférieure de la plage suivante alors l'intervalle de la plage suivante est > (strictement supérieur) à la limite inférieure<br />Sinon il est >= (supérieur ou égal) à la limite inférieure<br />La limite supérieure d'une plage est elle toujours <= (inférieur ou égal)",
	"alarm-notification-frequency-help-msg": "La première notification est envoyée dès que l'alarme se déclenche. Une notification peut ensuite être envoyée toutes les {frequency} au maximum",
	"alarm-notification-user-no-phonenumber": "Pour activer la notification par SMS, cet utilisateur doit ajouter son numéro de téléphone à son profil depuis la console.",
	"alarm-occurrence-time-interval": "Intervalle",
	"alarm-occurrence-time-interval-tooltip": "Les occurrences doivent se produire pendant cet intervalle. N'oubliez pas que l'intervalle par défaut entre deux valeurs est de 10 minutes.<br />Le compteur d'occurrences est remis à zéro si les conditions ont été remplies pendant la période de temps. Pour être déclenché à nouveau, les conditions doivent se produire pendant une nouvelle période de temps.",
	"alarm-priority-updated": "Priorité d'alarme mise à jour",
	"alarm-property-measurement-boolean-constraint": "La valeur reçue est <b>True/False ou 1/0</b>",
	"alarm-property-measurement-boolean-constraint-summary": "True / False",
	"alarm-property-measurement-notification-frequency-error-msg": "Doit être au minimum de 10 minutes",
	"alarm-property-measurement-range-constraint-inrange": "La valeur reçue est <b>dans une plage</b>",
	"alarm-property-measurement-range-constraint-inrange-summary": "Dans une plage",
	"alarm-property-measurement-range-constraint-outrange": "La valeur reçue est en <b>dehors d'une plage</b>",
	"alarm-property-measurement-range-constraint-outrange-summary": "En dehors d'une plage",
	"alarm-property-measurement-set-constraint": "La valeur reçue est <b>dans un ensemble de valeurs interdites</b>",
	"alarm-property-measurement-set-constraint-summary": "Ensemble de valeurs interdites",
	"alarm-range-maximum-required": "Veuillez fournir une valeur maximale pour la plage",
	"alarm-range-minimum-required": "Veuillez fournir une valeur minimale pour la plage",
	"alarm-ranges": "Plages",
	"alarm-required-occurrences": "Nombre d'occurrences pour déclencher une alerte",
	"alarm-required-occurrences-tooltip": "Le nombre d'occurrences requis pour que l'alarme soit déclenchée",
	"alarm-set-constraints-values": "Ensemble de valeurs",
	"alarm-set-constraints-values-placeholder": "Ajouter une valeur",
	"alarm-sortby-name": "Nom de l'alarme (A-Z)",
	"alarm-sortby-triggered-at": "Date de la dernière alerte (A-Z)",
	"alarm-type-box_connection_status": "Etat de la connexion de la boîte",
	"alarm-type-equipment-status-condition": "Pour un équipement qui se connecte à la @.lower:box en <strong>LoRaWAN</strong>, la connexion sera considérée comme perdue si aucune valeur n'a été reçue au cours des dernières 12 heures. <br />Pour un équipement qui se connecte à la @.lower:box via un <strong>protocole câblé</strong> (BACnet, ModBus...), la connexion sera considérée comme perdue s'il y a moins de valeurs reçues que prévu dans la dernière heure pour un équipement donné. Le nombre de valeurs attendues étant calculé automatiquement.",
	"alarm-type-equipment_status": "Etat de l'équipement",
	"alarm-type-property_measurement": "Mesure de propriété",
	"alarm-valueset-duplicate-priorities": "Les sévérités des contraintes multiples doivent être différentes",
	"alarm-valueset-duplicate-values": "Certaines valeurs à l'intérieur des ensembles sont dupliquées",
	"alarm-zone": "Zone d'alarme",
	"alarm.add-range": "Ajouter une plage d'alarme",
	"alarm.depend-on-schedule.label": "Dépendance à un planning",
	"alarm.depend-on-schedule.msg": "L'alarme dépend d'un planning",
	"alarm.schedules.and-value-is": "Et que la valeur est :",
	"alarm.schedules.and-value-is-equal-to": "Et que la valeur est égale à :",
	"alarm.schedules.and-value-is-inrange": "Et que la valeur se trouve entre :",
	"alarm.schedules.and-value-is-outrange": "Et que la valeur est en dehors de :",
	"alarm.schedules.if-state-is": "Si le planning indique :",
	"alarm.schedules.then-priority-is": "Alors la sévérité sera :",
	"alarm.slider-visualization-if-state": "Visualisation des plages si \"{state}\"",
	"alarms": "Alarmes",
	"alarms-route": "Route alarms",
	"alarms-url": "URL des alarmes",
	"alarms.automation.close": "Fermer automatiquement l’alarme",
	"alarms.automation.close-auto": "<strong>Fermer automatiquement l’alerte</strong> lorsque les conditions de déclenchement ne sont plus réunies",
	"alarms.automation.close-auto.comment": "L'alarme est revenue à la normale. Par conséquent, les dernières alertes déclenchées par l'alarme ont été automatiquement fermées.",
	"alarms.go-to-create-schedule": "Créer votre premier planning",
	"alarms.go-to-push-config": "Envoyez la configuration à votre @.lower:box pour pouvoir sélectionner un planning ici",
	"alarms.go-to-schedules": "Accéder aux plannings",
	"alarms.history.behaviour.boolean.desc": "si la valeur est égale à <b>{value}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.boolean.desc.minimal": "égale à {value}",
	"alarms.history.behaviour.inrange.desc": "si la valeur est <b>>{min} et <{max}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.inrange.desc.minimal": ">{min} et <{max}",
	"alarms.history.behaviour.outrange.desc": "si la valeur est <b><{min} ou >{max}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.outrange.desc.minimal": "<{min} ou >{max}",
	"alarms.history.behaviour.schedule-boolean.desc": "si le planning indique <b>{state}</b> et valeur est égale à <b>{value}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.schedule-inrange.desc": "si le planning indique <b>{state}</b> et valeur <b>>{min} et <{max}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.schedule-outrange.desc": "si le planning indique <b>{state}</b> et valeur <b><{min} ou >{max}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.schedule-set.desc": "si le planning indique <b>{state}</b> et valeur dans l'ensemble <b>{set}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.set.desc": "si la valeur est dans l'ensemble <b>{set}</b> alors sévérité <b>{severity}</b>",
	"alarms.history.behaviour.set.desc.minimal": "dans l'ensemble {set}",
	"alarms.history.tooltip.boolean.desc": "valeur égale à {value}",
	"alarms.history.tooltip.inrange.desc": "valeur >{min} et <{max}",
	"alarms.history.tooltip.outrange.desc": "valeur <{min} ou >{max}",
	"alarms.history.tooltip.set.desc": "valeur dans l'ensemble {set}",
	"alert-raw-bytes-not-supported-bacnet-gateway": "Toutes les propriétés dont le format de données {raw_bytes} sont masquées car elles ne sont toujours pas prises en charge sur Passarelle BACnet.",
	"alerts-history": "Historique des alertes",
	"all": "Tous",
	"all-configured": "Tout est configuré!",
	"all-day": "Toute la journée",
	"all-equipment": "Tous les équipements",
	"all-properties": "Toutes les properties",
	"all-year": "Toute l'année",
	"amplitude": "Amplitude (Max - Min)",
	"an-optional-password-in-the-authentication": "Un mot de passe optionnel dans l'authentification",
	"and": "et",
	"any": "Tout",
	"api-device-id": "API Device Id",
	"api-documentation": "Documentation de l'API",
	"api-error.equipment.4": "Certaines propriétés sont déjà présentes pour cet équipement. Veuillez supprimer les propriétés dans la configuration avant de modifier la valeur du champ \"{codecFieldName}\".",
	"api-error.scheduler.9": "La propriété {propertyName} est déjà pilotée par le planning {previousScheduleName} sur la période d'application {previousStart} - {previousEnd}. Pour qu'une propriété soit pilotée par différents plannings, les périodes d'application ne doivent pas se chevaucher. | Les propriétés {propertyNames} sont pilotées par le planning {previousScheduleName} sur la période d'application {previousStart} - {previousEnd}. Pour qu'une propriété soit pilotée par différents plannings, les périodes d'application ne doivent pas se chevaucher.",
	"api-error.scheduler.9-current-schedule": "La propriété {propertyName} est utilisé plusieurs fois sur la même période d'application. Pour qu'une propriété puisse recevoir différentes consignes, les périodes d'applications ne doivent pas se chevaucher. Merci de modifier les périodes d'applications ou de supprimer la propriété en doublon.",
	"api-error.user[3]": "Le mot de passe choisi est dans une liste de mots de passe génériques utilisés dans des cyberattaques. Veuillez choisir un mot de passe plus spécifique.",
	"api-keys": "Clés API",
	"app-eui": "App EUI",
	"app-version": "Version de l'application",
	"apparently-havent-configured-box-go-to-configuration": "Apparemment vous n'avez pas encore configuré votre @.lower:box . Allez dans Configuration pour le faire!",
	"appeui": "AppEUI",
	"appkey": "AppKey",
	"application-extended-universal-identifier": "Application Extended Universal Identifier",
	"application-extended-universal-identifier-provided-by-manufactor": "Identifiant d'application fourni par le fabricant",
	"application-key": "Application Key",
	"apply": "Appliquer",
	"apply-all": "Appliquer à tous",
	"apply-all.bacnet-properties": "Appliquer le Type d'objet à toutes les propriétés sélectionnées ({n})",
	"apply-all.modbus-properties": "Appliquer les Type de registre, Format de données et Raw registres à toutes les propriétés sélectionnées ({n})",
	"apply-changes": "Appliquer les modifications",
	"apply-severity-to-alarm": "Appliquer la nouvelle sévérité à l'alarme",
	"apply-status-to-alarm": "Appliquer le nouveau statut à l'alarme",
	"applying-configuration-to-the-box": "Application de la configuration à la @.lower:box",
	"archive-applied-operation-on-data": "Opération appliquée sur les données",
	"archive-apply-operation-on-data": "Transformer les données",
	"archive-downloaded": "Archive téléchargée",
	"archive-file-format": "Format du fichier archive",
	"archive-no-transformation": "Pas de transformation",
	"archive-request": "Demande d'archive de données",
	"archive-status-ENDED": "Terminé",
	"archive-status-FAILED": "Échoué",
	"archive-status-NEW": "Nouveau",
	"archive-status-STARTED": "Démarré",
	"archive-transformation-diff-month": "Différence mensuelle (dernière valeur du mois - dernière valeur du mois précédent)",
	"archive-transformation-diff-week": "Différence hebdomadaire (dernière valeur de la semaine - dernière valeur de la semaine précédente)",
	"archive.alert.delete.body": "L’archive récurrente {name} sera supprimée et ne sera plus générée.",
	"archive.alert.delete.success": "L’archive récurrente a été supprimée avec succès",
	"archive.alert.delete.title": "Supprimer l’archive récurrente",
	"archive.recurring.name": "Archive récurrente | Archives récurrentes",
	"archive.request.actions.duplicate-it": "Dupliquer la demande d’archive",
	"archive.request.actions.see-it": "Voir la demande d’archive",
	"archive.request.actions.update-it": "Modifier la demande d’archive",
	"archive.request.day-of-week": "Jour de la semaine",
	"archive.request.end.date.error": "La date de fin doit être postérieure à la date de la prochaine exécution",
	"archive.request.frequency": "Fréquence",
	"archive.request.frequency.daily": "Quotidienne",
	"archive.request.frequency.monthly": "Mensuelle",
	"archive.request.frequency.monthly.help": "Les données seront envoyées le 1er de chaque mois suivant",
	"archive.request.frequency.weekly": "Hebdomadaire",
	"archive.request.frequency.weekly.help": "Exemple : En sélectionnant le lundi, les données seront exportées pour la période allant du lundi de la semaine précédente jusqu’au dimanche.",
	"archive.request.not-available": "L'archive récurrente n'est plus disponible",
	"archive.request.type": "Type de demande",
	"archive.request.type.recurring": "Récurrente",
	"archive.request.type.single": "Unique",
	"archives": "Archives",
	"are-you-creating-organization-internal-siemens-or-end-user": "L'organisation est pour",
	"area": "Aires",
	"array-length-error": "Le tableau doit avoir exactement {length} éléments",
	"as-soon-as-it-occurs": "Dès que cela se produit",
	"assistance": {
		"access": "Accès assistance",
		"authorize-access": {
			"desc": "Permettre à notre équipe d'assistance d'accéder à votre compte et à vos box pour vous accompagner dans la configuration et résoudre les problèmes techniques.",
			"title": "Autoriser l'accès à l'assistance technique"
		},
		"delegated-connections": {
			"title": "Connexions déléguées"
		},
		"end-of-access": "Fin d'accés le",
		"remaining-time": "Temps restant: {endDate}",
		"revoke-access": "Révoquer l'accès",
		"status": {
			"active": "Actif",
			"inactive": "Inactif"
		},
		"title": "Assistance",
		"unlimitted-access": {
			"msg": "Accès illimité (jusqu'à révocation manuelle)",
			"unlimited": "illimité"
		}
	},
	"at-least-one-property-is-redirect-confirm-rename": "Au moins une propriété de cet équipement est redirigée vers une passerelle BACnet IP ou MQTT. Ces passerelles peuvent s'appuyer sur le nom de l'équipement pour nommer les propriétés redirigées. Souhaitez-vous appliquer la modification aux passerelles ?",
	"attention": "Attention",
	"auth0.security.button.disabled": "Désactiver",
	"auth0.security.button.enabled": "Activer les deux étapes",
	"auth0.security.delete.description": "Après avoir désactivé l'authentification en deux étapes, vous pourrez vous connecter avec votre email et mot de passe.",
	"auth0.security.delete.title": "Désactiver l'authentification en deux étapes",
	"auth0.security.description": "Après avoir entré votre mot de passe, confirmez votre identité avec une seconde méthode d’authentification.",
	"auth0.security.disabled": "L’activation à deux étapes est désactivée",
	"auth0.security.enabled": "L’activation à deux étapes est activée",
	"auth0.security.is-app": "Les codes d'authentification sont disponibles sur l'application d'authentification installée sur votre téléphone.",
	"auth0.security.is-disabled": "L’authentification en deux étapes est désactivée pour votre compte.",
	"auth0.security.is-sms": "Les codes d'authentification sont envoyés par SMS sur votre téléphone.",
	"auth0.security.title": "Authentification en deux étapes",
	"authentication": "Authentification",
	"author": "Auteur",
	"authorization-url": "URL d'autorisation",
	"auto-update-disabled-description": "Votre box ne recevra plus les mises à jour de sécurité automatiques. Vérifiez régulièrement les mises à jour disponibles pour maintenir la sécurité de votre installation.",
	"auto-update-disabled-title": "Désactivation des mises à jour automatiques",
	"auto-update-firmware-description": "Les mises à jour sont appliquées automatiquement",
	"auto-update-firmware-title": "Mises à jour automatiques du firmware",
	"auto-update-help": "contactez l'assistance technique pour l'installer.",
	"auto-update-history": "Consultez l'historique des versions pour vérifier l'état actuel. Si une mise à jour est disponible,",
	"auto-update-toast-message": "Mises à jour automatiques activées",
	"autodiscovery.scan-didnt-find-results-after-x-minutes-review-config": "Le scan est lancé depuis {minutes} minutes et aucun appareil n'a été détecté sur le réseau {protocol}. <br> Souhaitez-vous revoir la configuration puis lancer un nouveau scan ?",
	"autodiscovery.see-the-former-scan-and-let-running-in-background": "Voir les résultats du précédent scan et continuer le scan en tâche de fond",
	"autodiscovery.stop-scan-and-go-to-network-configuration": "Arrêter le scan et vérifier la configuration du réseau",
	"automation": "Programmation",
	"automation-rtn-setpoint-help-message-with-schedule": {
		"li1": "Planning : les valeurs du créneau actif au moment du retour à la normale seront renvoyées.Vérifiez que les propriétés ont des consignes pour chaque créneau.{cta}",
		"li2": "Valeur personnalisée : n'indiquez pas l'unité et utilisez le {dot} pour les nombres décimaux.",
		"title": "Appliquez les valeurs du planning {scheduleName} ou indiquez une valeur personnalisée."
	},
	"automation.action.alarm.level": "Niveau des alertes : {level}",
	"automation.action.helper-text-setpoint-input": "Pour écrire une valeur différente par propriété, créer plusieurs actions.",
	"automation.action.property-not-selectable-controlled-by-schedule": "Cette propriété ne peut pas être sélectionnée car elle est déjà contrôlée par un planning qui n'a pas été inclus dans les conditions.",
	"automation.action.schedule-title-description": "Le scénario prendra la main jusqu’au début du prochain créneau prévu par le planning.",
	"automation.action.schedule.to-state-x": "À {name}",
	"automation.action.setpoint.set-value-to-property": "{value} à :",
	"automation.action.type-of-action": "Que souhaitez-vous faire ?",
	"automation.action.type.alarm": "Déclencher une alarme",
	"automation.action.type.no-schedule.tooltip": "Un planning doit être utilisé dans les conditions pour être utilisé dans une action",
	"automation.action.type.schedule": "Modifier le planning",
	"automation.action.type.schedule.desc": "Appliquer un créneau différent",
	"automation.action.type.send": "Envoyer",
	"automation.action.type.send-value": "Modifier la valeur d'une propriété",
	"automation.action.type.send-value.desc": "Modifier la valeur d'une propriété",
	"automation.add-return-to-normal": "Ajouter un retour à la normale",
	"automation.back-to-original-schedule-slot": "Remettre le créneau initial du planning : {slot}",
	"automation.change-schedule": "Modifier le planning",
	"automation.cod.as-soon-as-it-occurs": "Ne pas attendre, continuer dès que la condition est vérifiée",
	"automation.cod.occurrence.x-during-time": "{occurence} fois pendant {time}",
	"automation.cod.occurrence.x-during-unlimited": "{occurence} fois",
	"automation.condition.cod.x-during-time": "{occurence} fois pendant {time}",
	"automation.condition.cod.x-during-unlimited": "{occurence} fois dès que cela se produit",
	"automation.condition.operator-AND": "Toutes les conditions ci-dessous sont réunies (ET)",
	"automation.condition.operator-OR": "Au moins une condition est remplie (OU)",
	"automation.condition.property.the-value-of-x-prop": "La valeur de {name}",
	"automation.condition.schedule.has-not-state-x": "Indique que le type de créneau n'est pas {name}",
	"automation.condition.schedule.has-state-x": "Indique que le type de créneau est {name}",
	"automation.condition.schedule.the-schedule-x": "Le planning {name}",
	"automation.condition.type-of-condition": "Qu'est-ce qui déclenchera le scénario et quelles sont les conditions à remplir pour l'exécuter ?",
	"automation.condition.type.property": "Propriété",
	"automation.condition.type.property.desc": "La valeur d'une propriété",
	"automation.condition.type.schedule": "Planning",
	"automation.condition.type.schedule.desc": "Le créneau appliqué par un planning",
	"automation.condition.type.schedule.disabled-tooltip": "Pour le moment, il n'est pas possible de sélectionner un planning comme condition.",
	"automation.condition.type.select-a-schedule": "Sélectionner un planning",
	"automation.condition.type.select-schedule": "Sélectionner un planning",
	"automation.condition.value.type.formula": "Calcul",
	"automation.condition.value.type.value": "Valeur",
	"automation.condition.value.type.value.help-message": "Indiquer un texte ou un chiffre. Ne renseignez pas l'unité. Utiliser {point} avec les nombres décimaux.",
	"automation.create-scenario": "Créer un scénario",
	"automation.define-return-to-normal.title": "Retour à la normale",
	"automation.empty-state.desc": "Piloter vos équipements en fonction ....",
	"automation.empty-state.title": "Piloter vos équipements",
	"automation.history.conditions-fulfilled": "Les conditions sont validées. Les actions ont été exécutées",
	"automation.history.conditions-fulfilled-rtn": "Les conditions de retour à la normale sont validées. Les actions de retour à la normale ont été exécutées",
	"automation.history.conditions-fulfilled-rtn-simulation": "Les conditions de retour à la normale sont validées. Les actions de retour à la normale seront exécutées",
	"automation.history.conditions-fulfilled-simulation": "Les conditions sont validées. Les actions seront excécutées",
	"automation.history.conditions-not-fulfilled": "Les conditions ne sont pas validées. Les actions n'ont pas été exécutées.",
	"automation.history.conditions-not-fulfilled-rtn": "Les conditions de retour à la normale ne sont pas validées. Les actions correspondantes n'ont pas été exécutées.",
	"automation.history.conditions-not-fulfilled-rtn-simulation": "Les conditions de retour à la normale ne sont pas validées. Les actions correspondantes ne seront pas exécutées",
	"automation.history.conditions-not-fulfilled-simulation": "Les conditions ne sont pas validées. Les actions ne seront pas exécutées",
	"automation.history.evaliation-of-conditions": "Evaluation des conditions",
	"automation.history.evaluated-at": "Evaluation le {date}",
	"automation.history.event": "Evénement",
	"automation.history.false": "Faux",
	"automation.history.history": "Historique",
	"automation.history.initial": "Scénario",
	"automation.history.it-received-a-value": "{type} {type-name} a reçu une valeur.",
	"automation.history.modify-conditions": "Modifier les conditions",
	"automation.history.not-executed": "Stoppé",
	"automation.history.occurences-counter": "Compteur d'occurrences",
	"automation.history.return-to-normal": "Retour à la normale",
	"automation.history.scenario-status": "Résultat de l'évaluation",
	"automation.history.table-conditions.property": "Propriété",
	"automation.history.table-conditions.schedule": "Planning",
	"automation.history.table-history.expected": "Attendues",
	"automation.history.table-history.read": "Lues",
	"automation.history.table-not": "n'est pas",
	"automation.history.table.operators": "Opérateurs",
	"automation.history.the-property": "La propriété",
	"automation.history.the-schedule": "Le planning",
	"automation.history.true": "Vrai",
	"automation.history.view-scenario": "Voir le scénario",
	"automation.incomplete-scenario": "Scénario non valide",
	"automation.incomplete-scenario.define-cod": "Définir une temporalité",
	"automation.incomplete-scenario.error-lorawan-flooding": "Au moins une propriété sélectionnée utilise le protocole LoRaWAN. La définition actuelle du scénario scénario peut engendrer de multiples écritures sur cette propriété sans que ces-dernières soient envoyées. Si vous souhaitez conserver le scénario, veuillez ajouter une temporisation d’au moins 30 minutes.",
	"automation.incomplete-scenario.min-1-action": "Ajouter une action",
	"automation.incomplete-scenario.min-1-condition": "ajouter au moins une condition",
	"automation.incomplete-scenario.steps-to-make-complete": "Pour sauvegarder le scénario, veuillez ",
	"automation.no-rtn-with-schedule.msg": "Sans définir de retour à la normale la consigne perdurera jusqu'au début du nouveau créneau. Le début du nouveau créneau écrira la consigne indiquée dans le planning.",
	"automation.no-rtn.msg": "Si aucun retour à la normale n'est spécifié, lorsque les conditions ne sont plus remplies, la dernière action s'applique jusqu'à nouvel ordre.",
	"automation.no-rtn.msg-alarms": "Si les conditions ne sont plus observées, l'alarme restera ouverte. Ajouter un retour à la normale pour fermer automatiquement l'alarme.",
	"automation.no-unit.rtn.help-message": "Renseignez une valeur pour chaque propriété. N'indiquez pas l'unité et utilisez le {dot} pour les nombres décimaux.",
	"automation.required-occurrences": "Attendre que la condition se répète",
	"automation.return-to-current-schedule-state": "Revenir au créneau programmé du planning",
	"automation.rtn-apply-custom-value": "Valeur personnalisée",
	"automation.rtn-apply-schedule-value": "Appliquer les valeurs du planning",
	"automation.rtn-property-scheduleStateId.msg": "Planning {name} à {scheduleState}",
	"automation.rtn-property-setpoint.msg": "Envoyer {setpoint} à {name}",
	"automation.rtn-release-to-schedule.msg": "Renvoyer {setpoint} {name}",
	"automation.rtn-release-to-schedule.schedule-value": "la valeur définie par le planning",
	"automation.rtn-title": "Si les conditions ne sont plus réunies",
	"automation.rtn.disabled-select-message-during": "Cette valeur ne peut pas être modifiée. Elle reprend par défaut la valeur de la temporisation.",
	"automation.rtn.disabled-select-message-if": "Cette valeur ne peut pas être modifiée. Elle reprend par défaut la valeur de la condition.",
	"automation.scenario.empty-state.btn-chose-condition-to-start": "Choisissez une condition pour débuter",
	"automation.scenario.empty-state.desc": "Ajustez automatiquement les valeurs ou les plannings en fonction de ce qui se passe dans le bâtiment. Ajouter une condition pour démarrer",
	"automation.scenario.empty-state.title": "Bienvenue dans l'éditeur de scénarios",
	"automation.schedule-action.return-to-normal.help-msg": "Sans revenir à la normale, il faudra attendre le début du prochain créneau pour que le planning reprenne la main.",
	"automation.schedule-action.return-to-normal.label": "Si les conditions ne sont plus réunies",
	"automation.schedule-action.return-to-normal.msg": "Revenir au créneau initial (retour à la normale)",
	"automation.schedule-cod.as-soon-as-it-occurs.msg": "Ne pas attendre, continuer dès que la condition se produit",
	"automation.set-name-scenario": "Donner un nom au scénario",
	"automation.setpoint-action.return-to-normal.help-msg": "Sans revenir à la normale, si le scénario s'est éxécuté au moins une fois mais que les conditons ne sont ensuite plus réunies :<br />* Si la propriété ne dépend pas d'un planning, la consigne perdurera<br />* Si la propriété dépend d'un planning, le début d'un nouveau créneau écrira une nouvelle consigne<br />En revenant à la normale, la consigne reprendra sa valeur d'origine :<br />* Si la propriété ne dépend pas d'un planning, vous définissez cette valeur d'origine<br />* Si la propriété dépend d'un planning, la valeur d'origne sera celle paramétrée dans le planning (évite d'attendre le prochain créneau)",
	"automation.setpoint-action.return-to-normal.label": "Si les conditions ne sont plus réunies",
	"automation.setpoint-action.return-to-normal.msg": "Revenir à la normale",
	"automation.simulation.chose-period-simulate-scenario": "Choisissez une période pour simuler l'évaluation du scénario.",
	"automation.simulation.test-automation": "Tester le scénario",
	"automation.slot-types": "Liste des créneaux",
	"automation.tab-title": "Programmation",
	"automation.test": "Tester",
	"automation.test-btn": "Tester",
	"automation.value": "Valeur",
	"automations": "Scénarios",
	"automations.add-automation": "Ajouter un scénario",
	"automations.edit-automation": "Modifier le scénario",
	"automations.failed-deleting-scenario": "Échec de suppression du scénario",
	"automations.history.view-history": "Voir l'historique",
	"available-until": "Disponible jusqu'au",
	"average": "Moyenne",
	"awaiting-next-reading": "En attente de la prochaine lecture",
	"axis-left": "Gauche",
	"axis-right": "Droite",
	"back": "Retour",
	"bacnet-devices-not-complete": "Certains appareils BACnet ne sont pas encore terminés.",
	"bacnet-extra-days-help-msg": "32 pour le Dernier jour du mois <br />33 pour le jour impair du mois <br />34 pour le jour pair du mois",
	"bacnet-flag-FAULT": "Faute",
	"bacnet-flag-IN_ALARM": "En alarme",
	"bacnet-flag-OK": "Tout est bien",
	"bacnet-flag-OUT_OF_SERVICE": "Hors service",
	"bacnet-flag-OVERRIDEN": "Remplacé",
	"bacnet-import.instructions.1": "Consignes pour ajouter des équipements en masse",
	"bacnet-import.instructions.2": "Le fichier d’import doit respecter le format EDE (version 2.3).",
	"bacnet-import.instructions.3": "Téléchargez un exemple.",
	"bacnet-import.instructions.4": "Seuls les colonnes suivantes sont importées : device-object-instance, object-name, object-type, object-instance, description, present value, unit-code.",
	"bacnet-import.instructions.5": "Chaque propriété BACnet est un objet dont la present value représente la valeur en temps réel. Dans la configuration de la box, la notion d’objet disparait. La propriété conserve un nom ({object-name}), une description ({description}), une unité ({unit-code}) et une valeur ({present-value}). Elle a une adresse sur le réseau ({object-instance}), un type ({object-type}) et est rattachée à un équipement ({device-object-instance}).",
	"bacnet-import.instructions.title": "Import des propriétés BACnet dans la box",
	"bacnet-import.no-data": "Erreur de format de fichier, tableau des propriétés introuvable",
	"bacnet-import.title": "Ajout en masse d’équipements BACnet",
	"bacnet-import.toast.end": "Importation du fichier terminé",
	"bacnet-ip-gateway-property": "Propriété de la passerelle BACnet IP",
	"bacnet-network-number": "Le numéro de réseau BACnet",
	"bacnet-object-name": "Nom d'objet BACnet",
	"bacnet-property": "Propriété BACnet",
	"bacnet-redirect.modal.allow-wattsense": "J’autorise Wattsense à modifier la configuration de ma box",
	"bacnet-redirect.modal.confirm": "Notre équipe vous contactera par email dans les 48h ouvrées pour vous informer de l'état de votre demande.",
	"bacnet-redirect.modal.description": "Le planning du régulateur sera redirigé dans un objet BACnet Schedule (pour le moment, uniquement compatible avec les programmes horaires des régulateurs Synco de Siemens).",
	"bacnet-redirect.modal.equipment": "Equipement et circuit",
	"bacnet-redirect.modal.gtb": "Marque de la GTB {optional}",
	"bacnet-redirect.modal.instance": "Instance de l’objet Schedule {optional}",
	"bacnet-redirect.modal.note": "Note : Vous pouvez gérer les autorisations d'accès de l'assistance technique à votre box dans votre profil.",
	"bacnet-redirect.modal.placeholder": "ex. RMH760B - CIRCUIT DE CHAUFFAGE 1 - Radiateurs école",
	"bacnet-redirect.modal.title": "Rediriger un planning depuis un régulateur",
	"bacnet-schedule.data-type.help-msg": "Si les propriétés ciblées par le planning sont binaires, vous devez sélectionner le type de donnée ENUMERATED",
	"bacnet.max-value": "Valeur maximale",
	"bacnet.max-value.help": "Valeur maximale attendue",
	"bacnet.min-value": "Valeur minimale",
	"bacnet.min-value.help": "Valeur minimale attendue",
	"bacnet.object-instance": "BACnet Object instance",
	"bacnet.object-instance.help": "The BACnet object instance id [0 .. 4194303]",
	"bacnet.object-type": "BACnet Object Type",
	"bacnet.polarity": "Polarité",
	"bacnet.resolution": "Résolution",
	"bacnet.resolution.help": "Taille de la résolution entre les changements de valeur",
	"bacnet.rules.uniq": "Il ne peut y avoir qu'une seule interface BACnet à la fois sur la box (réseau BACnet ou passerelle BACnet).",
	"bacnet.update-interval": "Intervalle de mise à jour",
	"bacnetscan.properties": "Properties :",
	"banner.alarm.linked-schedule.unused-state": "Le type de créneau \"{state}\" n'est plus utilisé par le planning \"{schedule}\". Veuillez éditer l'alarme pour modifier le type de créneau.",
	"banner.autodiscovery-wait-for-scan": "Veuillez patienter pendant que le scan est en cours.",
	"banner.bulk-import-properties.title": "Consignes pour ajouter des propriétés en masse",
	"banner.bulk-import.title": "Consignes pour ajouter des équipements en masse",
	"banner.cache-refresher.body": "Une nouvelle version est disponible. Elle sera lancée au prochain écran.",
	"banner.cache-refresher.click-to-refresh": "Cliquez ici pour l'utiliser immédiatement.",
	"banner.duplicate-equipment-no-network.body": "Aucun réseau {protocol} n'est configuré dans la box “{boxName}”. Veuillez d'abord créer ce réseau avant de dupliquer l'équipement.",
	"banner.duplicate-equipment-no-network.footer": "Configurer le réseau",
	"banner.duplicate-equipment-no-network.restart-network-detection": "Actualiser la liste des réseaux",
	"banner.duplicate-equipment-no-network.title": "Réseau non configuré",
	"banner.equipment-bulk-creation-advanced-config": "Les équipements ci-dessous nécessitent une configuration avancée :",
	"banner.hub-live-data-activate.body": "Pour visualiser les valeurs, activez leur réception en cliquant sur le bouton à droite du nom de votre @.capitalize:{'client-name-hub'}. Une fois activée, et après la prochaine lecture, les valeurs seront visibles pendant 60 minutes. En local, les valeurs sont toujours collectées et redirigées s'il y a lieu.",
	"banner.hub-live-data-activate.title": "Activez la réception des valeurs",
	"banner.satellite-licence": "Vous avez sélectionné une licence de type Satellite. Celle-ci pourra être activée uniquement si elle est utilisée en relation avec une autre box sur le même site avec une licence M ou L.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.1": "La mise à l'échelle est maintenant appliquée dans les valeurs redirigées vers les passerelles. Cette information a été apportée à votre configuration. Pour activer la fonctionnalité, envoyez la configuration à votre box.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.2": "Au préalable, et pour éviter une éventuelle double application de la mise à l'échelle, retirez la dans l'équipement ou le logiciel qui reçoit les valeurs redirigées",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.3": "Vous pouvez {downloadBtn} pour vérifier les changements qui seront appliqués.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.4": "Si vous ne souhaitez pas activer cette fonctionnalité, retirez la mise à l'échelle des propriétés.",
	"banner.scaling-to-gateway.bacnet-mqtt.download-properties-btn": "télécharger la liste des propriétés mises à l'échelle",
	"banner.scaling-to-gateway.bacnet-mqtt.send-configuration-btn": "Mettre à jour la configuration",
	"banner.scaling-to-gateway.body": "La mise à l'échelle est maintenant appliquée dans les valeurs redirigées vers les passerelles. Pour activer cette fonctionnalité, accédez aux box suivantes pour les mettre à jour : {devices}.",
	"banner.scaling-to-gateway.modbus.body.pending.1": "La mise à l'échelle est maintenant appliquée dans les valeurs redirigées vers les passerelles.",
	"banner.scaling-to-gateway.modbus.body.pending.2": "Pour activer cette fonctionnalité, déclenchez le processus de mise à jour. Cela aura pour effet de mettre à jour la configuration et de modifier les paramètres des propriétés redirigées dans votre passerelle Modbus. Vous pourrez vérifier les changements proposés et les éditer. Si besoin, {downloadBtn}.",
	"banner.scaling-to-gateway.modbus.body.pending.3": "Pour activer la redirection des valeurs mises à l'échelle, envoyez la nouvelle configuration avec les changements à votre box.",
	"banner.scaling-to-gateway.modbus.body.pending.4": "Au préalable, et pour éviter une éventuelle double application de la mise à l'échelle, retirez-la dans l'équipement Modbus qui reçoit les valeurs redirigées.",
	"banner.scaling-to-gateway.modbus.body.pending.5": "Si vous ne souhaitez pas appliquer la mise à l'échelle, retirez la des propriétés redirigées.",
	"banner.scaling-to-gateway.modbus.body.queued.1": "Vérifiez les changements apportés à votre configuration ({downloadBtn}). S'il y a des changements dans la table de communication, reportez-les dans l'équipement Modbus qui reçoit les valeurs redirigées.",
	"banner.scaling-to-gateway.modbus.body.queued.2": "Pour activer la redirection des valeurs mises à l'échelle, envoyez la nouvelle configuration avec les changements à votre box.",
	"banner.scaling-to-gateway.modbus.download-properties-btn": "téléchargez la liste des propriétés avec une mise à l'échelle",
	"banner.scaling-to-gateway.modbus.queued-download-properties-btn": "téléchargeable ici",
	"banner.scaling-to-gateway.modbus.revert-migration-btn": "Annuler la migration",
	"banner.scaling-to-gateway.modbus.send-configuration-btn": "Envoyez la nouvelle configuration",
	"banner.scaling-to-gateway.modbus.start-migration-btn": "Déclenchez le processus de mise à jour",
	"banner.scaling-to-gateway.title.pending": "Action requise",
	"banner.scaling-to-gateway.title.queued": "La configuration a été mise à jour",
	"banner.schedules.box-timezone-different-than-browser.body": "Selon les informations fournies par votre navigateur, vous vous trouvez sur le fuseau horaire “{browserTimezone}” différent de celui de votre box.{br}S'il s'agit d'une erreur de paramétrage, modifiez le fuseau horaire de la box ci-dessous.{br}Le planning s'exécutera dans l'heure locale de la box.",
	"banner.schedules.box-timezone-different-than-browser.title": "Votre fuseau horaire est différent de celui de la box.",
	"banner.schedules.lorawan-class-a.part1": "L'équipement {equipments} communique en LoRaWAN et de classe A. | Les équipements {equipments} communiquent en LoRaWAN et de classe A.",
	"banner.schedules.lorawan-class-a.part2": "Les valeurs seront envoyées aux équipements lors de l'émission de leur prochain uplink. L'écriture de la valeur interviendra après l'heure de début du créneau, en fonction des périodes d'émissions de l'équipement. | Les valeurs seront envoyées aux équipements lors de l'émission de leur prochain uplink. L'écriture de la valeur interviendra après l'heure de début du créneau, en fonction des périodes d'émissions des équipements.",
	"banner.schedules.lorawan-class-a.part3": "Chaque équipement ne peut avoir qu'une seule valeur en attente à la fois : si plusieurs valeurs sont envoyées, seule la dernière sera transmise.",
	"banner.schedules.lorawan-class-a.part4": "Assurez-vous de que la durée des créneaux soit supérieure à la période de transmission des équipements.",
	"banner.schedules.lorawan-class-a.title": "Équipements LoRaWAN Classe A",
	"banner.schedules.select-exceptions.body": "La liste des exceptions est commune à tous les plannings de votre box.",
	"banner.schedules.selected-exceptions.body": "Lorsque des périodes exceptions se chevauchent, la priorité est accordée à celle qui est ordonnancée en premier. Utilisez les boutons à droite de chaque ligne pour ordonner les exceptions.",
	"banner.schedules.selected-exceptions.title": "Priorité des exceptions",
	"banner.schedules.set-property-value": "Cette propriété est contrôlée par le planning {schedules}. Si vous éditez sa valeur ici, la modification sera prise en compte jusqu'à ce que le planning écrive une nouvelle valeur. | Cette propriété est contrôlée par les plannings : {schedules}. Si vous éditez sa valeur ici, la modification sera prise en compte jusqu'à ce qu'un planning écrive une nouvelle valeur.",
	"banner.schedules.try-control-siemens.body": "Lancement de la gamme Control. Découvrez de nouvelles fonctionnalités pensées pour piloter les bâtiments. Plus d'informations sur notre {blogLink}.",
	"banner.schedules.try-control.body": "Lancement de notre gamme Control. Découvrez nos nouvelles fonctionnalités pensées pour piloter vos bâtiments. Essayez dès maintenant nos programmes horaires en activant votre essai gratuit depuis {goToLink}. Découvrez la présentation de la nouvelle offre sur notre {blogLink}.",
	"banner.unpaired-devices.body": "Vous avez une licence en attente d'être rattachée à une box. Si vous avez reçu votre box, accédez à {goToLink} pour l'appairer.",
	"bars": "Bâtons",
	"base-url": "Base URL",
	"baudrate": "Baudrate",
	"bbmd-details": "Détails BBMD",
	"bbmd-ip-address": "Adresse IP BBMD",
	"bbmd-scenario-bbmd-config": "BACNet Broadcast Management Device",
	"bbmd-scenario-disabled": "Non activé",
	"bbmd-scenario-foreign-device": "Foreign Device Registration",
	"bbmd-section-name": "BBMD, FD",
	"bbmd-table-box-ip-msg": "La première ligne ci-dessous reprend l'adresse IP de votre appareil en se basant sur le connecteur sélectionné. Cette information est requise pour le BBMD",
	"bbmd-table-help-msg": "Pour que le BBMD fonctionne, assurez-vous que la table est la même dans tous les appareils BBMD",
	"bbmd-table-no-box-ip-msg": "L'adresse IP de l'appareil n'est pas disponible sur la base du connecteur sélectionné. Veuillez l'ajouter manuellement",
	"bbmd-time-to-live": "Durée de vie",
	"bbmd-time-to-live-tooltip": "Durée, en secondes, avant que l'appareil n'envoie un message hello à l'hôte BACnet",
	"below-line-graph-with-latests-values-from-property": "Ci-dessous un graphique avec les dernières valeurs collectées à partir de {property}",
	"between-an-address-range": "Entre une plage d'adresses",
	"billing-contact": "Contact de facturation",
	"bit-offset-and-scaling-conflict": "La lecture d'un bit ne peut pas être utilisée avec la mise à l'échelle. Veuillez désactiver la mise à l'échelle.",
	"bit-offset-and-write-conflict": "La lecture d'un bit ne supporte pas l'écriture. Veuillez modifier le type d'accès.",
	"bits-per-second": "bits par secondes",
	"block-type": "Type de graphique",
	"blog": "blog",
	"box": "@.clientname:_generic",
	"box-activated": "@.capitalize:box activée",
	"box-connect": "@.capitalize:box connectée",
	"box-didnt-receive-configuration": "@.capitalize:box n'a pas reçu la nouvelle configuration.",
	"box-disconnect": "@.capitalize:box déconnectée",
	"box-info.end-date": "Date de fin",
	"box-info.hub-end-date": "Fin carte SIM",
	"box-local-time": "@.capitalize:box heure locale",
	"box-name-in-network": "Nom de la @.lower:box dans le réseau",
	"box-not-connected-to-console": "@.capitalize:box non connectée à la console",
	"box-or-hub": "@.capitalize:client-name-box ou @.capitalize:client-name-hub",
	"box-status.never-connected": "Jamais connecté",
	"box-status.never-connected-to-the-platform": "Jamais connecté à la plateforme",
	"box-status.offline": "Non connecté",
	"box-status.offline-connected-once": "Non connecté (connecté au moins une fois)",
	"box-status.online": "Connecté",
	"box-status.online-but-data-inactive": "@.capitalize:box connectée à la console",
	"box-status.online-but-data-inactive-activate-communication": "Activer la communication pour réceptionner les valeurs des propriétés",
	"box-status.under-maintenance": "En maintenance",
	"box-timezone": "Fuseau horaire de la @.lower:box",
	"box.views.command.error_not_received-status": "La commande n'a pas été reçue par la @.lower:box",
	"box.views.logs.error_not_received-status": "La commande n'a pas été reçue par la @.lower:box même après plusieurs tentatives",
	"box.views.logs.new-status": "La commande est valide et stockée sur la plateforme cloud",
	"box.views.logs.received-status": "La commande a été reçue par la @.lower:box",
	"box.views.logs.retry_send-status": "La commande n'a pas encore été reçue par la @.lower:{'box'}, nous réessayerons bientôt",
	"box.views.logs.sent-status": "La commande a été envoyée à la @.lower:{'box'}, nous n'avons pas encore reçu de confirmation de la @.lower:box",
	"boxes": "@.clientname:_generic-plural",
	"broadcast": "Broadcast",
	"broadcast-distribution-table": "Tableau de distribution de diffusion",
	"broker": "Broker",
	"broker-port-number": "Numéro de port du broker",
	"broker-type": "Type de broker",
	"broker-url": "URL du broker",
	"bsp": "BSP",
	"bulk-creation": "Ajouter en masse",
	"bulk-downlink": {
		"live-data": {
			"banner-body": "Envoyez la même valeur à plusieurs équipements LoRaWAN de même modèle via \"Configuration > Équipements > Actions\".{cta}",
			"banner-title": "Envoi en masse disponible"
		},
		"step1": {
			"breadcrumb": "Modèles d'équipement",
			"no-product-reference": "Modèle inconnu",
			"title": "Sélectionnez le modèle d'équipement à configurer."
		},
		"step2": {
			"breadcrumb": "Équipements",
			"title": "Sélectionnez les équipements à configurer pour le modèle {name}."
		},
		"step3": {
			"apply-value": "Valeur à appliquer",
			"breadcrumb": "Propriétés",
			"error": {
				"invalid-payload": "Le payload doit être au format hexadécimal (0-9, A-F).",
				"invalid-port": "Le port doit être un nombre entier.",
				"no-codec-selected": "Veuillez séléctionner une propriété",
				"no-enabled-properties": "Il n'y a aucune propriété activée pour les équipements sélectionnés. Veuillez activer au moins une propriété pour envoyer les commandes."
			},
			"info-msg": {
				"body": "Pour activer des propriétés en masse, utilisez {link}.",
				"bulk-link": "Équipements > Actions > Modifier la configuration en masse",
				"title": "Les commandes seront envoyées uniquement aux propriétés actives"
			},
			"title": "Indiquez la valeur à envoyer à {name}. | Indiquez la valeur à envoyer aux {number} {name}.",
			"title-plural": "Sélectionnez la propriété à configurer puis indiquez la valeur à envoyer à {name}. | Sélectionnez la propriété à configurer puis indiquez la valeur à envoyer aux {number} {name}."
		},
		"step4": {
			"breadcrumb": "Résumé",
			"campaign-name": "Nom de la campagne",
			"campaign-name-error": "Le champ est obligatoire",
			"campaign-name-placeholder": "Ex. Intervalle - 30 min.",
			"class-a-msg": {
				"body1": "Les valeurs seront envoyées aux équipements lors de l'émission de leur prochain uplink.",
				"body2": "Chaque équipement ne peut avoir qu'une seule valeur en attente à la fois : si plusieurs valeurs sont envoyées, seule la dernière sera transmise.",
				"title": "Équipements LoRaWAN Classe A"
			},
			"class-c-msg": {
				"body": "Les valeurs seront envoyées progressivement. Temps estimé pour la mise à jour complète : {time}",
				"title": "Équipements LoRaWAN Classe C"
			},
			"description-placeholder": "Ex. Paramétrer l'intervalle d'émission à 30 minutes",
			"model-name": "Modèle d'équipement",
			"property": "Propriété",
			"see-list": "Voir la liste",
			"selected-equipments": "Equipements sélectionnés",
			"sent-value": "Valeur envoyée",
			"title": "Nommez la campagne et vérifiez les informations avant d'envoyer."
		},
		"success-dialog": {
			"body": "Suivez la progression de la campagne <b>{campaignName}</b> dans Logs > Campagnes.",
			"confirmBtn": "Voir la campagne",
			"title": "Commandes envoyées"
		},
		"title": "Envoyer des commandes LoRaWAN en masse",
		"version-dialog": {
			"body": "Cette fonctionnalité nécessite une version plus récente du firmware. Activez les mises à jour automatiques dans les paramètres de la @.lower:box (Organisation > {deviceName} > Paramètres).",
			"title": "Mise à jour requise"
		}
	},
	"bulk-edit": "Edition en masse",
	"bulk-edit-error-address": "Les adresses de registre des propriétés suivantes sont incompatibles. Veuillez modifier leurs addresses. {properties}",
	"bulk-import-file-error-msg": "Le fichier déposé n'est pas au bon format ou son contenu n'est pas accessible. Veuillez vous assurer du format du fichier et réessayer",
	"bulk-import.advanced-configuration-codec-name": "Configuration avancée {name}",
	"by-sending-config-from-da-config-will-overwrite-current-config-do-you-confirm": "En envoyant la configuration depuis la Desktop Application à la @.lower:{'hub'}, celle-ci écrasera la configuration actuelle et les changements ne seront pas reflétés dans la console. Confirmez-vous votre choix ?",
	"ca-certificate": "Certificat CA",
	"calculated": "Calculé",
	"calculated.no": "Non calculé",
	"calculation": "Calcul",
	"cancel": "Annuler",
	"cancel-changes": "Annuler les modifications",
	"cant-activate-box-without-subscription-plan": "Vous ne pouvez pas activer cette @.lower:box car elle n'a pas d'abonnement. Contactez le support, s'il vous plaît.",
	"certificate": "Certificat",
	"certificate-authentication": "Authentification par certificat",
	"certificate-authentication-required": "L'authentification par certificat est obligatoire",
	"certificate-deleted": "Certificat supprimé",
	"certificate-store-id": "Magasin de clés",
	"certificate-updated": "Certificat mis à jour",
	"certificates": "Certificats",
	"change": "Modifier",
	"change-alarm-settings": "Modifier les paramètres de l'alarme",
	"change-alert-status": "Modifier le statut de l'alerte",
	"change-box-hub-name": "Modifier le nom de la @.lower:box",
	"change-data-format-to-f32": "Veuillez modifier le format des données pour utiliser un format de données f32 (f32_dcba au lieu de float_abcd, f32_cdab au lieu de float_badc, f32_abcd au lieu de float_dcba et f32_badc au lieu de float_cdab)",
	"change-severity-of-alert": "Modifier la sévérité de l'alerte",
	"change-value-fields-restrict-scan-equipment-identification-number-matching-pattern": "Changer la valeur des champs pour limiter le scan au numéro d'identification de l'équipement correspondant au modèle.",
	"chat": "Discussion",
	"check-hub-configuration": "Vérifier la configuration de la @.lower:hub",
	"check-request-scan": "Vérifier si @.lower:box a reçu la demande d'exécuter le Scan",
	"choose-a-file": "Choisissez un fichier",
	"choose-date": "Choisissez la date",
	"choose-dates": "Choisissez les dates",
	"choose-end-date": "Choisir une date de fin",
	"choose-equipment-or-run-scan-bacnet": "Sélectionnez un équipement dans la base de données des équipements ou lancez un scan sur un réseau compatible (BACnet ou M-Bus)",
	"class-type": "Type de classe",
	"clear": "Effacer",
	"clear-selection": "Effacer la sélection",
	"click-here": "Cliquez ici",
	"click-here-touse-equipment-default-configuration": "Cliquez ici pour utiliser la configuration par défaut de l'équipement",
	"click-to-add-change-scaling": "Cliquez pour ajouter/modifier l'échelle",
	"click-to-add-change-unit": "Cliquez pour ajouter/modifier l'unité",
	"click-to-copy": "Cliquer pour copier",
	"click-to-copy-table-to-clipboard": "Cliquez ici pour copier le tableau dans le presse-papiers",
	"clicking-here": "cliquant ici",
	"client-authentication-method": "Client authentication method",
	"client-authentification": "Authentification client",
	"client-authentification-method": "Méthode d'authentification du client",
	"client-certificate": "Certificat Client",
	"client-id": "Client ID",
	"client-name-box": "@.clientname:_box",
	"client-name-boxes": "@.clientname:_boxes",
	"client-name-generic": "@.clientname:_generic",
	"client-name-generic-plural": "@.clientname:_generic-plural",
	"client-name-hub": "@.clientname:_hub",
	"client-name-hubs": "@.clientname:_hubs",
	"client-secret": "Client secret",
	"close": "Fermer",
	"close-alert": "Fermer l'alerte",
	"close-or-acknowledge-previous-alerts-from-this-alarm": "Fermer ou acquitter les précédentes alertes associées à l'alarme",
	"closed": "Fermée",
	"code": "Code",
	"codec-id": "ID du codec",
	"collapse-button-equipment-tooltip": "Fermer tous les équipements",
	"collapse-button-groups-tooltip": "Fermer tous les groupes",
	"collapse-button-organization-tooltip": "Fermer toutes les organisations",
	"colon-symbol": " :",
	"combination-of-baseurl-and-this-route-is-not-valid": "La combinaison de l'URL de base et de cette route n'est pas valide : {url}",
	"combination-of-brokerurl-and-this-route-is-not-valid": "La combinaison de l'URL du courtier et de cette route n'est pas valide : {url}",
	"comfort-reached-at": "Le confort atteint à",
	"command": "Commande",
	"command-of-configuration": "Commande de configuration",
	"command-scan-not-received-by-box": "La commande à analyser n'a pas été reçue par la @.lower:box",
	"command-status-ERROR_NOT_RECEIVED": "ERROR_NOT_RECEIVED",
	"command-status-NEW": "NEW",
	"command-status-RECEIVED": "RECEIVED",
	"command-status-RETRY_SEND": "RETRY_SEND",
	"command-status-SENT": "SENT",
	"command-status-tooltip": "New<br />La commande est valide et est dans la file d'envoi vers la @.lower:{'box'}<br /><br />Error_not_received<br />La commande n'a pas été reçue par la @.lower:box après plusieurs tentatives<br /><br />Sent<br />La commande a été envoyée à la @.lower:{'box'}. En attente de conformation de sa réception<br /><br />Received<br />La commande a été reçue par la @.lower:{'box'}<br /><br />Retry_send<br />La commande n'a pas été reçue par la @.lower:{'box'}. Une nouvelle tentative aura lieu",
	"command-to-send-to-device-to-read-write": "Commande à envoyer au périphérique pour lecture / écriture",
	"command-type-DISCOVER": "DISCOVER",
	"command-type-READ_REQUEST": "READ_REQUEST",
	"command-type-RESTART": "RESTART",
	"command-type-SEND_CONFIG": "SEND_CONFIG",
	"command-type-SET_PROPERTY": "SET_PROPERTY",
	"command-type-WS_CONFIG": "WS_CONFIG",
	"comment": "Commentaire",
	"communication": "Communication",
	"communication-mode": "Mode de communication",
	"communication-mode-to-use": "Le mode de communication à utiliser",
	"comparison-operator.eq.label": "Est égale à",
	"comparison-operator.ge.label": "Est plus grande ou égale à",
	"comparison-operator.gt.label": "Est plus grande que",
	"comparison-operator.le.label": "Est plus petite ou égale à",
	"comparison-operator.lt.label": "Est plus petite que",
	"comparison-operator.ne.label": "Est différente de",
	"components.buttons-expand-collapse.collapse": "Fermer tous",
	"components.buttons-expand-collapse.expand": "Etendre tous",
	"components.demo-account.account": "Compte Démo",
	"components.layouts.app.components.global-search.boxes-result.no-result": "0 @.lower:boxes trouvées avec les critères de recherche",
	"components.layouts.app.components.global-search.equipment-result.no-result": "0 équipement trouvé avec les critères de recherche",
	"components.layouts.app.components.global-search.modal-globlal-search.failed-getting-boxes": "Échec d'obtention de la liste des @.lower:boxes",
	"components.layouts.app.search.search-for-box": "Rechercher une @.lower:box",
	"components.paginator.next": "Page suivante",
	"components.paginator.previous": "Page précédente",
	"condition": "Condition",
	"configuration": "Configuration",
	"configuration-changed-but-not-applied-send-to-box": "La configuration a été éditée mais les modifications n'ont pas encore été synchronisées avec la @.lower:box . Envoyer la configuration à la @.lower:box pour les appliquer.",
	"configuration-get-network-id-to-scan-msg": "Obtenir le réseau pour exécuter l'analyse",
	"configuration-imported": "Configuration importée",
	"configuration-imported-with-success": "Configuration importée avec succès",
	"configuration-in-the-box": "Configuration dans la @.lower:box",
	"configuration-recreating-draft-msg": "Recréation de la configuration du brouillon",
	"configuration-saving-msg": "Sauvegarde de la configuration dans la @.lower:box",
	"configuration-verify-exist-scan-msg": "Vérification de l'existence d'un scan",
	"configuration-waiting-to-apply": "En attente de l'application de la configuration par @.lower:box",
	"configuration-was-successfully-applied-to-hub": "La configuration a été appliquée avec succès à votre @.lower:{'hub'}!",
	"configuration-wizard": "Wizard de configuration",
	"configuration.bulk-downlink": "Envoyer des commandes LoRaWAN en masse",
	"configuration.bulk-downlink-no-lorawan-tooltip": "Aucun équipement LoRaWAN disponible",
	"configuration.bulk.export.cell.error": "Veuillez sélectionner une valeur de la liste",
	"configuration.bulk.readme.equipment.a2": "Ce fichier contient des données importantes pour tous vos équipements, vous pouvez modifier certains d'entre eux afin d'importer des changements en masse. Vous trouverez ci-dessous un guide qui vous aidera à comprendre les différentes colonnes et comment les utiliser correctement.",
	"configuration.bulk.readme.equipment.a3": "Certaines colonnes sont en lecture seule, ce qui signifie qu'elles figurent dans l'exportation à titre d'information uniquement et que si vous en modifiez la valeur dans le fichier, elles ne seront pas prises en compte lors de l'importation. Les autres colonnes peuvent être modifiées afin de changer votre configuration.",
	"configuration.bulk.readme.equipment.a4": "Pour voir les données exportées et les modifier, passez à l'onglet suivant « Équipements ». N'essayez pas de modifier les autres onglets.",
	"configuration.bulk.readme.equipment.a5": "Pour supprimer des équipements en masse, retournez dans la console, sélectionnez plusieurs équipements et choisissez l'option « Supprimer » sous « Actions ».",
	"configuration.bulk.readme.equipment.column.a.10": "Equipment Name",
	"configuration.bulk.readme.equipment.column.a.11": "Equipment Description",
	"configuration.bulk.readme.equipment.column.a.12": "Equipment Protocol",
	"configuration.bulk.readme.equipment.column.a.13": "Equipment Synchronized",
	"configuration.bulk.readme.equipment.column.a.14": "Equipment Group",
	"configuration.bulk.readme.equipment.column.a.15": "DevEUI",
	"configuration.bulk.readme.equipment.column.a.16": "AppEUI",
	"configuration.bulk.readme.equipment.column.a.17": "Application Key",
	"configuration.bulk.readme.equipment.column.a.9": "Equipment ID",
	"configuration.bulk.readme.equipment.column.b.10": "Nom de l'équipement.",
	"configuration.bulk.readme.equipment.column.b.11": "Description de l'équipement.",
	"configuration.bulk.readme.equipment.column.b.12": "Protocole utilisé par l'équipement.",
	"configuration.bulk.readme.equipment.column.b.13": "Indique si l'équipement est synchronisé avec la box.",
	"configuration.bulk.readme.equipment.column.b.14": "Nom du groupe auquel l'équipement appartient. Si le groupe renseigné n'existe pas, il sera créé. ",
	"configuration.bulk.readme.equipment.column.b.15": "Identifiant de l'appareil. Pour les équipements LoRaWAN uniquement.",
	"configuration.bulk.readme.equipment.column.b.16": "Identifiant de l'application. Pour les équipements LoRaWAN uniquement.",
	"configuration.bulk.readme.equipment.column.b.17": "Clef racine de l'appareil. Pour les équipements LoRaWAN uniquement.",
	"configuration.bulk.readme.equipment.column.b.9": "Identifiant unique de l'équipement dans la base de données.",
	"configuration.bulk.readme.name": "Lisez-moi",
	"configuration.bulk.readme.properties.a2": "Ce fichier contient des données importantes pour tous vos propriétés d'équipement, vous pouvez modifier certaines d'entre elles afin d'importer des changements en masse. Vous trouverez ci-dessous un guide qui vous aidera à comprendre les différentes colonnes et comment les utiliser correctement.",
	"configuration.bulk.readme.properties.a3": "Certaines colonnes sont en lecture seule, ce qui signifie qu'elles figurent dans l'exportation à titre d'information uniquement et que si vous en modifiez la valeur dans le fichier, elles ne seront pas prises en compte lors de l'importation. Les autres colonnes peuvent être modifiées afin de changer votre configuration.",
	"configuration.bulk.readme.properties.a4": "Pour voir les données exportées et les modifier, passez à l'onglet suivant « Propriétés ». N'essayez pas de modifier les autres onglets.",
	"configuration.bulk.readme.properties.column.a.10": "Property Name",
	"configuration.bulk.readme.properties.column.a.11": "Property Description",
	"configuration.bulk.readme.properties.column.a.12": "Property Slug",
	"configuration.bulk.readme.properties.column.a.13": "Property Access Type",
	"configuration.bulk.readme.properties.column.a.14": "Property Interval",
	"configuration.bulk.readme.properties.column.a.15": "Property Unit",
	"configuration.bulk.readme.properties.column.a.16": "Property Scaling A",
	"configuration.bulk.readme.properties.column.a.17": "Property Scaling B",
	"configuration.bulk.readme.properties.column.a.18": "Redirect To",
	"configuration.bulk.readme.properties.column.a.19": "Property Synchronized",
	"configuration.bulk.readme.properties.column.a.20": "Property Activation Status",
	"configuration.bulk.readme.properties.column.a.8": "Property ID",
	"configuration.bulk.readme.properties.column.a.9": "Property Equipment",
	"configuration.bulk.readme.properties.column.b.10": "Nom de la propriété",
	"configuration.bulk.readme.properties.column.b.11": "Description de la propriété",
	"configuration.bulk.readme.properties.column.b.12": "Identifiant unique dans votre système (et par box) pour référencer la propriété",
	"configuration.bulk.readme.properties.column.b.13.1": "Indique si les valeurs de la propriété sont disponibles via la console cloud et les API (remote). Avec un accès en lecture et/ou en écriture. Ou si elles sont local (non envoyées au cloud) et par défaut en lecture et/ou en écriture en local.",
	"configuration.bulk.readme.properties.column.b.13.2": "Vous pouvez choisir la valeur appropriée à l'aide de la liste déroulante dans la cellule.",
	"configuration.bulk.readme.properties.column.b.14.1": "Le nombre de secondes entre deux récupérations de données.",
	"configuration.bulk.readme.properties.column.b.14.2": "Utilisé par la box lorsqu'elle lit des données depuis l'équipement.",
	"configuration.bulk.readme.properties.column.b.14.3": "Le minimum est  600 pour les propriétés REMOTE et 60 pour les LOCAL.",
	"configuration.bulk.readme.properties.column.b.15.1": "Unité de la propriété.",
	"configuration.bulk.readme.properties.column.b.16.1": "Si une mise à l'échelle est appliquée pour cette propriété, valeur ",
	"configuration.bulk.readme.properties.column.b.16.2": "de la formule : a*x + b",
	"configuration.bulk.readme.properties.column.b.17.1": "Si une mise à l'échelle est appliquée pour cette propriété, valeur ",
	"configuration.bulk.readme.properties.column.b.17.2": "de la formule : a*x + b",
	"configuration.bulk.readme.properties.column.b.18": "Si la propriété est redirigée vers une passerelle, nom de la propriété redirigée.",
	"configuration.bulk.readme.properties.column.b.19": "Indique si la propriété est synchronisée avec la box.",
	"configuration.bulk.readme.properties.column.b.20.1": "Indique si la propriété est activée ou non.",
	"configuration.bulk.readme.properties.column.b.20.3": "Utiliser ce champ pour désactiver plusieurs propriétés en une seule fois dans votre configuration.",
	"configuration.bulk.readme.properties.column.b.8": "Identifiant unique de la propriété dans la base de données.",
	"configuration.bulk.readme.properties.column.b.9": "Nom de l'équipement auquel la propriété appartient.",
	"configuration.bulk.readme.redirected-properties.a2": "Ce fichier contient des données importantes pour tous vos propriétés redirigées d'équipement, vous pouvez modifier certaines d'entre elles afin d'importer des changements en masse. Vous trouverez ci-dessous un guide qui vous aidera à comprendre les différentes colonnes et comment les utiliser correctement.",
	"configuration.bulk.readme.redirected-properties.a3": "Certaines colonnes sont en lecture seule, ce qui signifie qu'elles figurent dans l'exportation à titre d'information uniquement et que si vous en modifiez la valeur dans le fichier, elles ne seront pas prises en compte lors de l'importation. Les autres colonnes peuvent être modifiées afin de changer votre configuration.",
	"configuration.bulk.readme.redirected-properties.a4": "Pour voir les données exportées et les modifier, passez à l'onglet suivant « Propriétés redirigées ». N'essayez pas de modifier les autres onglets.",
	"configuration.bulk.readme.redirected-properties.column.a.10": "Redirected Property Name",
	"configuration.bulk.readme.redirected-properties.column.a.11": "Redirected Property Description",
	"configuration.bulk.readme.redirected-properties.column.a.12": "Redirected Property Slug",
	"configuration.bulk.readme.redirected-properties.column.a.13": "Redirected Property Access Type",
	"configuration.bulk.readme.redirected-properties.column.a.14": "Redirected Property From",
	"configuration.bulk.readme.redirected-properties.column.a.15": "Redirected Property To",
	"configuration.bulk.readme.redirected-properties.column.a.16": "Redirected Property Unit",
	"configuration.bulk.readme.redirected-properties.column.a.17": "Redirected Property Synchronized",
	"configuration.bulk.readme.redirected-properties.column.a.18": "Redirected Property Register Address",
	"configuration.bulk.readme.redirected-properties.column.a.19": "Redirected Property Register Type",
	"configuration.bulk.readme.redirected-properties.column.a.20": "Redirected Property Data Format",
	"configuration.bulk.readme.redirected-properties.column.a.21": "Redirected Property Raw Register",
	"configuration.bulk.readme.redirected-properties.column.a.22": "Redirected Property Object Type",
	"configuration.bulk.readme.redirected-properties.column.a.23": "Redirected Property Object Instance",
	"configuration.bulk.readme.redirected-properties.column.a.24": "Redirected Property MQTT Slug",
	"configuration.bulk.readme.redirected-properties.column.a.8": "Redirected Property ID",
	"configuration.bulk.readme.redirected-properties.column.a.9": "Redirected Property Gateway",
	"configuration.bulk.readme.redirected-properties.column.b.10": "Nom de la propriété redirigée.",
	"configuration.bulk.readme.redirected-properties.column.b.11": "Description de la propriété redirigée.",
	"configuration.bulk.readme.redirected-properties.column.b.12.1": "Identifiant unique dans votre système (et par box) pour référencer la propriété",
	"configuration.bulk.readme.redirected-properties.column.b.12.2": "Différent du slug MQTT, voir plus bas.",
	"configuration.bulk.readme.redirected-properties.column.b.13.1": "Indique si les valeurs de la propriété sont disponibles via la console cloud et les API (remote). Avec un accès en lecture et/ou en écriture. Ou si elles sont local (non envoyées au cloud) et par défaut en lecture et/ou en écriture en local.",
	"configuration.bulk.readme.redirected-properties.column.b.13.2": "Vous pouvez choisir la valeur appropriée à l'aide de la liste déroulante dans la cellule.",
	"configuration.bulk.readme.redirected-properties.column.b.14": "Nom de la propriété depuis laquelle la redirection est effectuée.",
	"configuration.bulk.readme.redirected-properties.column.b.15": "Nom de la propriété vers laquelle la redirection est effectuée.",
	"configuration.bulk.readme.redirected-properties.column.b.16.1": "Unité de la propriété.",
	"configuration.bulk.readme.redirected-properties.column.b.17": "Indique si la propriété est synchronisée avec la box.",
	"configuration.bulk.readme.redirected-properties.column.b.18.1": "Adresse du registre de la propriété. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.19.1": "Type du registre à utiliser. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.20.1": "Format de la donnée. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.21.1": "Registre à utiliser. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.22.1": "Type de l'objet. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.23.1": "Identifiant de l'instance l'objet. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.24.1": "Slug utilisé comme identifiant de la propriété sur MQTT. Pour les passerelles",
	"configuration.bulk.readme.redirected-properties.column.b.8": "Identifiant unique de la propriété redirigée dans la base de données.",
	"configuration.bulk.readme.redirected-properties.column.b.9": "Nom de la passerelle à laquelle la propriété appartient.",
	"configuration.bulk.readme.redirected-properties.column.b.gateways-only": "uniquement.",
	"configuration.bulk.readme.table.choose-correct-value": "Choisir la valeur appropriée dans la liste déroulante au niveau de la cellule. ",
	"configuration.bulk.readme.table.column.value.128hex": "Valeur 128-bit hexadecimal",
	"configuration.bulk.readme.table.column.value.64hex": "Valeur 64-bit hexadecimal",
	"configuration.bulk.readme.table.column.value.coil": "- COIL",
	"configuration.bulk.readme.table.column.value.current": "- CURRENT si l'équipement est synchronisé avec la box,",
	"configuration.bulk.readme.table.column.value.decimal": "Nombre décimal",
	"configuration.bulk.readme.table.column.value.disable": "- DISABLE",
	"configuration.bulk.readme.table.column.value.draft": "- DRAFT sinon.",
	"configuration.bulk.readme.table.column.value.dropdown": "Liste déroulante",
	"configuration.bulk.readme.table.column.value.enable": "- ENABLE",
	"configuration.bulk.readme.table.column.value.holding-register": "- HOLDING_REGISTER",
	"configuration.bulk.readme.table.column.value.input-discrete": "- INPUT_DISCRETE",
	"configuration.bulk.readme.table.column.value.input-register": "- INPUT_REGISTER",
	"configuration.bulk.readme.table.column.value.integer": "Entier",
	"configuration.bulk.readme.table.column.value.local": "- LOCAL : locale",
	"configuration.bulk.readme.table.column.value.numeric": "Identifiant alphanumerique",
	"configuration.bulk.readme.table.column.value.read": "- REMOTE_READ_ONLY : en lecture ",
	"configuration.bulk.readme.table.column.value.read-write": "- REMOTE_READ_WRITE : en lecture et en écriture",
	"configuration.bulk.readme.table.column.value.text": "texte",
	"configuration.bulk.readme.table.column.value.write": "- REMOTE_WRITE_ONLY : en écriture",
	"configuration.bulk.readme.table.header.a": "Nom de la colonne",
	"configuration.bulk.readme.table.header.b": "Description",
	"configuration.bulk.readme.table.header.c": "Type de donnée",
	"configuration.bulk.readme.table.header.d": "Valeur modifiable",
	"configuration.bulk.readme.table.header.e": "Exemple",
	"configuration.bulk.readme.table.no-change-value": "Ne pas modifier cette valeur.",
	"configuration.bulk.readme.table.title": "Définition des colonnes",
	"configuration.bulk.readme.title": "Introduction",
	"configuration.bulk.update": "Modifier la configuration en masse",
	"configuration.bulk.update.action": "Mettre à jour la configuration",
	"configuration.bulk.update.confirm.equipments.gateways.body": "Au moins une propriété des équipements modifiés est redirigée vers une passerelle BACnet IP ou MQTT. Ces passerelles peuvent s’appuyer sur le nom de l’équipement pour nommer les propriétés redirigées. Souhaitez-vous appliquer la modification aux passerelles ?",
	"configuration.bulk.update.confirm.equipments.gateways.title": "Mettre à jour le nom des équipements dans les passerelles",
	"configuration.bulk.update.confirm.equipments.topics.body": "Au moins une propriété des équipements modifiés est redirigée vers une passerelle MQTT. Ce type de passerelle peut s’appuyer sur le nom de l’équipement dans les uplink topics MQTT. Si tel est le cas, tous les topics des propriétés redirigées de cette passerelle seront mis à jour.",
	"configuration.bulk.update.confirm.equipments.topics.title": "Mettre à jour le nom de l'équipement dans les topics MQTT",
	"configuration.bulk.update.confirm.properties.gateways.body": "Au moins une propriété est redirigée vers une passerelle BACnet IP ou MQTT. Ces passerelles peuvent nécessiter une mise à jour pour refléter les modifications de la propriété. Souhaitez-vous appliquer les modifications aux passerelles ?",
	"configuration.bulk.update.confirm.properties.gateways.title": "Appliquer les modifications de la propriété aux passerelles",
	"configuration.bulk.update.confirm.properties.topics.body": "Au moins une propriété est redirigée vers une passerelle MQTT. Ce type de passerelle peut s’appuyer sur le nom des propriétés dans les uplink topics MQTT. Si tel est le cas, tous les topics des propriétés redirigées de cette passerelle seront mis à jour.",
	"configuration.bulk.update.confirm.properties.topics.title": "Mettre à jour le nom des propriétés dans les topics MQTT",
	"configuration.bulk.update.confirmation": "Oui, appliquer la modification aux passerelles",
	"configuration.bulk.update.error": "Erreur lors de la mise à jour de la configuration. Téléchargez le fichier d’origine avec les messages d’erreur. ",
	"configuration.bulk.update.export": "Sélectionnez le contenu à mettre à jour",
	"configuration.bulk.update.export.error": "Une erreur est survenue pendant l'export de vos données. Veuillez réessayer.",
	"configuration.bulk.update.file-to-import": "Importez le fichier mis à jour",
	"configuration.bulk.update.file-to-update": "Mettez à jour le fichier",
	"configuration.bulk.update.import.error": "Assurez-vous d’avoir sélectionné le bon type de contenu à mettre à jour dans l'étape précédente.",
	"configure-connector": "Configuration du connecteur",
	"configure-ethernet-connector": "Configurer le connecteur Ethernet",
	"configure-gateway": "Configurez la passerelle",
	"configure-heating-optimiser": "Configurer l'Optimiseur de Relance",
	"configure-how-to-run-the-mbus-scan": "Configurer comment exécuter le scan du MBUS",
	"configure-individual-and-internal-address-box": "Configurez l'adresse individuelle et interne de la @.lower:{'box'}.",
	"configure-knx-network": "Configurer le réseau KNX",
	"configure-lon-ip852-network": "Configurer le réseau LON IP852",
	"configure-lorawan-network": "Configurer le réseau LoRaWAN",
	"configure-mbus-protocol": "Configurer le protocole MBUS",
	"configure-network-RVL-equipment": "Configurer le réseau pour l'équipement RVL",
	"configure-network-lon-ip852": "Configurez les adresses LON IP852 dans @.lower:box",
	"configure-new-gateway": "Configurez la nouvelle passerelle",
	"configure-new-routing": "Configurer une nouvelle route",
	"configure-properly-property": "Configurez correctement la propriété",
	"configure-routing": "Configurer la route",
	"configuring-bacnet-msg": "Configuration de @.lower:{'box'}. Cela peut prendre un certain temps. Attendez, s'il vous plaît.",
	"configuring-connector": "Configuration du connecteur",
	"configuring-network": "Configuration du réseau",
	"confirm": "Confirmer",
	"congratulations": "Toutes nos félicitations!",
	"connection": "Connexion",
	"connection-inactive": "Connexion inactive",
	"connection-ko": "Connexion KO",
	"connection-ok": "Connexion OK",
	"connectivity": "Connectivité",
	"connector": "Connecteur",
	"connector-and-triggers-duplicated": "Connecteur et triggers dupliqués",
	"connector-canot-get-ip-address": "Le connecteur {connector} ne peut pas obtenir d'adresse IP",
	"connector-configuration-different-from-equipment-default-configuration": "La configuration du connecteur est différente de la configuration par défaut de l'équipement (ignorez cet avertissement si vous avez modifié la configuration de l'équipement).",
	"connector-ko-because-cant-get-ip": "Le connecteur est KO car il ne peut pas obtenir d'adresse IP",
	"connector-name-triggers": "Trigger pour \"{name}\"",
	"connector-saved": "Connecteur enregistré",
	"connectors": "Connecteurs",
	"connectors-for": "Connecteurs pour \"{name}\"",
	"control": "Control",
	"copied-to-clipboard": "Copié dans le presse-papiers",
	"copy": "copie",
	"copy-all-info": "Copier toutes les infos",
	"copy-gateway": "Copier vers la passerelle :",
	"copy-of": "Copie de",
	"copy-to-clipboard": "Copier dans le presse-papier",
	"copypaste-copied": "Copié",
	"copypaste-copy": "Copier",
	"copypaste-paste": "Coller",
	"count": "Compter",
	"create-a-lorawan-network": "Créer un réseau LoRaWAN",
	"create-a-new-network": "Créer un nouveau réseau",
	"create-archive-request": "Créer une demande d'archive de données",
	"create-equipment": "Créer l'équipement",
	"create-equipments": "Créer les équipements",
	"create-licence-for-this-organization": "Créer une nouvelle licence pour cette organisation",
	"create-lorawan-network": "Créer le réseau LoRaWAN",
	"create-new-equipment": "Créer de nouveaux équipements",
	"create-new-gateway": "Créer une Passerelle",
	"create-new-notification": "Créer une nouvelle notification",
	"create-new-organization": "Créer une organisation",
	"create-new-properties": "créer de nouvelles propriétés",
	"create-properties": "Créer les propriétés",
	"create-the-trigger": "Créer le trigger",
	"create-your-first-connector": "Créer votre premier connecteur",
	"create-your-first-trigger": "Créer votre premier trigger",
	"created-at": "Créé le",
	"created-by": "Créé par",
	"creating-all-equipment": "Création des équipements en cours",
	"creation-date": "Date de création",
	"critical": "Critique",
	"csv-file-format": "Format accepté : .CSV avec un encodage UTF-8, séparateur virgule ou point virgule",
	"csv-xlsx-file-format": "Format autorisé : .xlsx, .csv avec encoding UTF-8 (séparateur virgule ou point virgule)",
	"current": "Actuel",
	"current-configuration": "Configuration actuelle",
	"current-rate-plan": "Licence associée aujourd'hui",
	"current-status": "Statut actuel",
	"current-value": "Valeur en cours",
	"curve": "Courbe",
	"custom": "Personnalisé",
	"custom-mqtt-slug": "Personnaliser le format du slug MQTT",
	"custom-routing-table": "Table de routage personnalisée",
	"daily": "Journalier",
	"daily-schedule-help-msg-1": "L'équipement étant de type RVL, vous pouvez définir jusqu'à 6 créneaux au cours d'une journée. Le mode NORMAL s'applique au début du créneau. Il se terminera soit au début du créneau suivant, soit à la fin de la journée selon vos réglages. Le mode RÉDUIT s'appliquera entre deux créneaux ou en dehors des créneaux horaires.",
	"daily-schedule-help-msg-1-knx": "Veuillez tenir compte de l'heure locale de l'équipement car l'horaire sera stocké dans l'équipement et il sera exécuté par l'équipement.",
	"daily-schedule-help-msg-2-knx": "L'équipement étant de type Synco, vous pouvez définir jusqu'à 6 créneaux au cours d'une journée. Le mode DÉFAUT s'applique jusqu'au début du premier créneau.",
	"daily-schedule-invalid-consecutive-time": "L'heure de début n'est pas cohérente avec l'heure de début du créneau précédent.",
	"daily-schedule.copy-day-btn": "Appliquer ce programme au",
	"dashboard": "Dashboard",
	"dashboard-exit-full-screen": "Quitter le plein écran",
	"dashboard-go-full-screen": "Plein écran",
	"dashboard-name": "Nom du dashboard",
	"dashboard-properties-table-tooltip": "Sélectionner les propriétés à afficher dans le tableau",
	"dashboard-properties-tile-tooltip": "Le nombre de graphiques de type \"Valeur unique\" ajoutés au dashboard sera égal au nombre de propriétés sélectionnées",
	"dashboard.card.hover": "Glissez-déposez votre image au format PNG ou JPEG",
	"dashboard.dropzone.invalid": "Seules les images jpg ou png inférieures à 5MO sont supportées. Veuillez modifier l'image et la redéposer",
	"dashboard.no-schedule-yet": "Vous n'avez pas encore créé de planning.",
	"dashboard.option-of-schedule": "Affichage du planning",
	"dashboard.schedule-day-of-the-week": "Jour de la semaine",
	"dashboard.schedule-option.5days": "5 jours glissants",
	"dashboard.schedule-option.day": "Jour unique",
	"dashboard.schedule-option.week": "Semaine du lundi au vendredi",
	"dashboard.schedule-type": "Planning",
	"dashboard.schedule-type-plural": "Plannings",
	"dashboard.schedule.in-console": "Planning créé dans la console",
	"dashboard.schedule.in-regulator": "Planning stocké dans un régulateur",
	"dashboard.type-of-schedule": "Type de planning",
	"dashboard.want-to-create-one": "Souhaitez-vous créer votre premier planning ?",
	"dashboards": "Dashboards",
	"data-bits": "Data bits",
	"data-format": "Format de Données",
	"data-point-type": "Type de point de données",
	"data-points-expected-got": "Dernière vérification il y a {since} <span class=\"has-text-grey-400\">({date})</span>. <br> Entre {start} et {end} : <ul><li>Nombre minimum de valeurs attendues : {expected}</li><li>Nombre de valeurs reçues : {got}</li></ul><p class=\"has-text-grey-400 mt-2 is-italic\">Prochaine vérification à {next}</p>",
	"data-streams": "Data Streams",
	"data-streams-available-only-boxes-because-data-have-be-present-in-console": "Les Data Streams ne sont disponibles que pour les @.clientname:_boxes car les données doivent être disponibles depuis la console.",
	"data-type": "Type de donnée",
	"datapoint.tooltip": "DP (Datapoint) : nombre de points inclus dans la licence",
	"datastream-connector-error.cause-label": "Cause :",
	"datastream-connector-error.error-label": "Erreur :",
	"datastream-connector-error.last-error-received": "Ci-dessous, la dernière erreur rencontrée :",
	"datastream-connector-error.mqtt-custom.authentication": "Le type de broker PERSONNALISÉ doit avoir au moins un type d'authentification : soit une authentification classique, soit une authentification par certificat",
	"datastream-connector-error.tooltip": "Connexion KO. <br/>Cliquer pour voir les détails.",
	"datastreams.connector-config-kb.msg": "Définissez les paramètres de votre connecteur {type}. {link}",
	"datastreams.connector-error.notifications": "Notification en cas d'erreur",
	"datastreams.connector-error.notifications.help-msg": "Ajouter des personnes à notifier en cas de défaillance du connecteur",
	"date": "Date",
	"date-range": "Période",
	"date-time-is-out-of-service-msg": "Cette exception est désactivée. Editer la propriété pour l'activer.",
	"datepicker-last-x-days": "{days} derniers jours",
	"datepicker-last-year": "Dernière année",
	"dates-and-time": "Dates et heures",
	"day": "Jour",
	"days": "Jours",
	"default": "défaut",
	"default-class-a": "Défaut (classe A)",
	"default-format-used-for-slug-properties": "Format par défaut utilisé pour le nom du slug des différentes propriétés. La valeur peut être personnalisée pour chaque propriété",
	"default-routing-table": "Table de routage par défaut",
	"default-severity": "Sévérité par défaut",
	"default-value": "Valeur par défaut",
	"define-temporization": "Définir une temporalité",
	"defines-end-of-event": "Définit l'heure de fin de l'événement.",
	"defines-how-data-is-interpreted-and-encoded-equipment": "Définit comment les données doivent être interprétées et encodées sur l'équipement",
	"defines-start-of-event": "Définit le début de l'événement et quand il se produira.",
	"delete": "Supprimer",
	"delete-certificate": "Supprimer le certificat",
	"delete-connector": "Supprimer le connecteur",
	"delete-dashboard-block": "Supprimer le graphique",
	"delete-equipment": "Supprimer l'équipement | Supprimer les équipements",
	"delete-properties": "Supprimer la propriété | Supprimer les propriétés",
	"delete-schedule-linked-to-items": {
		"linked-to-alarm-body": "Ce planning est utilisé dans une ou plusieurs alarmes ({alarms}).{br}Modifiez d'abord ces alarmes pour pouvoir supprimer ce planning.",
		"linked-to-automation-body": "Ce planning est utilisé dans un ou plusieurs scénarios ({scenarios}).{br}Modifiez d'abord ces scénarios pour pouvoir supprimer ce planning.",
		"title": "Impossible de supprimer le planning"
	},
	"delete-schedule-property-linked-to-rtn": {
		"body": "La propriété \"{propertyName}\" est utilisée dans un ou plusieurs scénarios ({scenarios}) avec une valeur de retour à la normale indiquée dans ce planning. {br}Modifiez d'abord ces scénarios pour pouvoir retirer la propriété du planning.",
		"title": "Impossible de retirer la propriété du planning"
	},
	"delete-this-field": "Supprimer le champ",
	"delete-trigger-triggername": "Supprimer le trigger \"{trigger}\" ?",
	"delete-widget": "Supprimer l'élément",
	"delete-x-properties": "Supprimer 1 propriété | Supprimer {x} propriétés",
	"delta": "Delta (Dernière - Première)",
	"description": "Description",
	"description-use-mask-identification-number": "Seuls les équipements dont le numéro d'identification dans l'adresse secondaire correspond au masque, seront retournés.",
	"deselect": "Désélectionner",
	"destination": "Destination",
	"details": "Détails",
	"dev-eui": "Dev EUI",
	"deveui": "DevEUI",
	"device": "Appareil",
	"device-as-box": "Box",
	"device-created-with-success": "Appareil créé avec succès",
	"device-extended-universal-identifier": "Device Extended Universal Identifier",
	"device-instance": "Device Instance",
	"device-instance-for-network-this-device-instance-unique-on-box": "Une instance d'appareil pour le réseau de la @.lower:{'box'}. Cette instance d'appareil doit être unique sur la boîte.",
	"device-name": "Nom de l'appareil",
	"device-number": "Numéro d'appareil",
	"device-number-description": "Le numéro de périphérique de l'équipement LPB",
	"device-type": "Type d'appareil",
	"device.header.connected": "@.capitalize:box connectée à la console",
	"device.header.connexion.eth": "@.capitalize:box connectée à la console",
	"device.header.connexion.gsm": "Qualité du réseau cellulaire",
	"devices": "Appareils",
	"devices-found": "Appareils trouvés",
	"devices.configuration": "Paramètres",
	"dialog-active-box.box-name-tooltip": "Donnez un nom à la {box} (vous pourrez le changer plus tard)",
	"dialog.archive-sent.body": "Votre demande est en cours de traitement. Vous recevrez un email dès que votre archive est prête.",
	"dialog.archive-sent.body.schedule": "Votre export automatique de données est programmé. Vous recevrez vos données à la fréquence que vous avez spécifiée.",
	"dialog.archive-sent.title": "Demande envoyée",
	"dialog.archive-sent.title.schedule": "Demande enregistrée",
	"dialog.autodiscovery-refresh-scan.body": "Si le scan est relancé alors les propriétés actuellement sélectionnées seront déselectionnées.",
	"dialog.autodiscovery-refresh-scan.title": "Relancer le scan",
	"dialog.config-wizard-request-equipment.body": "Nous traitons votre demande. Notre équipe vous contactera par email pour vous tenir informé de l'état de votre demande.",
	"dialog.config-wizard-request-equipment.title": "Demande envoyée",
	"dialog.confirm-timer-below-60.body": "Vous avez configuré un intervalle entre deux lectures inférieur à 60 secondes. Si plusieurs équipements communiquent sur le réseau, cela pourrait engendrer des perturbations. Si vous n’avez pas de contraintes, conservez une valeur de 60 secondes minimum.",
	"dialog.confirm-timer-below-60.title": "Confirmer l'intervalle",
	"dialog.datastream-connector-error.confirm": "Modifier",
	"dialog.datastream-connector-error.message": "Le connecteur du data stream est en erreur depuis le {dateTime} après 15 erreurs successives.{br}Une fois le problème corrigé, veuillez relancer la connexion.",
	"dialog.datastream-connector-error.relaunch": "Relancer",
	"dialog.datastream-connector-error.title": "Connecteur en erreur",
	"dialog.datastreams.disable.body": "Cette action interrompt l'envoi des données.",
	"dialog.datastreams.disable.title": "Désactiver le connecteur",
	"dialog.delete-alarm.body": "L'alarme \"{name}\" sera supprimée ainsi que toutes les alertes créées en rapport à l'alarme.",
	"dialog.delete-alarm.title": "Supprimer l'alarme",
	"dialog.delete-api-key.body": "La clé \"{name}\" sera supprimée. Cette action ne pourra pas être annulée.",
	"dialog.delete-api-key.title": "Supprimer la clé API",
	"dialog.delete-automation-scenario.body": "Cela supprimera le scénario d'automatisation \"{name}\" et toutes ses instances.",
	"dialog.delete-automation-scenario.title": "Supprimer le scénario d'automatisation",
	"dialog.delete-config.body": "Toutes les modifications apportées à la configuration depuis votre dernière sauvegarde seront supprimées.",
	"dialog.delete-config.confirm": "Abandonner les modifications",
	"dialog.delete-config.title": "Abandonner les modifications",
	"dialog.delete-dashboard-block.title": "Supprimer le graphique",
	"dialog.delete-dashboard.title": "Supprimer le dashboard",
	"dialog.delete-equipment.alarms": "Les alarmes basées sur les propriétés de l’équipement cesseront de fonctionner | Les alarmes basées sur les propriétés des équipements cesseront de fonctionner",
	"dialog.delete-equipment.archives.1": "Archives récurrentes contenant uniquement les propriétés de l’équipement | Archives récurrentes contenant uniquement les propriétés des équipements",
	"dialog.delete-equipment.archives.2": "des archives récurrentes contenant d'autres propriétés",
	"dialog.delete-equipment.body": "L'équipement \"{equipment}\" ainsi que toutes ses propriétés ({properties}) seront supprimées.",
	"dialog.delete-equipment.body.bridge": "Cette action supprime définitivement l’équipement “{equipment}” et ses {properties}. | Cette action supprime définitivement les {equipments} sélectionnés et leurs {properties}.",
	"dialog.delete-equipment.body.tower": "Cette action supprime définitivement l’équipement  “{equipment}” ainsi que ses {properties}. | Cette action supprime définitivement les {equipments} ainsi que leurs {properties}.",
	"dialog.delete-equipment.calendar": "Envoi de consignes par un planning sur les propriétés de l’équipement (planning conservé) | Envoi de consignes par un planning sur les propriétés des équipements (planning conservé)",
	"dialog.delete-equipment.checkbox": "Supprimer les propriétés de cet équipement redirigées dans les passerelles. Si l'option n'est pas sélectionnée, les propriétés redirigées seront conservées.",
	"dialog.delete-equipment.dashboard": "des widgets de tableaux de bord contenant d'autres propriétés",
	"dialog.delete-equipment.graphs": "des graphiques",
	"dialog.delete-equipment.historic": "Historique des valeurs enregistrées",
	"dialog.delete-equipment.redirected-properties": "Redirections depuis ou vers les propriétés de l’équipement | Redirections depuis ou vers les propriétés des équipements",
	"dialog.delete-equipment.schedules": "Scénarios où l’une des propriétés de l’équipement est utilisée | Scénarios où les propriétés des équipements sont utilisées",
	"dialog.delete-equipment.streams": "des datastreams",
	"dialog.delete-equipment.this": "Les propriétés de l’équipement seront retirées : | Les propriétés des équipements seront retirées :",
	"dialog.delete-equipment.title": "Supprimer l'équipement",
	"dialog.delete-equipment.virtual-properties": "Propriétés virtuelles basées sur les propriétés de l’équipement | Propriétés virtuelles basées sur les propriétés des équipements",
	"dialog.delete-equipment.widgets": "Widgets de tableaux de bord basés sur les propriétés de l’équipement | Widgets de tableaux de bord basés sur les propriétés des équipements",
	"dialog.delete-event.title": "Supprimer l'évènement",
	"dialog.delete-gateway.body": "La passerelle \"{gateway}\" et toutes ses propriétés ({properties}) seront supprimées.",
	"dialog.delete-gateway.title": "Supprimer la passerelle",
	"dialog.delete-graph.body": "Le graphique sera supprimé.",
	"dialog.delete-graph.title": "Supprimer le graphique",
	"dialog.delete-network.body": "Le réseau \"{network}\" sera supprimé. Les équipements ou les passerelles qui utilisent ce réseau ne seront pas supprimés.",
	"dialog.delete-network.title": "Supprimer le réseau",
	"dialog.delete-notifications.title": "Supprimer la notification",
	"dialog.delete-property.alarms": "Les alarmes basées sur cette propriété cesseront de fonctionner | Les alarmes basées sur ces propriétés cesseront de fonctionner",
	"dialog.delete-property.archives.1": "Archives récurrentes contenant uniquement cette propriété | Archives récurrentes contenant uniquement ces propriétés",
	"dialog.delete-property.archives.2": "des archives récurrentes contenant d'autres propriétés",
	"dialog.delete-property.body": "Cette action supprime définitivement la propriété “{property}”. | Cette action supprime définitivement les {properties}.",
	"dialog.delete-property.body.bridge": "Cette action supprime définitivement la propriété “{property}”.| Cette action supprime définitivement les {properties}.",
	"dialog.delete-property.calendar": "Envoi de consignes par un planning (planning conservé)",
	"dialog.delete-property.dashboard": "des widgets de tableaux de bord contenant d'autres propriétés",
	"dialog.delete-property.graphs": "des graphiques",
	"dialog.delete-property.historic": "Historique des valeurs enregistrées",
	"dialog.delete-property.redirected-properties": "Redirections depuis ou vers cette propriété | Redirections depuis ou vers ces propriétés",
	"dialog.delete-property.schedules": "Scénarios où cette propriété est utilisée | Scénarios où ces propriétés sont utilisées",
	"dialog.delete-property.streams": "des datastreams",
	"dialog.delete-property.this": "Cette propriété sera retirée : | Ces propriétés seront retirées :",
	"dialog.delete-property.virtual-properties": "Propriétés virtuelles basées sur cette propriété | Propriétés virtuelles basées sur ces propriétés",
	"dialog.delete-property.widgets": "Widgets de tableaux de bord basés sur cette propriété uniquement | Widgets de tableaux de bord basés sur ces propriétés uniquement",
	"dialog.delete-routing.body": "Le routage \"{name}\" sera supprimé.",
	"dialog.delete-routing.title": "Supprimer un routage",
	"dialog.delete-schedule-state-linked-to-alarm.body": "Une ou plusieurs alarmes ({alarms}) utilisent toujours le type de créneau dans leur configuration. Veuillez d'abord éditer cette ou ces alarmes pour ne plus les relier au type de créneau.",
	"dialog.delete-schedule-state-linked-to-alarm.title": "Suppression du type de créneau \"{name}\" impossible",
	"dialog.delete-schedule.body": "Le planning \"{name}\" sera supprimé.",
	"dialog.delete-schedule.title": "Supprimer le planning",
	"dialog.graph-archive-sent.body": "Votre demande est en cours de traitement. Vous recevrez un email dés que votre fichier sera prêt.",
	"dialog.graph-archive-sent.title": "Demande envoyée",
	"dialog.graph-unsaved-changes-save.body": "Des changements ne sont pas sauvegardés. En quittant cette page, les modifications apportées au graphique seront supprimées.",
	"dialog.graph-unsaved-changes.title": "Quitter la page avec des modifications non enregistrées ?",
	"dialog.lorawan-equipment-duplication.body": "Pensez à appairer l'équipement avec la box \"{boxDestinationName}\".",
	"dialog.lorawan-equipment-duplication.cancel": "Fermer",
	"dialog.lorawan-equipment-duplication.confirm": "Accéder à l'équipement dupliqué",
	"dialog.lorawan-equipment-duplication.title": "Equipement dupliqué. Que souhaitez-vous faire ?",
	"dialog.lpb-equipment-device-number-1.body": "Le numéro d'appareil choisi pour l'équipement {equipmentName} est 1. De fait, cet équipement agira comme maître sur le segment {segmentNumber}. Confirmez-vous cette configuration?",
	"dialog.lpb-equipment-device-number-1.title": "Équipement LPB",
	"dialog.lpb-equipment-segment-number.body": "Le numéro de segement choisi est {segmentNumber}. Le réseau LPB configuré sur la @.lower:box utilise le segment {boxSegmentNumber}. Si les deux segments diffèrent alors la box ne pourra pas communiquer avec le nouvel équipement. Confirmez-vous cette configuration?",
	"dialog.lpb-equipment-segment-number.title": "Équipement LPB",
	"dialog.mqtt-slug-change.body": "En modifant le format du slug, toutes les propriétés de la passerelle pour lesquelles le slug n'a pas été personnalisé, seront impactées et suivront le nouveau format. Confirmez-vous les changements ?",
	"dialog.mqtt-slug-change.title": "Modifier le slug ?",
	"dialog.mqtt-uplink-change.body": "En modifant le format de l'uplink topic, tous les topics des propriétés de la passerelle seront impactés et suivront le nouveau format. Confirmez-vous les changements ?",
	"dialog.mqtt-uplink-change.title": "Modifier le format de l'uplink topic MQTT ?",
	"dialog.request-new-scan.body": "La demande d'un nouveau scan supprimera le scan précédent et ses propriétés. Ce changement est définitif. En fonction du réseau, la durée du scan pourra prendre un certain temps.",
	"dialog.request-new-scan.title": "Demander un nouveau scan",
	"dialog.rvl-even-slots.body": "Le nombre de créneaux édités est impair. Pour respecter la logique du RVL, un dernier créneau sera ajouté avec le mode (\"REDUIT\").",
	"dialog.rvl-even-slots.confirm": "Ajouter le créneau",
	"dialog.rvl-even-slots.title": "Ajouter un créneau automatiquement ?",
	"dialog.schedules.change-timezone.body": "Un seul fuseau horaire peut être utilisé dans une box. En modifiant le fuseau horaire de ce planning, la modification s'appliquera aux autres plannings.",
	"dialog.schedules.change-timezone.title": "Appliquer le changement de fuseau horaire ?",
	"dialog.schedules.change-used-states-info.body": "Les types de créneaux sont communs à tous les plannings d'une box. Les modifications seront visibles sur les autres plannings.",
	"dialog.schedules.change-used-states-info.title": "Modifier les types de créneaux ?",
	"dialog.schedules.request-trial.body": "La <b>gamme « Control »</b> offre de nouvelles fonctionnalités pour contrôler votre bâtiment. En commençant par la <b>planification</b>, vous pouvez définir des valeurs de consigne basées sur un programme horaire. <br />Vous pouvez <b>mettre à jour votre abonnement gratuitement pendant 30 jours</b>. <b>Après cette période de 30 jours</b>, si vous ne souhaitez pas bénéficier de Control, l'abonnement actuel de votre box sera rétabli. <br />L'activation n'est pas immédiate. Les nouvelles fonctionnalités seront disponibles dans les deux jours ouvrables et visibles sous l'onglet Configuration.",
	"dialog.schedules.request-trial.btn": "Essayer Control",
	"dialog.schedules.request-trial.cta": "Démarrer l'essai",
	"dialog.schedules.request-trial.success": "Nous avons bien reçu votre demande. Control sera bientôt disponible sur votre box.",
	"dialog.schedules.request-trial.title": "Essayer ”Control” gratuitement",
	"dialog.service-account.delete-service-account-body": "Cela supprimera définitivement le compte de service \"{name}\".",
	"dialog.service-account.delete-service-account-title": "Supprimer le compte de service",
	"dialog.temp-warning-max-property-count.body": "Le nombre de propriétés et de propriétés virtuelles, {current}, est supérieur au nombre total de propriétés incluses dans votre abonnement, {max}. Lors d'une prochaine modification de votre abonnement, cette configuration ne sera plus possible et le nombre total de propriétés devra être inférieur ou égal à la limite de votre abonnement. Vous pouvez envoyer la configuration telle quelle, mais après la modification à venir, elle ne sera plus possible.",
	"dialog.temp-warning-max-property-count.title": "Changement dans votre abonnement à venir",
	"dialog.unsaved-changed.body": "Vos modifications seront perdues si vous quittez sans sauvegarder.",
	"dialog.unsaved-changed.title": "Sauvegarder les modifications",
	"dialog.virtual-properties.delete-property-body": "Cette action supprime définitivement la propriété virtuelle \"{name}\".",
	"dialog.virtual-properties.delete-property-body.1": "Historique des valeurs enregitrées",
	"dialog.virtual-properties.delete-property-body.10": "Les alarmes basées sur cette propriété cesseront de fonctionner",
	"dialog.virtual-properties.delete-property-body.2": "Widgets de tableaux de bord basés sur cette propriété uniquement",
	"dialog.virtual-properties.delete-property-body.3": "Propriétés virtuelles basées sur cette propriété",
	"dialog.virtual-properties.delete-property-body.4": "Archives récurrentes contenant uniquement cette propriété",
	"dialog.virtual-properties.delete-property-body.5": "Cette propriété sera retirée :",
	"dialog.virtual-properties.delete-property-body.6": "des widgets de tableaux de bord contenant d'autres propriétés",
	"dialog.virtual-properties.delete-property-body.7": "des graphiques",
	"dialog.virtual-properties.delete-property-body.8": "des datastreams",
	"dialog.virtual-properties.delete-property-body.9": "des archives récurrentes contenant d'autres propriétés",
	"dialog.virtual-properties.delete-property-title": "Supprimer la propriété virtuelle",
	"dialog.wizard-gateway-exit.body": "En quittant cette page, l'ajout des propriétés ne sera pas pris en compte.",
	"dialog.wizard-gateway-exit.title": "Quitter la page ?",
	"different-lpb-related-data-formats": "Les différents formats de données liés à LPB pris en charge par la dernière version de l'appareil",
	"disable": "Désactiver",
	"disable-schedule-linked-to-items": {
		"linked-to-alarm-body": "Ce planning est utilisé dans une ou plusieurs alarmes ({alarms}).{br}Modifiez d'abord ces alarmes pour pouvoir désactiver ce planning.",
		"linked-to-automation-body": "Ce planning est utilisé dans un ou plusieurs scénarios ({scenarios}).{br}Modifiez d'abord ces scénarios pour pouvoir désactiver ce planning.",
		"title": "Impossible de désactiver le planning"
	},
	"disable-x-properties": "Désactiver 1 propriété | Désactiver {x} propriétés",
	"disabled": "Désactivé",
	"disabled-lorawan-tti-tooltip": "Vous ne pouvez pas rediriger ces propriétés car le serveur LoRaWAN n'est pas local",
	"discontinued-in": "suspendue en {date}",
	"display-name-in-console": "Nom dans la console",
	"do-not-update-equipment": "Uniquement l'équipement",
	"do-not-update-property": "Uniquement la propriété",
	"do-you-want-to-delete-connector": "Voulez-vous supprimer le connecteur {connector} ?",
	"documentation": "documentation",
	"does-it-end": "Est-ce que ça finit?",
	"doesnt-work-lorawan-because-lorawan-sensors-autonomous-decides-its-own-when-sends-data": "Il ne peut pas être utilisé avec le capteur LoRaWAN car il est autonome et décide de lui-même quand il envoie des données",
	"domain": "Domaine",
	"domain-box-on-lon-ip-network": "Le domaine de la @.lower:box sur le réseau IP LON",
	"dont-have-permission-to": "Vous n'êtes pas autorisé(e) à {action}",
	"dot-not-update-no-confidence": "En cas de doute, nous vous conseillons de ne pas appliquer les modifications aux passerelles.",
	"down": "KO",
	"downlink-topic": "Downlink topic",
	"download": "Télécharger",
	"download-configuration": "Télécharger la configuration",
	"download-desktop-app": "Téléchargez Desktop App",
	"download-license": "Télécharger la licence",
	"download-link": "Lien de Téléchargement",
	"download-the-error-report": "Téléchargez le rapport d'erreurs.",
	"download-the-error-report-and-restart": "Télécharger le rapport d’erreur et recommencer",
	"download-this-template": "Téléchargez ce template",
	"downloading-archive": "Téléchargement d'archives",
	"draft": "Brouillon",
	"draft-configuration": "Configuration de brouillon",
	"drag-drop-csv": "Glissez et déposez votre fichier CSV",
	"drag-drop-file-or-click": "Glissez et déposez votre fichier ou cliquez sur le bouton",
	"drag-drop-file-or-click-button": "Glissez et déposez votre fichier ou cliquez sur le bouton",
	"drag-drop-here": "Glissez et déposez votre fichier",
	"drag-file-here": "Glissez votre fichier ici",
	"drag-image-here": "Glissez-Déposez ou choisissez un fichier pour télécharger votre image. Tous les types de fichiers .png, .jpeg et .jpg sont pris en charge.",
	"duplicate": "Dupliquer",
	"duplicate-another-equipment": "Dupliquer un autre équipement",
	"duplicate-connector": "Dupliquer un connecteur",
	"duplicate-equipment": "Dupliquer l'équipement",
	"duplicate-lorawan-equipment": "Dupliquer l'équipement LoRaWAN",
	"duplicate-trigger": "Dupliquer un trigger",
	"duplicate.equipment.redirected-properties": "Dupliquer les propriétés redirigées",
	"duplicate.equipment.redirected-properties.tooltip": "Les propriétés de l'équipement sont copiées par défaut. Cette option permet de copier les propriétés redirigées vers une passerelle.",
	"duplicated": "Dupliqué ! | Dupliqués !",
	"duplicated-f": "Dupliquée ! | Dupliquées !",
	"duration": "Durée",
	"during": "Pendant",
	"ede.export.content.1": "Le fichier est disponible dans le dossier “Téléchargements” de votre navigateur.",
	"ede.export.content.2": "Pour sélectionnez les propriétés à ajouter à la configuration depuis le fichier :",
	"ede.export.content.3": "Dans la colonne “<strong>Selected</strong>”",
	"ede.export.content.4": "Indiquez par une croix : les propriétés à ajouter",
	"ede.export.content.5": "Laissez vide pour les propriétés à ignorer",
	"ede.export.content.6": "Sauvegardez les changements",
	"ede.export.content.7": "Importez le fichier",
	"ede.export.note": "Note : modifiez uniquement la colonne “Selected”, les autres changements sont ignorés. Une fois ajoutées à la configuration, les propriétés pourront être modifiées en masse.",
	"ede.export.properties.successfull": "Résultat du scan",
	"ede.export.scanned.properties": "Exporter les propriétés scannées",
	"ede.export.waiting.scan": "Veuillez attendre la fin du scan pour réaliser l’export des propriétés",
	"edit": "Éditer",
	"edit-box": "Modifier la @.lower:_box",
	"edit-configuration": "Éditer la configuration",
	"edit-connector": "Editer un connecteur",
	"edit-equipment-new-tab": "Ouvrir les propriétés de l'équipement dans un nouvel onglet",
	"edit-event": "Modifier l'événement",
	"edit-indicator": "Modifier l'indicateur",
	"edit-properties": "Modifier les propriétés",
	"edit-property": "Modifier la propriété",
	"edit-trigger": "Editer un trigger",
	"edit-value": "Éditer la valeur",
	"edit-widget": "Éditer l'élément",
	"effective-period": "Période effective",
	"effective-period-invalid-range": "Les jours de début et de fin doivent être cohérents",
	"element-affected": "Élément affecté : | Éléments affectés :",
	"element-deleted": "Élément supprimé : | Éléments supprimés :",
	"email": "E-mail",
	"email-to": "E-mail à",
	"empty-state": {
		"alarms": {
			"action": "Créer une alarme",
			"description": "Soyez alerté par email ou sms si un comportement non attendu survient grâce à la mise en place de télé-alarmes. Liez-les à un planning pour une gestion optimale.",
			"title": "Gardez le contrôle de votre bâtiment"
		},
		"archives": {
			"action": "Demander une archive",
			"description": "Demandez une archive pour recevoir les données collectées par votre box et réaliser une analyse sur-mesure du fonctionnement de votre bâtiment.",
			"title": "Exportez les données des équipements"
		},
		"automation": {
			"action": "Créer un scénario",
			"description": "Envoyez automatiquement une nouvelle consigne à un équipement ou modifiez le créneau d'un planning en fonction des valeurs des propriétés reçues..",
			"title": "Automatisez le fonctionnement de votre bâtiment"
		},
		"dashboards": {
			"action": "Créer un dashboard",
			"description": "Observez en temps réel les valeurs des propriétés de vos équipements sur un synoptique. Construisez des tableaux de bord avec vos indicateurs clés et le planning de vos équipements.",
			"new-dashboard": {
				"description": "Construisez votre tableau de bord avec des éléments graphiques pour visualiser l'état de votre bâtiment en temps réel",
				"title": "Créer un dashboard"
			},
			"schematic": {
				"description": "Glissez et déposez un fond de plan ou schéma technique au format PNG ou JPEG pour y positionner ensuite vos propriétés.",
				"title": "Créer un synoptique"
			},
			"title": "Visualisez l'état de votre bâtiment"
		},
		"graphs": {
			"action": "Créer un graph",
			"action-temp": "Sélectionner une propriété ↓",
			"description": "Suivez et analysez la valeur d'une ou plusieurs propriétés dans le temps.",
			"title": "Suivez l'évolution de votre bâtiment"
		},
		"schedules": {
			"control": {
				"action": "Créer un planning",
				"description": "Renseignez dans un planning l'occupation de votre bâtiment puis utilisez-le pour automatiquement écrire des valeurs dans des propriétés.",
				"title": "Pilotez vos équipements avec une programmation horaire"
			},
			"no-control": {
				"action": "Créer un planning",
				"description": "Renseignez dans un planning l'occupation de votre bâtiment puis utilisez-le pour moduler vos alarmes.",
				"title": "Déclarez l'occupation de votre bâtiment"
			}
		},
		"settings": {
			"equipments": {
				"action": "Ajouter des équipements",
				"description": "Déclarez votre premier équipement puis envoyez ensuite la configuration à la box pour l'ajouter définitivement.",
				"title": "Bienvenue dans la configuration de votre box"
			},
			"gateways": {
				"action": "Créer une passerelle",
				"description": "Configurez une passerelle puis sélectionnez des propriétés pour utiliser la box comme BACnet serveur ou Modbus serveur ainsi que pour envoyer les données à un broker MQTT.",
				"title": "Transférez les données reçues"
			},
			"networks": {
				"action": "Ajouter un réseau",
				"description": "Ajoutez votre réseau BACnet, KNX, LoRaWAN, M-Bus ou Modbus. La box communiquera comme client sur les réseaux BACnet ou Modbus. Pour configurer la box comme serveur, allez dans \"Passerelles\".",
				"title": "Paramétrez votre premier réseau"
			},
			"virtual-properties": {
				"action": "Créer une propriété virtuelle",
				"description": "Calculez des consommations ou réalisez des calculs à partir de propriétés existantes.",
				"title": "Créez des propriétés à partir de propriétés existantes"
			}
		}
	},
	"enable": "Activer",
	"enable-edition-of-network-configuration": "Activer l'édition de la configuration réseau",
	"enable-plural": "activée | activées",
	"enable-temporization-msg": "Fermer automatiquement l'alarme quand l'état revient à la normale",
	"enable-temporization-tooltip": "Si la condition n'est plus observée avec un nombre d'occurences équivalent à celui nécessaire pour déclencher l'alarme et pendant le même intervalle alors l'alarme est fermée ainsi que son historique.",
	"enable-x-properties": "Activer 1 propriété | Activer {x} propriétés",
	"enabled": "Activé",
	"encryption": "Encryption",
	"end": "Fin",
	"end-date": "Date de fin",
	"end-time": "Temps de fin",
	"ending": "fin le",
	"english": "Anglais",
	"enter-brand-model-or-select-from-list": "Entrez la marque ou le modèle ou sélectionnez dans la liste",
	"enter-code-list-codes-or-enter-asterisks-to-any-code": "Renseignez un code {url}. Ou renseignez '*' pour être notifié pour n'importe quel code.",
	"equipment": "Équipement",
	"equipment-bulk-create-import-csv-msg1": "L'ajout d'équipements en masse est uniquement disponible pour des équipements qui utilisent le <strong>LoRaWAN</strong> et qui sont inlcus dans notre <strong>bibliothèque d'équipements décodés</strong>.",
	"equipment-bulk-create-import-csv-msg2": "La liste des équipements doit respecter un format précis. {template} et complétez le avec les équipements désirés.",
	"equipment-bulk-create-network-existing-msg": "Un réseau LoRaWAN existe déjà. Si vous modifiez sa configuration, il modifiera également les équipements qui lui sont rattachés. Si vous souhaitez modifier la configuration du réseau, cliquez sur le bouton ci-dessous.",
	"equipment-bulk-create-network-msg": "Vous n'avez pas encore créé de réseau LoRaWAN. Merci d'en créer un avant de procéder à la création des équipements. Les nouveaux équipements utiliseront ce réseau",
	"equipment-creation": "Création des équipments",
	"equipment-creation-mapping-msg": "Veuillez associer à chaque modèle issue de votre fichier la référence correspondante",
	"equipment-deleted": "Équipement supprimé | Équipements supprimés",
	"equipment-discriminator": "Discriminateur de l'équipement",
	"equipment-discriminator-description": "Informations identifiant l'équipement : DevEUI pour LoRaWAN, Device Instance pour BACnet, etc.",
	"equipment-duplicated-successfully": "Équipement dupliqué avec succès",
	"equipment-id": "ID de l'equipment",
	"equipment-name": "Nom de l'équipement",
	"equipment-plural": "Équipement | Équipements",
	"equipment-properties": "Propriétés de l'équipement",
	"equipment-required": "L'équipement est requis",
	"equipment-status-indicator-info-tooltip-txt": "KO : aucune donnée reçue au cours de la dernière heure (24 heures pour les équipements LoRaWAN) <br />- : L'état de la connexion n'est pas connu pour cet équipement",
	"equipment-with-mbus-protocol": "Equipement avec protocole MBUS",
	"equipment-with-modbus-serial-protocol": "Équipement avec protocole Modbus RTU",
	"equipment-with-percentage-scan-refresh-to-update": "Équipement avec {percentage} % scan terminé. Actualiser le scan pour mettre à jour.",
	"equipment-x-saved": "{n} équipement enregistré | {n} équipements enregistrés",
	"equipments": "Équipements",
	"equipments-properties": "Propriétés des équipements",
	"equipments-status-to-be-checked-and-alarm-raised": "Perte de connexion avec l'équipement",
	"equipments.bms": "GTB",
	"equipments.meters": "Compteurs",
	"equipments.others": "Autres",
	"error-communicating-with-hub-reception-properties-values-not-available": "Erreur lors de la communication avec la @.lower:{'hub'}. Il n'est pas possible de recevoir les valeurs des propriétés.",
	"error-field-hexadecimal-length": "{field} doit comporter {characters} caractères hexadécimaux MAJUSCULES.",
	"error-occured": "Une erreur est survenue. Veuillez réessayer.",
	"error-occured-status-equipment": "Erreur lors de la récupération des statuts d'équipements. Veuillez réessayer plus tard.",
	"error.min-1-character": "Le champ doit contenir au moins 1 caractère.",
	"errors": "Les erreurs",
	"even-months": "Mois pairs",
	"event": "Événement",
	"event-code-0-999": "Générique",
	"event-code-0-999-range": "Générique (0 to 999)",
	"event-code-1000-1999": "Configuration",
	"event-code-1000-1999-range": "Configuration (1000 to 1999)",
	"event-code-2000-2999": "Réseau",
	"event-code-2000-2999-range": "Réseau (2000 to 2999)",
	"event-code-3000-3999": "Équipement",
	"event-code-3000-3999-range": "Équipements (3000 to 3999)",
	"event-code-4000-4999": "Propriété",
	"event-code-4000-4999-range": "Propriétés (4000 to 4999)",
	"event-code-5000-5999": "Équipement",
	"event-code-5000-5999-range": "Équipements (5000 to 5999)",
	"events-route": "Route events",
	"events-url": "URL des événements",
	"every-time-alarm-history-item-is-created": "Au déclenchement d'une alarme dans la console",
	"every-time-event-matching-code-received-on-console": "À la réception d'un événement dans la console avec le code correspondant",
	"every-time-value-property-received-on-console": "À la réception d'une nouvelle valeur pour une propriété dans la console",
	"exception": "Exception",
	"existant-graph": "Graphique existant",
	"expand-button-equipment-tooltip": "Etendre tous les équipements",
	"expand-button-groups-tooltip": "Etendre tous les groupes",
	"expand-button-organization-tooltip": "Etendre toutes les organisations",
	"expand-collapse": "Etendre/Fermer",
	"expected": "Attendues",
	"expected-value": "Valeur attendue",
	"expiration-date": "Date d'expiration",
	"expired": "Expiré",
	"expires-on": "Expire le",
	"export": "Exporter",
	"export-configuration": "Exporter la configuration",
	"export-ede-csv": "Export EDE (csv)",
	"export-ede-xlsx": "Export EDE (xlsx)",
	"export-file": "Exporter le fichier",
	"export-properties": "Exporter les propriétés",
	"extended-time-max-format": "\"24:00\" est la dernière valeur autorisée",
	"extended-time-seconds-max-format": "\"24:00:00\" est la dernière valeur autorisée",
	"external": "Externe",
	"external-id": "ID externe",
	"external-recipient": "Le destinataire n'a pas ou n'aura pas accès à la console",
	"fail": "Erreur",
	"fail-copying-to-clipboard": "Échec de la copie dans le presse-papiers",
	"failed": "Échoué",
	"failed-activating-box": "Échec de l'activation de la @.lower:box",
	"failed-adding-privileges-to-user": "Échec de l'ajout de privilèges à l'utilisateur",
	"failed-adding-property": "Échec de l'ajout de la propriété : {property}",
	"failed-bacnet-scan-autodiscovery": "Échec de l'obtention du BACnet Scan. Veuillez vérifier votre configuration.",
	"failed-creating-draft-refresh-page": "Échec de la création du brouillon. Rafraîchissez la page s'il vous plaît.",
	"failed-creating-equipment": "Erreur lors de la création des équipements. Téléchargez le fichier d'origine avec les messages d'erreur. Utilisez-le ensuite à l'étape 1 pour conserver la correspondance de chaque équipement avec sa référence.",
	"failed-creating-gateway-properties": "Échec de la création des propriétés Gateway",
	"failed-creating-new": "Échec de la création de {thing}",
	"failed-creating-organization": "Échec de la création d'une nouvelle organisation",
	"failed-creating-params-to-save-network": "Échec de la création de paramètres pour enregistrer le réseau",
	"failed-creating-properties": "Erreur lors de la création des propriétés. Téléchargez le fichier d'origine avec les messages d'erreur.",
	"failed-deleting-certificate": "Échec de la suppression du certificat",
	"failed-deleting-connector": "Échec de la suppression du connecteur",
	"failed-deleting-equipment": "Échec de suppression de l'équipement",
	"failed-deleting-rate-plan": "Échec de la suppression du rate plan",
	"failed-downloading-archive-request-it-again": "Échec du téléchargement de l'archive, veuillez en demander une nouvelle.",
	"failed-downloading-desktop-app": "Impossible de télécharger l'application de bureau",
	"failed-downloading-equipment-list": "Échec du téléchargement de la liste d'équipements",
	"failed-downloading-license": "Echec du téléchargement de la licence",
	"failed-duplicating-equipment": "Échec de la duplication de l'équipement",
	"failed-duplicating-trigger": "Échec de la duplication du trigger {name}",
	"failed-exporting-hub-configuration": "Échec de l'exportation de la configuration de la @.lower:hub",
	"failed-get-draft-config": "Échec d'obtention de la configuration de brouillon",
	"failed-get-graph": "Échec d'obtention des graphiques",
	"failed-get-networks-from-connectors": "Échec d'obtention des réseaux à partir des connecteurs",
	"failed-getting-alarms": "Échec de l'obtention des alarmes",
	"failed-getting-alarms-history": "Échec de l'obtention de l'historique des alarmes",
	"failed-getting-archives": "Échec de l'obtention des archives",
	"failed-getting-available-bacnet-data-types": "Échec de l'obtention des types de données BACnet disponibles",
	"failed-getting-available-networks": "Échec de l'obtention des réseaux disponibles",
	"failed-getting-connectors-configuration": "Impossible d'obtenir la configuration des connecteurs",
	"failed-getting-current-configuration": "Échec de l'obtention de la configuration actuelle",
	"failed-getting-encoders-configuration": "Échec de l'obtention de la configuration des encodeurs",
	"failed-getting-equipment-info": "Échec d'obtention des informations de l'équipement",
	"failed-getting-equipment-list": "Échec d'obtention de la liste d'équipements",
	"failed-getting-equipment-protocol-config": "Échec d'obtention de la configuration du protocole de l'équipement",
	"failed-getting-list-of-available-files": "Échec de l'obtention de la liste des fichiers disponibles",
	"failed-getting-list-of-lorawan-codecs": "Échec de l'obtention de la liste des codecs LoRaWAN",
	"failed-getting-lon-types": "Échec d'obtention des types LON SNVT à partir de l'API",
	"failed-getting-notifications": "Échec d'obtention des notifications",
	"failed-getting-orgaizations": "Échec de l'obtention des organisations",
	"failed-getting-organization": "Échec de l'obtention de l'organisation",
	"failed-getting-properties": "Échec d'obtention des propriétés",
	"failed-getting-property-last-value": "Échec de l'obtention de la dernière valeur définie de la propriété",
	"failed-getting-your-profile": "Échec de la récupération de votre profil",
	"failed-importing-configuration": "Échec de l'importation de la configuration",
	"failed-inspecting-command-wait-please": "Échec de la commande d'inspection reçue par @.lower:box .Attendez s'il vous plaît",
	"failed-loading-scan": "Échec du chargement du scan",
	"failed-refreshing-scan": "Échec de l'actualisation de le Scan",
	"failed-request-scan": "Échec de la demande de Scan vers la @.lower:box",
	"failed-reverting-sent-changes": "Échec de la restauration des modifications envoyées",
	"failed-saving-connector": "Échec d'enregistrement du connecteur",
	"failed-saving-gateway": "Échec de l'enregistrement de la passerelle",
	"failed-saving-new-name": "Échec de la sauvegarde du nouveau nom",
	"failed-saving-property": "Échec de l'enregistrement de la propriété",
	"failed-saving-route": "Échec d'enregistrement de la route",
	"failed-saving-trigger": "Échec de l'enregistrement du trigger",
	"failed-sending-license": "Échec de l'envoi de la licence",
	"failed-setting-value": "Échec de la définition de la nouvelle valeur",
	"failed-updating-alarm-event": "Échec de la mise à jour de l'événement d'alarme",
	"failed-updating-alarm-priority": "Échec de la mise à jour de la priorité d'alarme",
	"failed-updating-alarm-status": "Échec de la mise à jour de l'état de l'alarme",
	"failed-updating-file": "Échec de la mise à jour du fichier",
	"failed-updating-organization": "Échec de la mise à jour de l'organisation",
	"failed-updating-permission-not-authorized": "Échec de la mise à jour des autorisations. Vous n'êtes pas autorisé(e) à faire ça.",
	"failed-updating-properties-with-gateway-redirection": "Échec de la mise à jour des propriétés avec la redirection des propriétés de la passerelle",
	"failed-updating-user-password": "Échec de la mise à jour du mot de passe",
	"failed-updating-user-profile": "Échec de la mise à jour du profil utilisateur",
	"failed-uploading-file": "Échec du téléchargement du fichier",
	"failed-validating-equipment": "Échec de la validation de l'équipement : {message}",
	"failed-validating-network": "Echec de la validation du réseau : {message}",
	"field": "Champ",
	"field-is-required": "Le champ {field} est obligatoire",
	"field-must-be-a-decimal": "Le champ {field} doit être une décimale",
	"field-must-be-format": "Le champ doit être au format : {format}",
	"field-must-have-x-digits": "Le champ doit avoir au plus {digit} décimales",
	"field-should-be-between-values": "Le champ {field} doit être entre {min} et {max}",
	"field-should-be-number-or-null": "Le champ {field} doit être un nombre ou vide",
	"field.required": "Ce champ est requis",
	"fields-are-required": "Tous les champs ne sont pas remplis",
	"file": "Fichier",
	"file-format": "Format du fichier",
	"file-input-description": "Format accepté : .json",
	"file-saved": "Fichier enregistré",
	"file-too-big": "Fichier trop volumineux",
	"file-too-big-size": "Fichier trop volumineux, il ne doit pas dépasser {sizeMB} Mo",
	"file-type": "Type de fichier",
	"file-visibility": "Visibilité du fichier",
	"filter": "Filtrer",
	"filter-group-or-equipment": "Rechercher un groupe ou un equipement",
	"filters": "Filtres",
	"final-url": "URL finale",
	"find-equipment-want-to-connect-to-box": "Trouver l'équipement à connecter à la @.lower:box .",
	"finished": "Terminé",
	"finished-at": "Terminé à",
	"firewall-disabled-allow-usb-connection": "Le firewall est désactivé pour permettre la connexion USB",
	"first-visit": "Premiere visite ?",
	"fix-setpoint": "Fixer la consigne",
	"for-each-character-of-the-identification-number-enter-a-digit-between-0-and-9-or-the-letter-F-for-any-digit": "Pour chaque caractère du numéro d'identification, indiquer un chiffre entre 0 et 9, ou la lettre ‘F' pour \"n'importe quel chiffre\".",
	"forgot-password": "Mot de passe oublié?",
	"format": "Format",
	"formula-editor": {
		"help-message": "Liste des opérateurs autorisés : {operatorList}. Utiliser {point} pour les nombres décimaux. Saisir {mention} pour utiliser une propriété.",
		"invalid-message": "Calcul invalide. Utilisez des {'@'}propriétés, opérateurs et nombres."
	},
	"found": "Trouvé",
	"free-form-date-label": "Date de début ou date de fin du congé",
	"free-form-date-optional-month-help": "Si le mois n'est pas définie, le congé se répétera chaque mois à cette date.",
	"free-form-date-optional-year-help": "Si l'année n'est pas définie, le congé se répétera chaque année à cette date.",
	"free-form-date-time-help-msg-lpb": "Le mode protection ou le mode vacances s'applique pendant la période de congés.",
	"free-form-time-help": "Si la minute et/ou la seconde ne sont pas définies, la valeur par défaut est 0.",
	"free-form-time-label": "Heure de début ou heure de fin pour ce congé",
	"french": "Français",
	"frequency": "Fréquence",
	"friday": "Vendredi",
	"from": "À partir de",
	"from-bacnet-scan": "À partir du scan BACnet",
	"full-name": "Nom et prénom",
	"full-scan-in-the-network": "Scan complet du réseau",
	"function": "Fonction",
	"function-secondary": "Fonction secondaire",
	"gateway": "Passerelle",
	"gateway-id": "ID de la passerelle",
	"gateway-ip-address": "Adresse IP de la passerelle",
	"gateway-name": "Nom de la passerelle",
	"gateway-properties": "Propriétés de la passerelle",
	"gateway-properties-saved": "Propriétés de la passerelle enregistrées",
	"gateway-saved": "Passerelle enregistrée",
	"general-settings": "Paramètres généraux",
	"generic.no-unit.help-message": "Renseignez un texte ou un nombre. N'indiquez pas l'unité. Utilisez {dot} avec les nombres décimaux.",
	"german": "Allemand",
	"go-to-box": "Accéder au @.capitalize:client-name-box",
	"go-to-history": "Historique",
	"go-to-hub": "Accéder au @.capitalize:client-name-hub",
	"go-to-properties-list": "Accéder à l'écran de configuration des propriétés",
	"good": "Bon",
	"graph-name": "Nom du graphique",
	"graph.chart-type": "Type de graphique",
	"graph.export.data": "Exporter les données",
	"graph.export.graph-image": "Exporter une image",
	"graph.export.selected-data": "Les données sélectionnées",
	"graphs.apply-to-properties": "Appliquer aux propriétés",
	"graphs.axe-y": "Axe Y",
	"graphs.convert-to-virtual-property": "Transformer en propriété virtuelle",
	"graphs.marker": "Marqueur",
	"graphs.remove-property": "Supprimer la propriété",
	"graphs.select-interval": "Choisir un intervalle",
	"graphs.turns-into-interval-consommation": "Appliquer un delta",
	"group": "Groupe",
	"group-address": "Adresse du groupe",
	"group-already-exists": "Le groupe existe déjà.",
	"group-data-by": "Générer un fichier par",
	"group-equipment": "Grouper les équipements",
	"groups": "Groupes",
	"hang-in-there-we-are-loading-properties-and-can-take-some-minutes": "Accrochez-vous, s'il vous plaît ! \nNous chargeons toutes les propriétés et cela peut prendre quelques minutes !",
	"hardware": "Hardware",
	"hardware-id": "Hardware ID",
	"heating-optimiser": "Optimiseur de Relance",
	"help-accordion.property-scaling-applied.body": "Une mise à l'échelle de type “ax + b” (a={scalingA}; b={scalingB}) est appliquée dans la configuration de la propriété.",
	"hide-side-panel": "Masquer le volet",
	"higher-bound": "Borne supérieure",
	"history": "Historique",
	"hour": "Heure",
	"hour-plural": "Heure | Heures",
	"hourly": "Horaire",
	"hours": "Heures",
	"how-to-address-equipment": "Comment adresser l'équipement",
	"how-to-find-hardware-id": "Comment trouver votre hardware id ?",
	"how-to-run-the-scan": "Comment lancer le scan ?",
	"hub": "@.clientname:_generic",
	"hub-configuration": "Configuration de la @.lower:box",
	"hub-doesnt-have-current-configuration": "Le @.lower:box n'a pas de configuration actuelle",
	"hub-offline": "@.capitalize:hub hors ligne",
	"hub-online": "@.capitalize:hub en ligne",
	"hub-status-checker": "Vérificateur d'état du @.capitalize:client-name-hub",
	"hub-successfully-connected": "@.capitalize:client-name-hub connecté avec succès",
	"hubs": "@.clientname:_generic-plural",
	"id": "ID",
	"id-number": "ID number",
	"identification-number": "Numéro d'identification",
	"if": "Si",
	"if-alert-notify-24-hours": "Même si l'alarme se déclenche plusieurs fois, notifications espacées de 24h",
	"if-alert-notify-X": "Même si l'alarme se déclenche plusieurs fois, notifications espacées de {X}",
	"if-alert-notify-once": "Uniquement au premier déclenchement de l'alarme",
	"if-alert-notify-weekly": "Même si l'alarme se déclenche plusieurs fois, recevoir une notification par semaine",
	"if-box-located-europe": "Si @.lower:box est situé en <strong>Europe</strong>",
	"if-box-located-north-america": "Si @.lower:box est situé en <strong>Amérique du Nord</strong>",
	"if-cant-find-equipment-request-it-click": "Si vous ne trouvez pas l'équipement, demandez-nous de le rajouter en cliquant ici !",
	"if-priotity-any-notify": "Toutes les sévérités",
	"if-priotity-critical-notify": "Critique uniquement",
	"if-priotity-standard-notify": "Standard uniquement",
	"if-there-are": "S'il existe",
	"if-use-for-temporization": "Retour à normale inclus",
	"import": "Importer",
	"import-again": "Veuillez recommencer l'import",
	"import-configuration": "Importer la configuration",
	"import-errors.properties": "Erreur lors de la création des propriétés. Téléchargez le fichier d'origine avec les messages d'erreur.",
	"import-load-success": "Le fichier a été chargé",
	"import-properties": "Importer les propriétés sélectionnées",
	"import-success": "Votre fichier a été importé avec succès",
	"import.properties.title": "Importer les propriétés à sélectionner",
	"in": "en",
	"in-the-box": "Synchronisé avec la @.lower:box",
	"inactive-hub": "@.capitalize:hub inactif",
	"indicate-a-digit-between-0-9-or-F-for-any-digit": "Indiquer un chiffre entre 0 et 9 ou la lettre 'F' pour \"n'importe quel caractère\".",
	"indicate-period-in-days": "Indiquez la période en jours",
	"indicator-name": "Libellé",
	"individual-address": "Adresse individuelle",
	"individual-address-knx-lte-tooltip": "Adresse individuelle du périphérique KNX à lire. Il a le format suivant #x.#y.#z où #x, #y et #z sont des nombres positifs.",
	"individual-address-should-be-xyz": "L'Adresse individuelle a le format suivant #x.#y.#z où #x, #y et #z sont des nombres positifs",
	"inform-valid-email": "Renseignez une adresse e-mail valide",
	"insert-property": "Insérer une propriété",
	"insert-valid-name": "Insérer un nom valide",
	"instance": "Instance",
	"inter-frame-delay": "Délai inter-trame",
	"inter-frame-delay-tooltip": "Le délai d'attente en microsecondes après l'envoi d'une image",
	"interface": "Interface",
	"internal": "Interne",
	"internal-address": "Adresse interne",
	"internal-error-request-new-scan": "Ops! Nos serveurs ont renvoyé une erreur interne! Peut-être demander un nouveau scan!",
	"internal-recipient": "Le destinataire a déjà accès à la console",
	"internal-to-siemens": "Interne à Siemens",
	"interval": "Intervalle",
	"interval-s": "Intervalle (s)",
	"interval-seconds": "Intervalle (secondes)",
	"interval-seconds-tooltip": "Le nombre de secondes entre deux interrogations de données. Ceci est utilisé par la @.lower:box lors de la lecture des données de l'équipement.",
	"intervals-disabled-when-aggregation-enabled": "Veuillez désactiver l'aggrégation pour appliquer un delta",
	"invalid-ip-address": "Adresse IP invalide",
	"invalid-phone-format": "Format du numéro de téléphone non valide",
	"invalid-value-type": "Type de valeur invalide",
	"iot": "IoT",
	"ip-address": "Adresse IP",
	"ip-address-of-gateway-non-mandatory": "L'adresse IP de la passerelle, non obligatoire",
	"ip-address-on-cird-notation": "L'adresse IP y compris le sous-réseau sur la notation CIDR (XXX.XXX.XXX.XXX). L'adresse indiquée doit être valide à l'intérieur de votre réseau. \nCe champ est obligatoire si la méthode est manuelle.",
	"ipv4-address": "Adresse IP",
	"ipv4-method": "Méthode IPv4",
	"issued-on": "Date d'émission",
	"it should-be-one-of-those-options": "Il devrait s'agir de l'une de ces options : {options}",
	"it-is-not-possible-specify-first-character": "Le premier caractère ne peut pas être modifié.",
	"it-will-be-deleted-when-configuration-sent-to-box": "Il sera supprimé lorsque la configuration sera envoyée à @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-connector": "Ce connecteur sera supprimé lorsque la configuration sera envoyée à @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-equipment": "L'équipement sera supprimé lorsque la configuration sera envoyée à @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-gateway": "Cette passerelle sera supprimée lorsque la configuration sera envoyée à @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-network": "Ce réseau sera supprimé lorsque la configuration sera envoyée à @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-property": "La propriété sera supprimée lorsque la configuration sera envoyée à @.lower:box",
	"keep-the-old-scan": "Garder l'ancien scan",
	"key": "Clé",
	"key-name": "Key name",
	"key-sent-with-data-check-integrity-message": "Clé envoyée avec les données pour confirmer le message",
	"key-type": "Key type",
	"key-value": "Key value",
	"known": "Acquitté",
	"knx-60001-mode-0": "Anti-légionelles",
	"knx-60001-mode-1": "Normal",
	"knx-60001-mode-2": "Réduit",
	"knx-60001-mode-3": "Arrêt/Protection gel",
	"knx-60002-mode-0": "Arrêt",
	"knx-60002-mode-1": "Marche",
	"knx-default-mode": "Défaut",
	"knx-other-mode-0": "Confort",
	"knx-other-mode-1": "Préconfort",
	"knx-other-mode-2": "Economie",
	"knx-other-mode-3": "Fonction de protection",
	"language": "Langue",
	"language-english": "Anglais",
	"language-french": "Français",
	"language-german": "Allemand",
	"last-7-days": "Les 7 derniers jours",
	"last-activation-event": "Dernier événement d'activation",
	"last-alert-at": "Dernière alerte le",
	"last-digits-after--": "Derniers chiffres après -",
	"last-edited-at": "Dernière modification : {date}",
	"last-read-value-data": "Dernière valeur lue : {value} {unit}{asterisk}",
	"last-read-value-time": "Dernière valeur lue {time}",
	"last-token": "Dernier jeton",
	"last-value": "Dernière valeur",
	"last-value-receive": "Dernière valeur reçue",
	"last-value-receive.at-date": "Dernière vérification il y a {since} <span class=\"has-text-grey-400\">({date})</span>",
	"last-value.applied-scaling": "Mise à l'échelle (ax+b) : a={scalingA}; b={scalingB}",
	"last-values": "Dernières valeurs",
	"last-written-value-data": "Dernière valeur écrite : {value} {unit}{asterisk}",
	"last-written-value.scaling-not-applied": "la mise à l'échelle n'est pas appliquée à l'écriture de la valeur",
	"latest-configuration-from-console-advice-download-and-upload-here": "La dernière configuration stockée dans votre équipement a été éditée depuis la console web. Avant de procéder à des changements, nous vous conseillons de télécharger la configuration depuis cette-dernière et de la charger ici",
	"latest-configuration-from-da-advice-download-and-upload-here": "La dernière configuration stockée dans votre équipement a été éditée depuis l'application Windows. Avant de procéder à des changements, nous vous conseillons de télécharger la configuration depuis cette-dernière et de la charger ici. Sans quoi l'activation de la réception des données ne permettra pas de visualiser les valeurs propriétés",
	"latest-scan-dates-from-timestamp": "Le dernier scan date du {timestamp}.",
	"launch-the-scan": "Lancer le scan",
	"learn-more": "En savoir plus",
	"leave": "Quitter",
	"leave-page": "Quitter la page",
	"left": "Gauche",
	"left-ethernet-port": "Port Eth gauche",
	"license": "Licence",
	"license-sent-successfully": "Licence envoyée avec succès",
	"license.expired": "Licence expirée",
	"license.expiring.soon": "Licence bientôt expirée",
	"license.paired": "Licence associée",
	"license.suspended": "License suspendue",
	"license.unpair": "Dissocier la licence de la box",
	"license.unpair.modal-content": "Cette action dissocie la licence de la box \"{device}\". Les changements suivants se produiront :",
	"license.unpair.modal-content.activate": "Si la box est activée :",
	"license.unpair.modal-content.immediate": "Les changements prennent effet immédiatement.",
	"license.unpair.modal-content.list.1": "La box et la licence deviennent disponibles pour une nouvelle association",
	"license.unpair.modal-content.list.2": "Les dates de début et de fin de la licence sont supprimées",
	"license.unpair.modal-content.list.3": "Le statut de la box passe à INACTIF",
	"license.unpair.modal-content.list.4": "La configuration de la box est conservéee",
	"license.unpaired": "Licence et box dissociées",
	"licenses": "Licences",
	"lift": "Lift",
	"line": "Lignes droites",
	"line-type": "Type de ligne",
	"linked-schedule": "Planning associé",
	"list-boxes-in-scope-of-trigger": "Liste des @.lower:boxes ciblées par le trigger",
	"list-of-addresses-1-to-255": "Liste des adresses (1 à 255)",
	"list-of-alarms": "Liste des alarmes",
	"list-of-codes": "liste des codes",
	"list-of-equipment": "Liste des équipements",
	"list-of-mask-addresses": "Liste des adresses de masque",
	"list.devices": "listes des boxes",
	"live-data": "Données live",
	"live-data-open-chart": "Ouvrir le graphique avec les dernières valeurs",
	"loading": "Chargement",
	"loading-logs": "Chargement des logs",
	"loading-scan": "Chargement du Scan",
	"loading-scan-can-take-up-to-x-minutes": "Chargement du scan. Cela peut prendre jusqu'à {minutes} minutes",
	"location": "Emplacement",
	"logical-operator": "Opérateur logique",
	"login": "Se connecter",
	"logout": "Déconnexion",
	"logs": "Logs",
	"logs-events-msg": "Les événements sont des informations en temps réel envoyées par la @.lower:box en dehors de l'envoi des valeurs des propriétés. Ils peuvent vous aider à analyser de plus près un comportement si vous remarquez quelque chose d'inattendu. <a href=\"/list-events-code\" target=\"_blank\">Voir la liste des codes d'événements et leur signification.</a><br />Exemples d'événements:<br />- 4004 : la propriété de l'équipement LoRaWAN qui reçoit un downlink a accusé réception d'un nouveau message<br />- 5001 : erreur de décodage du message LoRaWAN<br />- 5004 : downlink LoRaWAN envoyé du serveur à l'équipement<br />- 5005 : downlink LoRaWAN perdu (non envoyé à l'équipement)",
	"logs-section": {
		"campaign-progress-status": {
			"FAILED": "en erreur",
			"PROCESSING": "en cours",
			"RECEIVED_BY_EQUIPMENT": "reçue | reçues",
			"UNKNOWN": "sans réponse"
		},
		"campaign-progress-status-desc": {
			"FAILED": "{count} commande en erreur | {count} commandes en erreur",
			"PROCESSING": "{count} commande en cours de traitement | {count} commandes en cours de traitement",
			"RECEIVED_BY_EQUIPMENT": "{count} commande reçue par l'équipement | {count} commandes reçues par les équipements",
			"UNKNOWN": "{count} commande sans réponse | {count} commandes sans réponse"
		},
		"campaign-status": {
			"COMPLETED": "Terminée",
			"IN_PROGRESS": "En cours"
		},
		"campaign-status-desc": {
			"COMPLETED": "Campagne terminée",
			"IN_PROGRESS": "Campagne en cours"
		},
		"campaigns": {
			"campaign-details": {
				"created-by": "Créée par :",
				"description": "Description :",
				"model-name": "Modèle :",
				"on-datetime": "le {datetime}",
				"title": "Liste des commandes de la campagne : {campaignName}"
			},
			"column-commands": "Commandes",
			"column-progress": "Progression",
			"column-progress-tooltip": "Consultez l'état d'avancement de vos campagnes d'envoi de commandes LoRaWAN en masse",
			"column-reference": "Modèle",
			"commands": "Commandes",
			"create": "Créer une campagne",
			"empty-state": {
				"description": "Lancez une campagne d'envoi de commandes LoRaWAN en masse et visualisez sa progression.",
				"title": "Suivez vos campagnes d'envoi de commandes LoRaWAN"
			}
		},
		"command-associated-description": "Description associée",
		"command-failed-reason": {
			"CORE_COMMAND_EXPIRED": "La commande a expiré : l'équipement n'a pas reçu la commande ou la @.lower:box n'a pas reçu la réponse.",
			"CORE_QUEUE_OVERRUN": "Le réseau est surchargé. Réduisez le nombre de commandes.",
			"INTERNAL_ERROR": "Une erreur technique s'est produite. Réessayez ultérieurement.",
			"INVALID_PAYLOAD": "La valeur saisie n'est pas valide.",
			"LORA_CODEC_ERROR": "L'équipement n'est pas supporté techniquement ou la valeur saisie n'est pas valide.",
			"LORA_QUEUE_FLUSHED": "La commande a été remplacée par une nouvelle commande avant d'être envoyée.",
			"NETWORK_ERROR": "Une erreur réseau s'est produite lors de l'envoi de la commande.",
			"NETWORK_TIMED_OUT": "Le délai d'attente du réseau a été dépassé. L'équipement n'a pas répondu à temps.",
			"SCALING_ERROR": "La valeur saisie n'est pas valide."
		},
		"command-history": "Historique de la commande",
		"command-status": {
			"DELIVERED": "Délivrée",
			"ERROR_ALREADY_IN_PROGRESS": "Échec",
			"ERROR_NOT_RECEIVED": "Échec",
			"ERROR_NOT_SENT": "Échec",
			"ERROR_RATE_LIMIT": "Échec",
			"ERROR_TIMEOUT": "Échec",
			"FAILED": "Échec",
			"PROCESSING": "Traitement en cours",
			"RECEIVED": "Reçue par la @.lower:box",
			"RECEIVED_SET_PROPERTY": "Reçue",
			"SENT": "Envoyée à la @.lower:box",
			"SENT_TO_EQUIPMENT": "Envoyée",
			"UNKNOWN": "Inconnu",
			"WAITING_FOR_HARDWARE_CONNECTION": "En attente"
		},
		"command-status-desc": {
			"DELIVERED": "Commande reçue par l'équipement",
			"ERROR_ALREADY_IN_PROGRESS": "Une commande identique est déjà en cours de traitement",
			"ERROR_NOT_RECEIVED": "La commande n'a pas été reçue par la @.lower:box",
			"ERROR_NOT_SENT": "La commande n'a pas pu être envoyée à la @.lower:box",
			"ERROR_RATE_LIMIT": "Maximum de 30 demandes de connexion atteint sur 7 jours consécutifs",
			"ERROR_TIMEOUT": "La @.lower:box n'a pas reçu de réponse dans le délai imparti",
			"FAILED": "La commande n'a pas été reçue par l'équipement",
			"PROCESSING": "La commande est en cours de traitement par la @.lower:box",
			"RECEIVED": "La commande a été reçue par la @.lower:box",
			"RECEIVED_SET_PROPERTY": "La commande a été reçue par l'équipement",
			"SENT": "La commande a été envoyée à la @.lower:box",
			"SENT_TO_EQUIPMENT": "La commande a été envoyée à l'équipement",
			"UNKNOWN": "Redémarrage de la @.lower:box ou absence de réponse de l'équipement",
			"WAITING_FOR_HARDWARE_CONNECTION": "En attente de connexion avec la @.lower:box"
		},
		"command-type": {
			"DATA_UPLINK_START": "Activation communication",
			"DATA_UPLINK_START_NO_LIMIT": "Activation communication illimitée",
			"DATA_UPLINK_STOP": "Arrêt communication",
			"DEBUG": "Débug",
			"DISCOVER": "Scan",
			"METRICS": "Métriques",
			"POLL_HAWKBIT": "Vérification des mises à jour",
			"READ_REQUEST": "Demande de lecture",
			"REQUEST_CONFIG": "Demande de configuration",
			"RESTART": "Redémarrage @.lower:box",
			"SEND_CONFIG": "Envoi de configuration",
			"SET_PROPERTY": "Demande d'écriture"
		},
		"command-type-desc": {
			"DATA_UPLINK_START": "Activation de la transmission des données de la @.lower:box vers la console",
			"DATA_UPLINK_START_NO_LIMIT": "Activation de la transmission des données de la box vers la console sans restriction",
			"DATA_UPLINK_STOP": "Arrêt de la transmission des données de la @.lower:box vers la console",
			"DEBUG": "Envoi de commande de débogage à la @.lower:box",
			"DISCOVER": "Commande de scan du réseau",
			"METRICS": "Écriture de métriques",
			"POLL_HAWKBIT": "Vérification de la disponibilité de mises à jour (APPS/BSP)",
			"READ_REQUEST": "Lecture d'une propriété d'un équipement",
			"REQUEST_CONFIG": "Demande de la configuration actuelle de la @.lower:box",
			"RESTART": "Redémarrage de la @.lower:box",
			"SEND_CONFIG": "Envoi de la configuration à la @.lower:box",
			"SET_PROPERTY": "Modification d'une propriété d'un équipement (consigne, mode, etc.)"
		},
		"commands-link-msg": "En savoir plus",
		"commands-msg": "Consultez l'état des instructions envoyées depuis la console vers votre @.lower:{'box'}.{eventLink}",
		"event-details": {
			"4004": {
				"failure": "La commande n'a pas été reçue par l'équipement",
				"success": "Commande reçue par l'équipement"
			},
			"601": {
				"RECEIVED": "Commande reçue par la @.lower:box",
				"SENT": "Commande envoyée à la @.lower:box"
			}
		},
		"event-origin-tooltip": "<b>Command ID</b> : commandes depuis la console ou l'API.<br /><b>Autre</b> : commandes externes ou locales (BMS, plannings, scénarios, etc.).",
		"events-link-msg": "Consulter la liste des codes",
		"events-msg": "Consultez les informations envoyées par la @.lower:{'box'} en temps réel pour diagnostiquer les dysfonctionnements.{eventLink}",
		"hub-msg": {
			"body": "Certains événements ne sont pas visibles. Activez la réception des données via le bouton à droite du nom de votre @.capitalize:{'client-name-hub'}. Les événements reçus pendant les 60 minutes suivantes seront visibles.",
			"title": "Activez la réception des événements"
		},
		"refresh-tooltip": "Rafraîchir la liste",
		"status": "Statut"
	},
	"looks-dont-have-heating-optimiser-configured": "Il semble que vous n'avez pas configuré l'Optimiseur de Relance.",
	"lorawan-easydownlink": "Propriété “Easy Downlink”, envoyez une consigne en renseignant directement sa valeur. Sa conversion en downlink est faite automatiquement.",
	"lorawan-property.interval-seconds.help-msg": "Pour les propriétés LoRaWAN, cette valeur sert uniquement à calculer le nombre total de valeurs reçues pendant une heure en lien avec votre abonnement. Merci de renseigner la même valeur que celle paramétrée dans l'équipement",
	"lorawan-quality-good": "Signal bon",
	"lorawan-quality-graph.example": "Ex. : si un capteur reçoit un signal avec un RSSI de -117 dBm et un SNR de -2 dB, alors la qualité du signal sera considérée comme faible en SF7. Le capteur est susceptible de passer en SF8 pour améliorer le signal s’il estime que la communication est trop mauvaise.",
	"lorawan-quality-graph.intro": "La qualité du signal {lorawan} est établie à partir du RSSI, du SNR et du SF.",
	"lorawan-quality-graph.rssi": "{rssi} (Received Signal Strength Indicator)",
	"lorawan-quality-graph.rssi.detail": "Puissance du signal reçu. Plus il est élevé, plus le signal est fort.",
	"lorawan-quality-graph.sf": "{sf} (Spreading Factor)",
	"lorawan-quality-graph.sf.detail": "Plus un équipement communique avec un SF élevé, plus il consomme de batterie. Le capteur ajuste automatiquement le SF en fonction du RSSI et du SNR pour assurer une communication et une durée de vie de la batterie optimales.",
	"lorawan-quality-graph.snr": "{snr} (Signal-to-Noise Ratio)",
	"lorawan-quality-graph.snr.detail": "Rapport entre le signal reçu et le bruit (les perturbations). Un SNR élevé signifie que le signal est clair et facile à distinguer du bruit.",
	"lorawan-quality-helper": "La qualité du signal ne peut être calculée car certaines des propriétés requises n'ont pas été ajoutées à le configuration : les propriétés SNR, RSSI et SF permettent de calculer la qualité du signal de votre équipement LoRaWAN. Elles ne sont pas décomptées de votre abonnement.",
	"lorawan-quality-medium": "Signal moyen",
	"lorawan-quality-poor": "Signal faible",
	"lorawan-use-same-keys-msg": "Réutiliser également les mêmes clés. Cela équivaut à transférer l'équipement vers le nouvel appareil",
	"lorawan-version.help-msg": "LoRaWAN versions 1.0.0 à 1.0.3",
	"lower-bound": "Borne inférieure",
	"lpb-network-device-number-1-error": "Si le numéro d'appareil est configuré sur 1 alors la @.lower:box devient maître sur le segment concerné. Ce fonctionnement n'est pas supporté par la @.lower:{'box'}.",
	"lpb-subkey": "Subkey",
	"maintenance-1h-at-X": "Une opération de maintenance est prévue sur la console {date} pendant 1h. Une interruption du service est possible durant cette période.",
	"maintenance-3h-at-X": "Une opération de maintenance est prévue sur la console {date} pendant 3h. Une interruption du service est possible durant cette période.",
	"make-sure-usb-cable-is-connected": "Assurez-vous que le câble USB est connecté",
	"managed-by": "Organisation parente",
	"manufacturer": "Fabricant",
	"manufacturer-and-product-reference": "Fabricant et modèle",
	"marker": "Marqueur",
	"marker-circle": "Cercle",
	"marker-cross": "Croix",
	"marker-none": "Aucun",
	"marker-square": "Carré",
	"marker-triangle": "Triangle",
	"mask": "Masque",
	"mask-address": "Adresse du masque",
	"max": "Max",
	"max-acceptable-value-is": "La valeur maximale acceptable est {value}",
	"max-cpu-usage": "Utilisation maximale du processeur (%)",
	"max-data-points-reached": "Nombre maximal de points de données atteint",
	"max-data-points-reached-hourly-computation-msg": "Nous estimons que vous allez envoyer {current} valeurs en une heure alors que votre plan actuel n'en autorise que {max}. Avant d'envoyer la configuration à votre appareil, veuillez modifier l'intervalle de temps de certaines propriétés, ou désactiver certaines propriétés. N'hésitez pas non plus à contacter votre responsable de compte pour augmenter votre nombre total de points.",
	"max-data-points-reached-msg": "En rapport à votre plan actuel, vous avez activé {current} propriétés sur {max}. Avant d'envoyer la configuration à votre appareil, veuillez retirer certaines propriétés ou demander à votre responsable de compte d'augmenter le nombre total de propriétés disponibles.",
	"max-ram-usage": "Utilisation maximale de la RAM (MB)",
	"max-ram-usage-megabytes": "L'utilisation maximale de la RAM en MegaBytes",
	"maximum": "Maximum",
	"maximum-timer-redirect-to-mqtt-property-is-600-seconds": "L'intervalle minimum pour une propriété redirigée vers une passerelle MQTT est de 600 secondes.",
	"maximum-value": "Valeur maximum",
	"mbus-scan": "Scan M-Bus",
	"measured-value": "Valeur mesurée",
	"medium": "Moyen",
	"message": "Message",
	"method": "Méthode",
	"metric": "Métrique",
	"min": "Min",
	"minimum": "Minimum",
	"minimum-acceptable-value-is": "La valeur minimale acceptable est {value}",
	"minimum-value": "Valeur minimum",
	"minute": "Minute",
	"minute-plural": "Minute | Minutes",
	"minutes": "Minutes",
	"missing": "ALERTE",
	"missing-column-in-file": "Colonne(s) manquante(s) dans le fichier : {column}",
	"missing-data-lorawan-txt": "Moins de données reçues que prévu au cours des dernières 24 heures",
	"missing-sheet-in-file": "Aucune feuille correspondante au type de contenu sélectionné n'a été trouvée.",
	"missing-values": "Valeurs manquantes dans les colonnes : {values}",
	"modal-activate.banner.1": "Renseignez les informations ci-dessous pour activer la box.",
	"modal-activate.banner.2": "En savoir plus en consultant {link}",
	"modal-activate.banner.guide": "le guide d’installation.",
	"modal-command-details": {
		"revision-id": "ID de la version",
		"title": "Détails de la commande"
	},
	"modal.add-graph.title": "Choix du graphique",
	"modal.schedules.edit-period.title": "Modifier la période d'application",
	"modal.schedules.edit-setpoints-values.help-text": "Renseignez une valeur pour chaque créneau. N'indiquez pas l'unité et utilisez le {dot} pour les nombres décimaux.",
	"modal.schedules.edit-setpoints-values.title": "Modifier les consignes",
	"modal.schedules.manage-slot-types.msg": "A l'étape “Propriétés et consignes”, vous définirez la consigne pour chaque type.",
	"modal.schedules.manage-slot-types.title": "Editer les types de créneaux",
	"modal.schedules.manage-states.unique-colors-error-msg": "Au moins une couleur est appliquée à plusieurs types de créneaux. Veullez attribuer une couleur différente à chaque type de créneau.",
	"modal.schedules.select-properties.title": "Sélectionner les propriétés",
	"modal.schedules.shared-slot-types.msg": "La liste des créneaux est commune à tous les plannings de votre box.",
	"modbus-data-format-tooltip-explanation-endianness": "Les flottants et les entiers longs ne tiennent pas dans un seul registre de 16 bits ; des registres consécutifs sont donc utilisés.<br /><br />Comme les différents fabricants gèrent l'endianness (ordre des octets) différemment, vous devez spécifier l'ordre des octets correspondant à votre équipement ModBus.",
	"modbus-ip-gateway-property": "Propriété de la passerelle Modbus TCP/IP",
	"modbus-register-address-must-be-unique-msg": "La propriété {propertyName} ne peut pas avoir l'adresse {address} et la fonction {functionName} car elles sont déjà utilisées par une autre propriété",
	"mode": "Mode",
	"model": "Modèle",
	"modify-schedule": "Modifier le planning",
	"monday": "Lundi",
	"month": "Mois",
	"monthly": "Mensuel",
	"months": "Mois",
	"more-infos": "Plus d'infos",
	"more-options": "Options",
	"mqtt-client-id-tooltip": "Le clientId utilisé pour se connecter à MQTT",
	"mqtt-gateway-property": "Propriété de la passerelle MQTT",
	"mqtt-gateway.add-block.tooltip": "Ajouter un champ",
	"mqtt-gateway.add-string-block": "Ajouter du texte",
	"mqtt-gateway.add-variables-block": "Ajouter une variable",
	"mqtt-gateway.downlink-topic.hashtag-error": "Le carcatère générique pour le multi niveau doit être le dernier caractère du topic, précédé par /",
	"mqtt-gateway.downlink-topic.help-msg": "Le caractère de remplacement multi-niveaux « # » est pris en charge. S'abonner avec ce caractère uniquement n'est pas autorisé.",
	"mqtt-gateway.downlink-topic.same-uplink-downlink-error-msg": "Veuillez saisir des topics différents pour le uplink et le downlink.",
	"mqtt-gateway.downlink-topic.special-characters-error": "Les caractères génériques '+' et '$' ne sont pas autorisés",
	"mqtt-gateway.downlink-topic.wildcard-error-msg": "S'abonner uniquement avec le caractère de remplacement multi-niveaux n'est pas autorisé.Veuillez éditer le downlink topic.",
	"mqtt-gateway.empty-template.help-msg": "Commencez à écrire pour voir un exemple de uplink topic",
	"mqtt-gateway.empty-template.space": "Les espaces dans les noms des variables seront remplacés par des tirets, '-'.",
	"mqtt-gateway.string-placeholder": "Ajouter du texte",
	"mqtt-gateway.uplink-topic-structure": "Format uplink topic",
	"mqtt-gateway.uplink-topic-structure.tooltip": "Format des uplink topics MQTT. La valeur des topics sera définie en se basant sur cette structure.",
	"mqtt-gateway.uplink-topic.special-characters-error": "Les caractères génériques '#', '+' et '$' ne sont pas autorisés",
	"mqtt-gateway.variable-placeholder": "Ajouter une variable (optionnel)",
	"mqtt-property.uplink-topic": "MQTT uplink topic",
	"mqtt-property.uplink-topic.tooltip": "Cet uplink topic sera utilisé pour accéder à la valeur de la propriété. Son format est défini dans les paramètres de la passerelle.",
	"mqtt-qos": "Quality of Service (QoS)",
	"mqtt-qos-0": "0 - Au plus une fois",
	"mqtt-qos-1": "1 - Au moins une fois",
	"mqtt-qos-2": "2 - Exactement une fois",
	"mqtt-server-host-placeholder": "Adresse du serveur MQTT",
	"mqtt-server-host-tooltip": "Adresse du serveur MQTT distant. Un nom de domaine complet (FQDN) ou une adresse IP. La longueur maximale est de 253.",
	"mqtt-server-port-tooltip": "Le port du serveur MQTT distant",
	"mqtt-slug-fields-must-be-unique": "Le nom du slug doit être unique pour différencier chaque propriété. Veuillez ajouter un identifiant unique comme le Property ID ou le Unique ID",
	"mqtt-slug-tooltip": "Un slug qui sera utilisé comme identificateur de la valeur de propriété sur MQTT. S'il n'est pas défini, le propertyId (qui est généré automatiquement) sera utilisé à la place.",
	"mqtt-slug.property-description": "Description de la propriété (50 premiers caractères)",
	"mqtt-version": "Version MQTT",
	"mqtt-version-tooltip": "La version MQTT à utiliser",
	"my-profile": "Mon profil",
	"n-days": "{n} jour | {n} jours",
	"n-days-after": "{days} jours après",
	"n-organization": "0 organisation | {n} organisation | {n} organisations",
	"n-property-saved": "{n} propriété enregistrée | {n} propriétés enregistrées",
	"name": "Nom",
	"name-box-gateway-seen-in-bacnet-network": "Nom de la @.lower:box ou de la passerelle telle qu'elle sera vue dans le réseau BACnet. Si le champ n'est pas renseigné, la valeur du champ \"Nom\" sera utilisée.",
	"name-of-person": "Nom de la personne",
	"name-of-the-file": "Nom du fichier",
	"netmask": "Masque de sous-réseau",
	"network": "Réseau",
	"network-address": "Adresse réseau",
	"network-and-connector": "Réseau et connecteur",
	"network-name": "Nom du réseau",
	"network-number": "Numéro de réseau",
	"network-protocol-modbusip-help-msg": "Le connecteur physique sera automatiquement assigné dès que la configuration à la passerelle sera envoyée et le câble du réseau Modbus TCP/IP branché.",
	"networks": "Réseaux",
	"neuron-id": "Neuron Id",
	"neuron-id-tooltip": "Exemple d'identification d'un Neuron ID: 07:02:73:DA:FC:00",
	"never-connected": "Jamais connecté",
	"new": "Nouveau",
	"new-alarm": "Nouvelle alarme",
	"new-configuration": "Nouvelle configuration",
	"new-configuration-not-applied-yet-to-box": "La nouvelle configuration n'a pas encore été appliquée à la @.lower:box",
	"new-configuration-will-overwrite-current-configuration-and-changes-wont-reflect-console": "La nouvelle configuration écrasera la configuration actuelle et les changements ne seront pas reflétés dans la console.",
	"new-dashboard": "Nouveau Dashboard",
	"new-equipment-added-to-network": "Nouvel équipement ajouté au réseau",
	"new-gateway": "Nouvelle passerelle",
	"new-graph": "Nouveau graphique",
	"new-group-name": "Nom du nouveau groupe",
	"new-password": "Nouveau mot de passe",
	"new-recipient": "Nouveau Destinataire",
	"new-value-not-set": "La nouvelle valeur n'a pas été définie",
	"new-value-not-set-yet": "La nouvelle valeur n'a pas encore été définie",
	"new-value-set-to-property": "Nouvelle valeur écrite dans la propriété {property}",
	"next": "Suivant",
	"next-day": "Le prochain jour",
	"next-period": "Période suivante",
	"no": "Non",
	"no-aggregation": "Données brutes",
	"no-alert": "Aucune Alerte",
	"no-authentication": "Aucune authentification",
	"no-codec": "Aucun codec",
	"no-data-for-specific-dates": "Aucune donnée disponible dans cette plage de dates",
	"no-data-received": "Aucune donnée reçue",
	"no-data-to-show": "Pas de données à afficher",
	"no-devices-found-on-network-check-configuration": "Aucun équipement n'a été détecté pendant le scan. Veuillez vérifier votre configuration et faire un nouveau Scan",
	"no-line": "Sans ligne",
	"no-perm-dashboard-tooltip": "Vous n'êtes pas autorisé(e) à ajouter un dashboard",
	"no-product-reference": "Aucun",
	"no-properties": "Aucune propriété à afficher",
	"no-properties-click-to-add": "Vous n'avez pas encore de propriétés. Cliquez ici pour l'ajouter.",
	"no-properties-click-to-add-short": "Vous n'avez pas encore de propriétés :",
	"no-redirections-message": "Cette propriété ne redirige pas ses valeurs",
	"no-results": "Pas de résultats",
	"no-selected-connector": "Connecteur non sélectionné",
	"no-static-ip-set-to-usb-network": "Aucune adresse IP statique n'est définie pour l'adaptateur réseau USB",
	"non-added": "non ajoutée",
	"non-grouped": "Sans groupe",
	"non-supported-object-type-and-instance": "Type d'objet non pris en charge : {objectType}. <br />Instance : {objectInstance}",
	"none": "Aucun",
	"not-allowed-column-in-file": "Colonne(s) non autorisée(s) : {column}",
	"not-available": "Non disponible",
	"not-configured": "non configuré",
	"not-connected-box": "@.capitalize:box n'est pas connecté à la console",
	"not-defined": "Non défini",
	"not-in-box-send-configuration-to-save": "Pas encore dans la @.lower:box . Envoyer la configuration à la @.lower:box pour l'ajouter.",
	"not-in-box-send-configuration-to-save-connector": "Ce connecteur n'est pas présent dans la @.lower:box . Envoyer la configuration à la @.lower:box pour l'ajouter.",
	"not-in-box-send-configuration-to-save-equipment": "L'équipement n'est pas présent dans la @.lower:box . Envoyer la configuration à la @.lower:box pour l'ajouter.",
	"not-in-box-send-configuration-to-save-gateway": "Cette passerelle n'est pas présente dans la @.lower:box . Envoyer la configuration à la @.lower:box pour l'ajouter.",
	"not-in-box-send-configuration-to-save-network": "Ce réseau n'est pas présent dans la @.lower:box . Envoyer la configuration à la @.lower:box pour l'ajouter.",
	"not-in-box-send-configuration-to-save-property": "La propriété n'est pas présente dans la @.lower:box . Envoyer la configuration à la @.lower:box pour l'ajouter.",
	"not-in-box-send-configuration-to-save-schedule": "Ce planning n'a pas été chargé dans la @.lower:box .",
	"not-specified": "Non renseigné",
	"notification": "Notification",
	"notification-enable-temporization": "Etre notifié en cas de retour à la normale",
	"notification-type": "Type de notification",
	"notifications": "Notifications",
	"notify-by": "Notifier par",
	"number-of-items-to-read-in-array": "Le nombre d'éléments à lire dans un tableau",
	"nv-index": "NV Index",
	"object-index": "Index de objet",
	"object-instance": "Instance d'objet",
	"object-type": "Type d'Objet",
	"object-type-not-supported": "Type d'objet non supporté",
	"objects": "objets",
	"odd-months": "Mois impairs",
	"offline": "Non connecté",
	"offline-box": "@.capitalize:box non connectée à la console",
	"offline-connected-once": "Non connecté (connecté au moins une fois)",
	"offline-hub": "@.clientname:_hub non connecté à la console",
	"offline-hub.modal.1": "Activez la communication via la carte SIM pour connecter la box à la console et envoyer une nouvelle configuration.",
	"offline-hub.modal.2": "Sans connexion, vous pouvez modifier la configuration de la box dans la console mais pas l'envoyer. De plus, les valeurs des propriétés ne sont pas réceptionnées.",
	"ok": "OK",
	"on-hold": "En cours",
	"online": "Connecté",
	"only-present-value-displayed-click-to-see-all-properties": "Par défaut, seules les propriétés “Average Value”, “Present Value”, “Priority For Writing” et “Program State” sont affichées.",
	"open": "Ouverte",
	"open-alert": "Ouverte",
	"optimiser": "Optimiseur",
	"optional": "optionnel",
	"options": "Options",
	"options-for-endiannese-are": "Options pour l'endianness",
	"or": "OU",
	"organization": "Organisation",
	"organization-prevent-rights-propagation": "Autoriser les administrateurs de l'organisation parente à avoir accès à cette organisation",
	"organization-prevent-rights-propagation-help": "Pour que les autorisations d'un utilisateur s'étendent de {parentName} à cette organisation (enfant), ce paramètre doit être activé ET l'utilisateur doit avoir l'autorisation d'administrateur sur {parentName}",
	"organization-saved": "Organisation enregistrée",
	"organizations": "Organisations",
	"organizations-managed-by": "Organisations gérées par {name}",
	"origin": "Origine",
	"other": "Autre",
	"other-actions": "Autres actions",
	"other-info": "Autre Info",
	"other-organization": "autre organisation | autres organisations",
	"other-organizations": "Ajouter une organisation",
	"other-properties": "autre propriété | autres propriétés",
	"other-value": "Autre valeur",
	"owner-organization": "Organisation parente",
	"pair": "Associer",
	"pair-a-physical-device": "Associer la licence à une box",
	"pair-renewal-help-messages": {
		"first": "Dans le cadre d'un renouvellement de licence, rendez-vous directement sur l'appareil qui va expirer.",
		"second": "Vous pourrez alors associer la nouvelle licence sans avoir à indiquer l'hardware ID et le code de vérification."
	},
	"pair-the-device": "Associer l'appareil",
	"pair-with-physical-device": "Associer à une box",
	"pair-with-physical-device.tooltip": "Associer la licence à une box",
	"paired": "Appairé",
	"paired-at": "Appairé à {date}",
	"panel-network.configure-network": "Configurer le réseau",
	"panel-network.error-lon-ip-same-port": "Un autre réseau IP LON utilise déjà le port {port}",
	"panel-network.placeholder-protocol": "Sélectionnez un protocole",
	"panel-property.property-id": "ID de la propriété",
	"panel-property.property-id.tooltip": "Non modifiable, identifiant système unique de la propriété",
	"panel-property.warning.changes-in-draft": "La configuration indiquée ci-dessous est celle présente dans la box.",
	"panel-property.warning.changes-in-draft.send": "Elle a été éditée, les modifications sont visibles dans “{startLink}Configuration{endLink}”. Afin d'appliquer les changements et les visualiser sur cet écran, veuillez les envoyer à la box.",
	"panel-property.warning.changes-in-draft.title": "Modifications en cours non synchronisées avec la box",
	"parent-box": "@.capitalize:box Parente",
	"parent-box-label": "@.capitalize:box Parente :",
	"parent-organization": "Organisation parente",
	"parity": "Parité",
	"password": "Mot de passe",
	"password-field.chars": "{chars} caractères",
	"password-field.one-lowercase": "Une minuscule",
	"password-field.one-specialchar": "Un caractère spécial",
	"password-field.one-uppercase": "Une majuscule",
	"password-field.password-generic-error": "Le mot de passe choisi est dans une liste de mots de passe génériques utilisés dans des cyberattaques. Veuillez choisir un mot de passe plus spécifique.",
	"password-field.password-must-contain-at-least": "Votre mot de passe doit contenir au moins :",
	"passwords-do-not-match": "Les mots de passe ne correspondent pas",
	"payload": "Donnée",
	"payload-prefix": "Préfixe du payload",
	"payload-prefix-when-writing-to-property-mandatory-when-access-write": "Le payload de cette propriété lors de l'écriture. Obligatoire lorsque l'accès est en écriture",
	"payment": "Paiement",
	"period": "Période",
	"period-after-incident-seconds": "Période après l'incident en secondes",
	"period-in-days": "Période en jours",
	"period-in-minutes": "Période en minutes",
	"period-in-seconds": "Période en secondes",
	"permissions": "Accès",
	"phone-number": "Numéro de téléphone",
	"physical-connector": "Connecteur Physique",
	"physical-location-of-box": "L'emplacement physique de la @.lower:box",
	"please-wait-while-applying-configuration-hub": "Veuillez patienter pendant que nous appliquons la configuration à votre @.lower:hub",
	"plugin": "Brancher",
	"plugin-file": "Fichier de plug-in",
	"plugin-properties": "Propriétés du plugin",
	"plugin.grant-access": "Type d'accès à accorder",
	"plugin.grant-access-tooltip": "Indiquez si le plugin a accès à cette propriété en entrée (les données entreront dans le plugin) ou en sortie (les données sortiront du plugin)",
	"plugin.local-name": "Nom local",
	"plugin.local-name-tooltip": "Le nom que le plugin utilisera comme identifiant de propriété pour cette propriété.",
	"poor": "Faible",
	"port": "Port",
	"port-to-expose-server-unique-per-physical-connector": "Le port sur lequel exposer le serveur. Ceci est unique par connecteur physique",
	"position-of-bit": "Position du bit",
	"position-of-properties": "Choisissez où afficher les propriétés",
	"predicted-time": "Temps prédit",
	"press-enter-to-deselect": "Appuyez sur Entrée pour supprimer",
	"press-enter-to-select": "Appuyez sur Entrée pour sélectionner",
	"preview-example": "Aperçu :",
	"previous": "Précédent",
	"previous-period": "Période précédente",
	"primary-address": "Adresse primaire",
	"priority": "Priorité",
	"priority-for-writing": "Priorité à l'écriture",
	"private-key": "Clé Privée",
	"program": "Programmation",
	"program-id": "Program Id",
	"program-id-tooltip": "L'identifiant du programme",
	"properties": "Propriétés",
	"properties-added": "Propriétés ajoutées",
	"properties-duplicated-successfully": "Propriétés dupliquées avec succès",
	"properties-included": "Nombre maximun de propriétés",
	"properties-references": "Références de propriétés",
	"properties-saved": "Propriétés sauvegardées avec succès",
	"properties-settings": "Paramètres des Propriétés",
	"properties-targeted-by-the-schedule": "Propriétés ciblées par le planning",
	"properties-updated": "Propriétés mises à jour",
	"properties-values": "Valeur des propriétés",
	"properties-values-in-an-hour": "Nombre de valeurs par heure",
	"properties-x-deleted": "{n} propriété supprimée | {n} propriétés supprimées",
	"properties-x-disabled": "{n} propriété désactivée | {n} propriétés désactivées",
	"properties-x-enabled": "{n} propriété activée | {n} propriétés activées",
	"properties-x-saved": "{n} propriété enregistrée | {n} propriétés enregistrées",
	"property": "Propriété",
	"property-already-saved": "Propriété déjà ajoutée",
	"property-bacnet": "Propriété BACnet",
	"property-didnt-receive-any-value": "Cette propriété n'a pas encore reçu de valeur",
	"property-duplicated": "Propriété dupliquée",
	"property-id": "ID de la propriété",
	"property-index": "Index de propriété",
	"property-is-redirected-confirm-rename": "Cette propriété est redirigée vers une passerelle BACnet IP ou MQTT. Ces passerelles peuvent nécessiter une mise à jour pour refléter vos modifications. Souhaitez-vous appliquer les modifications aux passerelles ?",
	"property-kind": "Type de propriété",
	"property-must-be-configured": "La propriété {property} doit être configurée",
	"property-name": "Nom de la propriété",
	"property-name-by-default": "Nom de la propriété par défaut",
	"property-not-available-for-scaling": "Propriété non disponible pour être mise à l'échelle",
	"property-not-saved-cant-be-empty": "{property} non enregistrée : elle ne peut pas être vide.",
	"property-plural": "Propriété | Propriétés",
	"property-redirecting-from": "Cette propriété reçoit des valeurs des propriétés répertoriées ci-dessous",
	"property-saved": "Propriété enregistrée | Propriétés enregistrées",
	"property-scaling-applied.input-help-msg": "Une mise à l'échelle de type \"ax + b\" (a={a}; b={b}) est appliquée, la valeur non mise à l'échelle de ce point est {value}",
	"property-slug": "Slug de la propriété",
	"property-slug-description": "Slug de la propriété d'équipement d'origine",
	"property-value": "Valeur de la propriété",
	"protocol": "Protocole",
	"provide-description-to-easily-identify-new-licence": "Fournir une description pour identifier facilement la nouvelle licence",
	"qtt-equipments-were-created": "{qtt} équipements ont été créés",
	"qtt-years": "1 an | {years} ans",
	"qtt1-equipment-was-created": "1 équipement a été créé",
	"quality": "Qualité",
	"quantity": "Quantité",
	"quit-without-saving": "Quitter sans sauvegarder",
	"rate-plan": "Licence",
	"rate-plan-deleted": "Licence supprimée",
	"rate-plan-type": "Type de licence",
	"rate-plan.delete": "Supprimer une licence",
	"rate-plan.delete.confirmation": "La licence {id} sera supprimée.",
	"rate-plan.pairing.error.22": "Une licence est déjà associée à l'appareil indiqué. Vérifiez l'hardware ID renseigné.",
	"rate-plan.pairing.error.23": "Une licence est déjà associée à cet appareil. Si vous souhaitez la renouveler, veuillez accéder directement à l'appareil qui est sur le point d'expirer.",
	"rate-plans": "Rate Plans",
	"raw-registers": "Raw registres",
	"reached-comfort-in": "Atteint le confort dans",
	"read": "Lire",
	"read-and-write": "Lire et Écrire",
	"read-and-write-desc": "Autoriser la lecture et l'écriture des valeurs depuis le cloud (lecture et écriture)",
	"read-function": "Fonction lecture",
	"read-more": "En savoir plus",
	"read-only": "Lecture seule",
	"read-only-desc": "Autoriser uniquement la lecture des valeurs depuis le cloud (lecture seule)",
	"read-write": "Lire/Écrire",
	"reason": "Raison",
	"reasons": "Raisons",
	"received-at": "Reçu le",
	"received-at-time": "Reçu à",
	"received-value-on-date": "Valeur reçue le {date}",
	"received-value-x-minutes-ago": "Valeur reçue {when}",
	"recipient": "Destinataire",
	"recipient-without-access": "Destinataire sans accès à la console",
	"recipient.confirm": "Veuillez confirmer le destinataire",
	"recipients": "Destinataires",
	"reconfigure-connector": "Reconfigurer le connecteur",
	"recurrence": "Récurrence",
	"recurrence.none": "Aucune",
	"recurrence.yearly": "Annuelle",
	"redirect-to-property": "Rediriger vers la propriété",
	"redirect-value-to": "Rediriger la valeur vers : {to}",
	"redirected-properties": "Propriétés redirigées",
	"redirected-properties.gateways": "Propriétés redirigées (passerelles)",
	"redirecting-from": "Redirection depuis",
	"redirecting-to": "Redirection vers",
	"redirections": "Redirections",
	"reference": "Référence",
	"reference-plural": "Référence | Références",
	"references": "Références",
	"refresh": "Rafraîchir",
	"refresh-scan": "Relancer le scan",
	"refresh-value": "Rafraîchir la valeur",
	"region": "Région",
	"register-address": "Adresse du registre",
	"register-address-already-in-use": "Adresse du registre déjà utilisée dans ce type de registre",
	"register-type": "Type de registre",
	"relation-between-physical-logical-state-with-image": "Relation entre l'état physique et logique de la valeur. <br /> <img src='{imgsrc}' />",
	"release-version": "Mise à jour {version}",
	"remaining-properties": "Propriétés restantes",
	"remove-all-slots": "Supprimer tous les créneaux",
	"remove-custom-permissions": "Supprimer les accès",
	"renew": "Renouveler",
	"renew-rate-plan": "Renouveler la licence",
	"renew-rate-plan-pairing": "Renouveler la licence en associant une licence déjà disponible",
	"renew.device.notification.content.1.expired": "Triez le tableau ci-dessous par date de fin pour identifier ceux qui sont arrivés à échéance.",
	"renew.device.notification.content.1.expired.siemens": "Triez le tableau ci-dessous par date de fin pour identifier celles qui sont arrivées à échéance.",
	"renew.device.notification.content.1.expiring": "Triez le tableau ci-dessous par date de fin pour identifier ceux qui arrivent à échéance.",
	"renew.device.notification.content.1.expiring.siemens": "Triez le tableau ci-dessous par date de fin pour identifier celles qui arrivent à échéance.",
	"renew.device.notification.content.2": "Pour en savoir plus sur leur renouvellement, cliquez sur le bouton “renouveler”, sur la ligne de l'abonnement.",
	"renew.device.notification.content.2.siemens": "Pour en savoir plus sur leur renouvellement, cliquez sur le bouton “renouveler”, sur la ligne de la licence.",
	"renew.device.notification.title.expired": "Un ou plusieurs abonnements ont expiré",
	"renew.device.notification.title.expired.siemens": "Une ou plusieurs licences ont expiré",
	"renew.device.notification.title.expiring": "Un ou plusieurs abonnements expirent dans {days}",
	"renew.device.notification.title.expiring.siemens": "Une ou plusieurs licences expirent dans {days}",
	"renew.dialog.alert": "L'administrateur de l'organisation de votre box a été notifié par email.",
	"renew.dialog.answer.1": "Interruption de la connexion GSM entre votre box et nos serveurs",
	"renew.dialog.answer.2.bridge": "Configuration à distance de la box : possible si la box est connectée à un réseau Ethernet/IP ouvert",
	"renew.dialog.answer.2.tower": "Arrêt de la configuration à distance de la box",
	"renew.dialog.answer.3.bridge": "Envoi ponctuel des données sur nos serveurs :  possible si la box est connectée à un réseau Ethernet/IP ouvert",
	"renew.dialog.answer.3.tower": "Arrêt de l'envoi des données sur nos serveurs",
	"renew.dialog.answer.4": "Mise à jour automatique du firmware de la box : possible si la box est connectée à un réseau Ethernet/IP ouvert",
	"renew.dialog.answer.5": "Pas d'impact sur les redirections et autres opérations en local",
	"renew.dialog.ask": "Que se passe-t-il en cas de non renouvellement ?",
	"renew.dialog.ask.bridge": "Que se passe-t-il en cas de non renouvellement ?",
	"renew.dialog.ask.siemens": "Que se passe-t-il en cas de non renouvellement ?",
	"renew.dialog.license": "Renouvellement de la licence",
	"renew.dialog.main-text.end": "Sans renouvellement d'ici le {endDate}, les fonctionnalités de votre {type} seront restreintes.",
	"renew.dialog.main-text.end.bridge": "Sans renouvellement d'ici le {endDate}, les fonctionnalités de votre {type} seront restreintes.",
	"renew.dialog.main-text.end.expired": "Actuellement, aucun abonnement n'est en cours, les fonctionnalités de votre {type} sont restreintes.",
	"renew.dialog.main-text.end.expired.bridge": "Si votre carte SIM a expiré, les fonctionnalités de votre {type} seront restreintes.",
	"renew.dialog.main-text.end.expired.siemens": "Actuellement, aucune licence n'est en cours, les fonctionnalités de votre {type} sont restreintes.",
	"renew.dialog.main-text.end.siemens": "Sans renouvellement d'ici le {endDate}, les fonctionnalités de votre {type} seront restreintes.",
	"renew.dialog.main-text.start": "Pour renouveler l'abonnement de la @.lower:box “{boxName}”, contactez votre revendeur.",
	"renew.dialog.main-text.start.bridge": "Votre {type} “{boxName}” dispose d'une carte SIM avec données incluses valable par défaut {duration}. La carte SIM permet la connexion via le réseau GSM à nos serveurs. Pour renouveler la carte SIM, contactez votre revendeur.",
	"renew.dialog.main-text.start.siemens": "Pour renouveler la licence de la @.lower:box “{boxName}”, contactez votre revendeur.",
	"renew.dialog.note": "Note : si vous avez déjà renouvelé, ce message disparaîtra à la date de début du nouvel abonnement.",
	"renew.dialog.note.siemens": "Note : si vous avez déjà renouvelé, ce message disparaîtra à la date de début de la nouvelle licence.",
	"renew.dialog.renewal.siemens": "Une fois la nouvelle licence commandée, vous pourrez la sélectionner pour activer le renouvellement. Si ce n'est pas le cas, contactez votre revendeur.",
	"renew.dialog.retrieve.admin": "L'administrateur de l'organisation de votre box a été notifié par email.",
	"renew.dialog.retrieve.data": "Comment récupérer vos données ?",
	"renew.dialog.retrieve.data.text": "Utilisez la fonction d'archivage ou l'API. Vos données seront définitivement supprimées le {date}.",
	"renew.dialog.sim": "Renouvellement de la carte SIM",
	"renew.dialog.subscription": "Renouvellement de l'abonnement",
	"renew.license": "Renouveler licence",
	"renew.main.notification.expired": "Un ou plusieurs abonnements ont expiré. Identifiez-les dans la {linkBoxes} de l'organisation {organization}{others}.",
	"renew.main.notification.expired.siemens": "Une ou plusieurs licences ont expiré. Identifiez-les dans la {linkBoxes} de l'organisation {organization}{others}.",
	"renew.main.notification.expiring": "Un ou plusieurs abonnements expirent dans {days}. Identifiez-les dans la {linkBoxes} de l'organisation {organization}{others}.",
	"renew.main.notification.expiring.siemens": "Une ou plusieurs licences expirent dans {days}. Identifiez-les dans la {linkBoxes} de l'organisation {organization}{others}.",
	"renew.subscription": "Renouveler l'abonnement",
	"renew.success": "Renouvellement réalisé avec succès. Les dates de début et de fin seront actualisées le 1er jour du renouvellement.",
	"renew.success.description": "Information sur la licence",
	"reopen-alert": "Rouvrir l'alerte",
	"repeat-every": "Répétez chaque",
	"repeat-new-password": "Répétez votre mot de passe",
	"request-autodiscovery-box": "Demander le scan à la @.lower:box",
	"request-download": "Demande de téléchargement",
	"request-new-scan": "Relancer un scan",
	"requested-by": "Demandé par",
	"requesting-scan": "Scan en cours",
	"required": "Requis",
	"required-when-communicating-lte-mode-if-device-supports-s-and-lte-modes-has-to-set": "Requis uniquement lors de la communication en mode LTE. Si un device prend en charge les modes S et LTE, cela doit être défini.",
	"reset-time": "Réinitialiser l'heure",
	"resource-uri": "URI de la ressource",
	"resources": "Ressources",
	"response-timeout": "Délai de réponse",
	"response-timeout-tooltip": "Demander le délai de réponse en microsecondes",
	"restart": "Recommencer",
	"restart-app-error": "Veuillez redémarrer l'application. Un problème est survenu, désolé.",
	"restart-app-msg": "Attendez, s'il vous plaît. Nous essayons de nous reconnecter au service back-end.",
	"restarting-server-failure-msg": "Veuillez fermer et ouvrir à nouveau l'application",
	"restarting-server-please-wait": "Veuillez patienter ... cela peut prendre quelques minutes.",
	"restarting-server-title": "Nous appliquons votre licence et installons l'application.",
	"result": "Résultat",
	"results": "Résultats",
	"retry-number": "Nombre d'essais",
	"retry-number-tooltip": "Le nombre de tentatives si la demande a été perdue",
	"return-to-normal": "Retour à la normale",
	"right": "Droite",
	"right-ethernet-port": "Port Eth droit",
	"role": "Rôle",
	"roles.box-permissions": "Autorisations de la @.lower:box",
	"roles.custom-rights": "Droits Personnalisés",
	"roles.integrator": "Intégrateur",
	"roles.maintenance-technician": "Technicien de Maintenance",
	"roles.no-access": "Pas d'accès",
	"roles.organization-admin": "Administrateur",
	"roles.read-only-user": "Utilisateur en lecture seule",
	"roles.site-manager": "Gestionnaire de Site",
	"roles.software-integrator": "Intégrateur Logiciel",
	"route-deleted": "Route supprimée",
	"route-saved": "Route sauvegardée",
	"route-valid-success-msg": "La nouvelle route est valide",
	"router.404.description": "Désolé, la page que vous recherchez n'existe pas.",
	"router.404.header": "404, Page non trouvée",
	"routing": "Routage",
	"routing-metric-help": "Priorité de la route en cas de conflits. Plus la valeur est basse, plus la priorité est élevée",
	"routing-table-msg": "Votre passerelle contient une table de routage avec des routes par défaut pour communiquer avec la console. Si votre configuration réseau requiert la définition de routes spécifiques ou si elle requiert de détourner certaines routes de leur routage par défaut alors vous pouvez ajouter de nouvelles routes. Ces dernières n'impacteront pas la table présente par défaut.",
	"routing-table-success-msg": "La table de routage est valide",
	"run-mbus-scan": "Lancer un scan M-Bus",
	"run-optimiser-wizard": "Exécutez l'assistant d'optimisation",
	"rvl-OFF-mode": "REDUIT",
	"rvl-ON-mode": "NORMAL",
	"rvl-migration-click-to-update": "Cliquez ici pour déclencher le processus de mise à jour",
	"rvl-migration-needed-msg": "Au moins un équipement de type RVL est connecté à l'un de vos appareils. Une nouvelle fonctionnalité est disponible pour faciliter la lecture et l'écriture des programmes horaires sur ces équipements. Nous pouvons mettre à jour votre configuration en votre nom pour que vous puissiez en bénéficier. Lorsque la mise à jour sera effectuée, vous ne verrez plus ce message.",
	"rvl-migration-success": "Votre appareil a été ajouté à la file d'attente pour être mis à jour",
	"same-day": "Même jour",
	"saturday": "Samedi",
	"save": "Sauvegarder",
	"save-all-properties-qtt": "Toutes les propriétés | Toutes les {qtt} propriétés",
	"save-all-selected-properties": "Souhaitez-vous enregistrer toutes les propriétés sélectionnées ?",
	"save-all-selected-properties-or-selected-properties-from-current-equipment": "Souhaitez-vous ajouter les propriétés sélectionnées sur les différents équipements ou uniquement les propriétés de l'équipement {equipment}",
	"save-and-close": "Sauvegarder et fermer",
	"save-changes": "Enregistrer les modifications",
	"save-properties": "Ajouter les propriétés",
	"save-qtt-properties-from-equipment": "{qtt} propriétés de {equipment}",
	"save-selected-boxes": "Enregistrer les @.lower:boxes sélectionnées",
	"save-selected-properties": "Ajouter les propriétés | Ajouter {n} propriété | Ajouter {n} propriétés",
	"saved": "enregistré",
	"saving": "Sauvegarde",
	"saving-status.failed.msg": "Les changements n'ont pas été enregistrés",
	"saving-status.saved.msg": "Modifications enregistrées",
	"scaled-value": "Mise à l'échelle",
	"scaling": "Mise à l'échelle",
	"scaling-explanation": "Appliquer une mise à l'échelle pour transformer la valeur de la propriété en la multipliant par un facteur, a (exemple : 1, 10, 0,1) et/ou en y ajoutant une valeur, b (exemple : 1000, -50). La valeur mise à l'échelle est un nombre décimal.",
	"scaling-explanation-gateway": "Une mise à l'échelle est appliquée sur la propriété de l'équipement. Elle est également appliquée sur la propriété redirigée. Vous pouvez modifier la formule de mise à l'échelle dans la configuration de la propriété de l'équipement.",
	"scan": "Scan",
	"scan-bacnet-network": "Scan un réseau BACnet",
	"scan-date": "Date du scan : {date}",
	"scan-discovery": "Scan BACnet",
	"scan-mbus-network": "Scan un réseau M-Bus",
	"scan-no-results-msg": "L'analyse n'a donné aucun résultat.",
	"scan-not-found": "Scan not found",
	"scan-not-found-please-request-one": "Aucun scan n'a été trouvé. Veuillez relancer un scan.",
	"scan-options": "Options de scan",
	"scan-progress": "Scan en cours",
	"scan-progress-yet": "Scan toujours en cours",
	"scan-requested-on-timestamp-want-to-use": "Un scan a été réalisé le {timestamp}. Souhaitez-vous l'utiliser ?",
	"scan-still-in-progress-longer-than-x-minutes-stop-and-request-new-one": "Le scan est en cours, mais aucune mise à jour n’a été détectée au cours des {minutes} dernières minutes.",
	"scan-stop-or-restart": "Souhaitez-vous l’interrompre et lancer un nouveau scan ?",
	"scan.detected": "Scan détecté",
	"scanning-hub-please-wait": "Scanning @.lower:{'hub'}. S'il vous plaît, attendez...",
	"scatter-plot": "Nuages de points",
	"scenario": "Scénario",
	"scenario-name": "Nom du scénario",
	"schedule": "Planning",
	"schedule-last-value-tooltip": "Valeur attendue en fonction de la configuration du calendrier",
	"schedule-management-encoder": "Encodeur du gestionnaire de planification",
	"schedule-name-by-default": "Nom du planning par défaut",
	"schedule-occurrence-time-interval-tooltip": "La condition doit se répéter autant de fois que désiré à gauche pendant cette période.<br />N'oubliez pas que l'intervalle de réception de deux valeurs successives pour une même propriété dépend de la nature de l'équipement. Vérifier l'écran “Données Live” si vous avez un doute.<br />Le compteur est remis à zéro si les conditions ont été remplies pendant la période.<br />Pour étre déclenché à nouveau, les conditions doivent se produire pendant une nouvelle période.",
	"schedules": "Plannings",
	"schedules.add-exception": "Ajouter une exception",
	"schedules.add-schedule": "Ajouter un planning",
	"schedules.application-period-saved-successfully": "Périodes d'application modifiées avec succès",
	"schedules.calendar-view": "Vue calendrier",
	"schedules.create-first-schedule": "Créer votre premier planning",
	"schedules.create-schedule-step1.form-title-edit": "Définir le planning hebdomadaire",
	"schedules.create-schedule-step1.form-title-new": "Nouveau planning hebdomadaire",
	"schedules.create-schedule-step1.title": "Planning hebdomadaire",
	"schedules.create-schedule-step2.form-title": "Exceptions",
	"schedules.create-schedule-step2.title": "Exceptions",
	"schedules.create-schedule-step3.form-title": "Propriétés et consignes",
	"schedules.create-schedule-step3.title": "Propriétés et consignes",
	"schedules.daily-schedule-invalid-consecutive-time.error-msg": "Les heures de début et de fin ne sont pas cohérentes.",
	"schedules.daily-schedule-invalid-overlap-time.error-msg": "Les créneaux ne peuvent pas se chevaucher",
	"schedules.default-schedule-state-label": "Type de créneau appliqué par défaut le reste du temps :",
	"schedules.default-schedule-state.field-required": "Merci d'indiquer quel type de créneau s'applique en dehors des créneaux définis ci-dessus.",
	"schedules.edit-exceptions": "Gérer les exceptions",
	"schedules.edit-period.label": "Période d'application",
	"schedules.edit-planning": "Gérer les types de créneaux",
	"schedules.edit-schedule": "Modifier le planning",
	"schedules.edit-the-application-periods": "Modifier les périodes d'application",
	"schedules.edit-the-application-periods.tooltip-x-properties": "Modifier la période d'application de la propriété | Modifier les périodes d'application des {x} propriétés",
	"schedules.edit-the-schedule": "Modifier le planning",
	"schedules.edit-the-setpoints-values": "Modifier les valeurs des consignes",
	"schedules.edit-the-setpoints-values.tooltip-x-properties": "Modifier les valeurs des consignes de la propriété | Modifier les valeurs des consignes des {x} propriétés",
	"schedules.empty-state.control.title": "Piloter vos consignes avec une programmation horaire",
	"schedules.empty-state.no-control.msg": "Et configurer vos alarmes pour prendre en compte le planning dans leur déclenchement",
	"schedules.empty-state.no-control.title": "Décriver l'usage de votre bâtiment avec un planning",
	"schedules.eod-label": "minuit",
	"schedules.exception-used-tooltip": "Cette exception ne peut pas être supprimée car elle est utilisée par un planning. Veuillez modifier le(s) planning(s) qui l'utilise(nt) avant de la supprimer.",
	"schedules.exception.all-day-schedule-state.field-required": "Veuillez sélectionner le type de créneau horaire qui s'appliquera pendant l'exception.",
	"schedules.exception.condition-is-met-if-type-slot-is": "La condition est vérifiée si le type de créneau correspond à",
	"schedules.exception.repeats-every-year": "Récurrence annuelle",
	"schedules.exception.slot-type": "Type de créneau",
	"schedules.exception.slot-type-desc": "Le même type de créneau s'appliquera pendant l'exception",
	"schedules.exception.state-outside-slot": "En dehors de ce créneau, le type de créneau défini dans le planning comme créneau par défaut s'appliquera. | En dehors de ces créneaux, le type de créneau défini dans le planning comme créneau par défaut s'appliquera.",
	"schedules.exception.type-of-period.a-day": "Une journée",
	"schedules.exception.type-of-period.time-period": "Une plage",
	"schedules.exceptions.create-exception": "Ajouter des exceptions",
	"schedules.exceptions.define-exceptions-msg": "Indiquez les jours fériés, vacances ou tout autre événement exceptionnel susceptible de modifier le planning.",
	"schedules.exceptions.edit-existing-exceptions": "Modifier la liste",
	"schedules.exceptions.select-existing-exceptions": "Liste des exceptions",
	"schedules.exceptions.slot-type-personalized": "Personnalisé",
	"schedules.failed-deleting-exception": "Échec de suppression de l'exception",
	"schedules.failed-deleting-schedule": "Échec de suppression du planning",
	"schedules.instruction-of-state": "Consigne",
	"schedules.instructions-activity-period": "Période d'application",
	"schedules.no-setpoints": "Aucune consigne",
	"schedules.properties.add-properties": "Ajouter des propriétés",
	"schedules.properties.select-properties": "Sélectionner les propriétés",
	"schedules.schedule-saved-successfully": "Planning hebdomadaire sauvegardé. Pour l'envoyer à la box, cliquez sur \"Enregistrer les modifications\"",
	"schedules.schedule-state": "Type de créneau",
	"schedules.schedule-state.add-type": "Ajouter un type",
	"schedules.schedule-state.manage-type": "Gérer les types",
	"schedules.schedule-state.occupied": "Occupé",
	"schedules.schedule-state.type": "Type",
	"schedules.schedule-state.unoccupied": "Inoccupé",
	"schedules.see-the-properties": "Voir et modifier les propriétés",
	"schedules.select-exceptions": "Sélectionner les exceptions à ajouter au planning",
	"schedules.select-slot-to-apply": "Sélectionner le créneau à appliquer",
	"schedules.setpoint-value": "Valeur de la consigne",
	"schedules.setpoint-values": "Valeur des consignes",
	"schedules.setpoints-saved-successfully": "Consignes modifiées avec succès",
	"schedules.slots": "Créneaux",
	"schedules.slots.help-txt": "Renseignez les créneaux de la journée (ex : “occupé”). Ensuite, vous indiquerez le créneau qui s'applique par défaut le reste du temps (ex : “inoccupé”).",
	"schedules.slots.tooltip": "A l'étape “Propriétés et consignes”, vous définirez la consigne pour chaque type.",
	"schedules.specific-period": "Période spécifique",
	"schedules.state-plus-name": "Créneau {name}",
	"schedules.state-used-tooltip": "Ce type de créneau ne peut pas être supprimé car il est utilisé par un planning. Veuillez modifier le(s) planning(s) qui l'utilise(nt) avant de le supprimer.",
	"schedules.time-period": "Période de temps",
	"schedules.time-period-recurring": "Répéter tous les ans",
	"scheduling": "Planning",
	"schematic": "Schéma",
	"schematic-drag-image-here": "Synoptique\n\nGlissez-Déposez une image\n\nPNG, JPEG",
	"scopes": "Scopes",
	"search": "Rechercher",
	"search-for-a-box": "Rechercher une @.lower:box",
	"search-for-a-device": "Rechercher un appareil (nom, device ID or hardware ID)",
	"search-for-a-property": "Chercher une propriété",
	"search-for-a-recipient": "Chercher un destinataire",
	"search-for-alarms": "Chercher une alarme",
	"search-for-an-equipment": "Rechercher un équipement",
	"search-for-archive-requests": "Recherche de requêtes d'archive de données",
	"search-for-delegated-connections": "Rechercher par prénom, nom, email",
	"search-for-hub": "Rechercher une @.lower:hub (nom, Device Id, Hardware Id)",
	"search-for-organization-name": "Rechercher le nom d'une organisation",
	"second": "Seconde",
	"second-plural": "Seconde | Secondes",
	"secondary-address": "Adresse secondaire",
	"secondary-address-mbus-tooltip": "Adresse secondaire de l'équipement. Format : 16 caractères hexadécimaux majuscules<br />Si les deux adresses sont renseignées et si son format est le bon, l'adresse secondaire seule sera prise en compte",
	"seconds": "Secondes",
	"seconds-symbol": "s",
	"secret-key": "Clé",
	"security": "Sécurité",
	"security-key": "Clef de sécurité",
	"see-details": "Voir les détails",
	"see-last-values": "Voir les dernières valeurs",
	"see-more": "Voir plus",
	"see-more-in-live-data": "Voir plus dans live data",
	"see-redirection-property": "Voir où la propriété est redirigée",
	"see-schedule": "Voir le planning",
	"see-the-former-scan": "Voir le précédent scan",
	"see-the-latest-values": "Voir les dernières valeurs",
	"see-the-schedule": "Voir le planning",
	"see-this-scan": "Voir ce scan",
	"segment-number": "Numéro de segment",
	"segment-number-description": "Le numéro de segment de l'équipement LPB",
	"select": "Sélectionner",
	"select-a-connector": "Sélectionnez un connecteur",
	"select-an-alarm": "Sélectionnez une alarme",
	"select-an-equipment": "Sélectionner un équipement",
	"select-and-configure-box-ethertnet-connector": "Sélectionner le connecteur Ethernet.",
	"select-at-least-one-property": "Vous devez sélectionner au moins une propriété",
	"select-at-least-one-weekday": "Vous devez sélectionner au moins un jour de la semaine",
	"select-box-or-hub-for-file": "Sélectionnez la @.lower:box pour le fichier",
	"select-date": "Sélectionner une date",
	"select-date-range": "Sélectionnez la plage de dates",
	"select-device": "Sélectionnez une box",
	"select-equipment-left-column-list-properties": "Sélectionnez un équipement dans la colonne de gauche pour lister toutes les propriétés disponibles",
	"select-file-format": "Sélectionner le format du fichier",
	"select-file-visibility": "Sélectionnez la visibilité du fichier",
	"select-frequency-receive-notification": "Sélectionnez la fréquence de réception des notifications",
	"select-gateway": "Sélectionner la passerelle :",
	"select-graph": "Sélectionnez le graphique",
	"select-hubs-to-export-configuration": "Sélectionnez les @.lower:hubs pour lesquels vous souhaitez exporter la configuration",
	"select-notification-type": "Sélectionnez le type de notification",
	"select-organization-fot-file": "Sélectionnez l'organisation pour le fichier",
	"select-organization-to-see-connectors-or-to-create-new": "Sélectionnez l'organisation à laquelle vous souhaitez associer un connecteur",
	"select-product-reference": "Selectionnez un modèle",
	"select-properties": "Sélectionnez les propriétés",
	"select-properties-to-activate": "Sélectionnez les propriétés à activer",
	"select-properties-to-redirect-to-gateway": "Sélectionnez les propriétés que vous souhaitez rediriger vers votre passerelle, configurez-les et enregistrez-les.",
	"select-properties-xlsx": "Sélectionner les propriétés via un fichier",
	"select-property": "Choisir une propriété",
	"select-property-one-least": "Veuillez ajouter au moins une propriété.",
	"select-property-to-apply-interval": "Sélectionner une propriété pour voir le delta",
	"select-region-and-frequency-for-sensors": "Sélectionnez la région (si disponible) et la fréquence des capteurs.",
	"select-region-for-lorawan-equipment": "Sélectionnez l'une des régions prises en charge pour l'équipement LoRaWAN",
	"select-region-frequency-equipment-is-installed": "Sélectionnez la région et la fréquence d'installation de votre équipement",
	"select-rvl-equipment": "Sélectionnez l'équipement RVL",
	"select-the-properties": "Sélectionner les propriétés",
	"select-the-region": "Sélectionnez la région",
	"select-the-user-to-send-the-license-by-email": "Sélectionnez l'utilisateur pour envoyer la licence par e-mail",
	"select-to-activate": "Sélectionner les propriétés pour activer la fonctionnalité",
	"select-which-address-run-scan": "Sélectionner l'adresse sur laquelle lancer le scan",
	"selected": "Sélectionné",
	"selected-equipments": "Équipement séléctionné | Équipements sélectionnés",
	"selected-properties": "Propriétés sélectionnées",
	"send": "Envoyer",
	"send-archive-to": "Envoyer l'archive à",
	"send-configuration-to-hub": "Envoyer la configuration à la @.lower:hub",
	"send-configuration-to-the-box": "Envoyer la configuration à la @.lower:box",
	"send-license": "Envoyer la licence",
	"send-license-by-email": "Envoyer la licence par e-mail",
	"send-new-configuration-to-the-box": "Envoyer une nouvelle configuration à la @.lower:box",
	"send-the-configuration": "Envoyer la configuration",
	"send-updates-to-device": "Cocher pour envoyer les modifications à la box après la sauvegarde",
	"send-updates-to-device-infos": "Si vous avez plusieurs modifications à effectuer, cocher cette case lors de la sauvegarde de la dernière modification.",
	"sending-frequency": "Fréquence d'envoi",
	"sending-notifications": "Envoi des notifications",
	"sent-configuration-to-box-msg": "Enregistrement et application de la configuration de la @.lower:{'box'}. Attendez, s'il vous plaît.",
	"separate-values-with-semicolons": "Séparez les valeurs par une {comma}. N'indiquez pas l'unité. Utilisez {dot} avec les nombres décimaux.",
	"separator": "Séparateur",
	"separator-space-or-comma": "Séparateur : espace ou virgule",
	"serial-number": "Numéro de série",
	"server-host": "Hôte du serveur",
	"server-port": "Port du serveur",
	"service-account": "Compte de service",
	"service-account-deleted": "Compte de service supprimé avec succès",
	"service-account-updated": "Compte de service mis à jour avec succès",
	"set-out-of-service": "Désactiver ce congé",
	"set-to-null": "Mettre à null",
	"set-value": "Définir une valeur",
	"set-value-to-property": "Définir une valeur sur la propriété",
	"settings": "Réglages",
	"several-actions": "Actions sur plusieurs lignes",
	"severity": "Sévérité",
	"severity-level-to-apply-to-alerts": "Niveau de sévérité à appliquer aux alertes",
	"severity-level-to-apply-to-alerts-when-created": "Niveau de sévérité à appliquer aux alertes créées par l'alarme",
	"show-advanced-properties": "Voir les propriétés avancées",
	"show-all-properties": "Voir toutes les propriétés",
	"show-hide-default-values-in-calendar": "Afficher / masquer les valeurs par défaut dans le calendrier. Pour atlantic_navipass_weekly, la valeur par défaut est OFF. Pour BACnet, vous configurez la valeur sur les configurations.",
	"show-more-info": "Plus d'info",
	"show-more-organization": "Afficher plus d'organisation",
	"show-side-panel": "Afficher le volet",
	"sidebar-menu-item.collapse-sidepanel": "Fermer le volet",
	"sidebar-menu-item.company": "Organisation",
	"sidebar-menu-item.expand-sidepanel": "Ouvrir le volet",
	"sidebar-menu-item.home": "Accueil",
	"sidebar-menu-item.map": "Carte",
	"signal": "Signal",
	"signal-strength": "Qualité du signal",
	"sim-card.expired": "Carte SIM expirée",
	"skip-this-step": "Passer cette étape",
	"slave-id": "Adresse esclave",
	"slave-id-modbus-gateway": "L'identifiant d'esclave de cette passerelle Modbus",
	"slot": "Créneau",
	"slots": "Créneaux",
	"slug-name": "Nom du Slug",
	"sms": "SMS",
	"sms-to": "SMS à",
	"snvt-type-index": "SNVT Type Index",
	"software": "Logiciel",
	"some-fields-are-invalid": "Certains champs ne sont pas valides",
	"some-fields-are-required": "Certains champs sont obligatoires",
	"something-went-wrong": "Quelque chose s'est mal passé",
	"something-went-wrong-our-side-try-again": "Quelque chose d'anormal s'est produit de notre côté. Essayez à nouveau.",
	"something-went-wrong-try-again": "Quelque chose d'anormal s'est produit de notre côté. Essayez à nouveau.",
	"sort-by": "Trier par",
	"specific-mask-address": "Adresse de masque spécifique",
	"specify-condition": "Spécifier la condition",
	"spreading-factor": "Spreading Factor",
	"standard": "Standard",
	"start": "Début",
	"start-again": "Recommencer",
	"start-date": "Date de début",
	"start-index": "Index de départ",
	"start-time": "Temps de début",
	"started-at": "Commencé à",
	"starting-time": "Heure de début",
	"state-schedule-object-click-see-full-json": "Valeur de l'objet schedule. Cliquez pour afficher le schedule au format JSON",
	"status": "Etat",
	"status-down": "Etat : en panne",
	"status-for-connector-not-available": "L'état de ce connecteur n'est pas disponible",
	"status-missing": "Données manquantes",
	"status-ok": "Etat : OK",
	"stay": "Rester",
	"stay-at-this-page": "Rester sur cette page",
	"stay-here": "Stay here",
	"step-line": "En escalier",
	"stop-bits": "Stop bits",
	"stop-reception-property-data": "Arrêter la réception des valeurs des propriétés des équipements",
	"strict-ranges": "Plages strictes",
	"sub-field": "Sub-field",
	"sub-field-tooltip": "Le chemin d'accès au champ à extraire de la structure. Le chemin doit avoir la forme suivante : firstLevelStructure.secondLevelStructure....sous-champ, cela extraira la valeur du sous-champ de sa structure parente, quelle que soit la profondeur de la structure.",
	"subscription": "Abonnement",
	"subscription.expired": "Abonnement expiré",
	"subscription.expiring.soon": "Abonnement bientôt expiré",
	"subscription.suspended": "Abonnement suspendu",
	"success": "Succès",
	"success-creating-organization": "Création réussie d'une nouvelle organisation",
	"success-editing-organization": "Mise à jour de la organisation réussie",
	"successfully-added-properties": "Vous avez enregistré avec succès les propriétés",
	"successfully-dashboard": "Vous avez enregistré avec succès le dashboard",
	"successfully-saved-graph": "Le graphique a bien été enregistré",
	"successfully-updated": "Mise à jour réussie",
	"summary": "Aperçu",
	"sunday": "Dimanche",
	"support-contact": "Contactez l'équipe support",
	"support-forum": "Centre d'aide",
	"supported-frequencies": "Fréquences supportées",
	"swap-boxes": {
		"command-timeout-msg": "Le temps alloué pour l'exécution de la commande est échue. Veuillez retourner à l'étape précédente et réessayer",
		"page-title": "Echanger @.lower:box {'|'} {boxName}",
		"step1": {
			"breadcrumb": "Prérequis",
			"msg1": "Merci de respecter les conditions suivantes.",
			"msg2": "1. La demande de RMA (Return Merchandise Authorization) a été approuvée et vous êtes en possession de la nouvelle @.lower:{'box'}.{br}2. Vous êtes sur site en présence des deux boxes.{br}3. La @.lower:box en erreur est alimentée et elle apparait en ligne dans la console (statut vert).{br}4. A partir de maintenant, veuillez ne pas éditer la configuration de la @.lower:box en erreur",
			"next-btn": "Je confirme, continuer",
			"title": "Avertissement",
			"warning": "Si une de ces conditions n'est pas remplie, veuillez stopper le processus et procéder à sa résolution."
		},
		"step2": {
			"accordion-msg-eu": "Si la @.lower:box est située en Europe",
			"accordion-msg-na": "Si la @.lower:box est située en Amérique du Nord",
			"accordion-title": "Où trouver le numéro de série de la @.lower:box ?",
			"breadcrumb": "Nouvelle @.lower:box",
			"current-box-serial-number": "Numéro de série de la @.lower:box en erreur",
			"msg1": "Scanner ou renseigner le numéro de série indiqué sur l'étiquette.",
			"new-box-serial-number": "Numéro de série de la nouvelle @.lower:box",
			"next-btn": "Suivant",
			"siemens-serial-number-1": "Numéro de série de la nouvelle @.lower:box",
			"siemens-serial-number-2": "Code de vérification",
			"siemens-serial-number-2-help-msg": "Derniers chiffres après -",
			"siemens-serial-number-fields-required": "Le numéro de série et le code de vérification sont requis",
			"siemens-serial-number-no-access": "Vous n'avez pas accès à la @.lower:box",
			"siemens-serial-number-wrong-crc": "Code de vérification (CRC) invalide. Veuillez vérifier le code et réessayer.",
			"siemens-serial-number-wrong-device-version": "Ces deux @.lower:boxes ne peuvent pas être échangées car elles utilisent des versions logicielles LoRaWAN différentes. Veuillez vous assurer que les deux @.lower:boxes utilisent la même version (les deux utilisent BSP >= 8.x OU BSP < 8.x), puis réessayez.",
			"siemens-serial-number-wrong-hardware-id": "Numéro de série invalide. Veuillez vérifier le numéro et réessayer.",
			"title": "Renseignez le numéro de série de la nouvelle @.lower:box"
		},
		"step3": {
			"breadcrumb": "Confirmation",
			"configuration": "Configuration (Connecteurs, Réseaux, Routage, Equipements, Passerelles...) ",
			"configuration-to-be-transferred": "Configuration à transférer",
			"current-box-title": "@.capitalize:box en erreur (à renvoyer)",
			"lorawan-configuration": "Configuration LoRaWAN",
			"msg": "Les éléments suivants seront permutés de la @.lower:box en erreur vers la nouvelle @.lower:{'box'}.",
			"next-btn": "Confirmer le transfert",
			"replacement-box-title": "Nouvelle @.lower:box",
			"title": "Transfert de configuration"
		},
		"step4": {
			"backup-done": "Sauvegarde de la configuration LoRaWAN faite",
			"backup-failed": "Sauvegarde de la configuration LoRaWAN",
			"backup-in-progress": "Sauvegarde de la configuration LoRaWAN",
			"breadcrumb": "Sauvegarde LoRaWAN",
			"error-message": "Erreur : la sauvegarde de la configuration LoRaWAN pour le device ID \"{deviceId}\" a échoué. Veuillez revenir en arrière et essayer à nouveau",
			"msg": "Ne pas débrancher la @.lower:box en erreur avant de voir afficher le message de confirmation",
			"next-btn": "Suivant",
			"title": "Sauvegarde de la configuration LoRaWAN"
		},
		"step5": {
			"breadcrumb": "Débrancher / Brancher",
			"msg": "Attendez que les voyants « Heartbeat » et « GSM » clignotent en vert. La nouvelle @.lower:box se mettra à jour et se connectera. L'ensemble du processus dure en moyenne 10 minutes.",
			"new-box-outdated-and-no-auto-update": "La version de la nouvelle @.lower:box n'est pas la bonne ou ses mises à jour automatiques sont désactivées. Veuillez revenir en arrière et mettre à jour la @.lower:box avant de poursuivre",
			"next-btn": "La nouvelle @.lower:box est branchée, continuer",
			"title": "Débrancher la @.lower:box en erreur et brancher la nouvelle @.lower:box"
		},
		"step6": {
			"breadcrumb": "Préparartion de la nouvelle @.lower:box",
			"error-msg": "Erreur : impossible de transférer la configuration vers la nouvelle @.lower:{'box'}. Veuillez revenir en arrière et réessayer.",
			"error-msg-lora-import": "Erreur : Erreur dans le téléchargement de la configuration LoRaWAN. Veuillez utiliser le bouton à droite pour le relancer. Si cela échoue à nouveau, contacter le support technique.",
			"error-msg-publish": "Erreur : Erreur dans l'export/import de la configuration dans la nouvelle @.lower:{'box'}. Veuillez utiliser le bouton à droite pour le relancer. Si cela échoue à nouveau, contacter le support technique.",
			"export-import-msg": "Export/Import de la configuration de la @.lower:box en erreur",
			"lorawan-import-msg": "Téléchargement de la configuration LoRaWAN de la @.lower:box en erreur",
			"msg": "Ne pas débrancher la @.lower:box avant la fin du processus",
			"next-btn": "Accéder à la @.lower:box",
			"retry-msg": "Réessayer",
			"success-msg": "La nouvelle @.lower:box est désormais opérationnelle. La @.lower:box en erreur est prête à être renvoyée.{br}{br}Étapes suivantes recommandées :{br}1. Vérifiez que les données des capteurs s'affichent correctement dans la console.{br}2. Renvoyez la box en erreur à l'aide de l'étiquette RMA.",
			"success-title": "Transfert de @.lower:box réussi !",
			"title": "Préparation de la nouvelle @.lower:box"
		},
		"swap-btn": "Transférer la @.lower:box"
	},
	"sync": "Sync.",
	"synchronized": "Synchronisé",
	"synco-exception-day": "Horaire défini au 8e jour (horaire d'exception)",
	"synco-exception-disable-text": "Désactiver l'exception",
	"synco-exception-disable-text-help": "Si vous désactivez l'exception, l'équipement réinitialisera les détails de l'exception à null",
	"synco-exception-end-day-label": "Fin le (inclus)",
	"synco-exception-help-msg": "Comme l'équipement est de type Synco, veuillez faire attention lorsque vous modifiez les exceptions. Si une exception est désactivée, cette exception peut être attribuée à une autre exception comme propriété. Par conséquent, veuillez lire la valeur des différentes exceptions avant d'en modifier une.",
	"synco-exception-invalid-range": "Les jours de début et de fin doivent être cohérents",
	"synco-exception-period": "Mode REDUIT ou mode PROTECTION (mode eco)",
	"synco-exception-start-day-label": "Démarre le",
	"synco-exception-type": "Horaire à appliquer pendant l'exception",
	"system-lorawan-property-tooltip": "Cette propriété n'est pas décomptée des propriétés disponibles avec votre abonnement",
	"table": "Tableau",
	"table-block-label-a": "Libellé en-tête colonne A",
	"table-block-label-b": "Libellé en-tête colonne B",
	"table-block-label-c": "Libellé en-tête colonne C",
	"table-block-nb-of-columns": "Nombre de colonnes (A, B, C...)",
	"table-block-nb-of-rows": "Nombre de lignes (1, 2, 3...)",
	"table-block-title-1": "Libellé ligne 1",
	"table-block-title-2": "Libellé ligne 2",
	"table-block-title-3": "Libellé ligne 3",
	"tabs.organization.devices": "@.capitalize:_boxes",
	"tag-can-start-with-ws": "La clé d'un tag ne peut pas commencer par ws_",
	"tag-key-cant-be-empty": "La clé d'un tag ne peut pas être vide",
	"tags": "Tags",
	"target": "Cible",
	"tcp-port": "Port TCP",
	"technical-contact": "Contact technique",
	"telephone": "Téléphone",
	"telephone-number": "Numéro de téléphone",
	"test-in-progress": "Test en cours",
	"test-route": "Tester la route",
	"test-routing-table": "Tester la table de routage",
	"the-certificate-has-to-be-of-type-MQTT_CA_CERTIFICATE": "Le certificat doit être de type MQTT_CA_CERTIFICATE",
	"the-certificate-has-to-be-type-MQTT_CLIENT_CERTIFICATE": "Le certificat doit être de type MQTT_CLIENT_CERTIFICATE",
	"the-certificate-has-type-MQTT_PRIVATE_KEY": "Le certificat doit être de type MQTT_PRIVATE_KEY",
	"the-end-customer": "Le client final",
	"the-max-cpu-usage-percent": "L'utilisation maximale du processeur en pourcentage",
	"the-new-scan-in-progress-while-is-completed-do-you-want-see-former-scan-new-scan-results-will-shown-when-over": "Le nouveau scan est en cours d'exécution. En attendant qu'il se termine, souhaitez-vous voir les données du précédent scan ? Les résultats du nouveau scan seront affichés dès qu'il sera terminé.",
	"the-new-scan-is-over-do-you-want-to-load-its-results": "Le nouveau scan est terminé. Voulez-vous charger son contenu ?",
	"the-number-of-registers-to-read-write": "Le nombre de registres à lire/écrire",
	"the-port-network-will-list": "La porte sur lequel ce réseau écoutera.",
	"the-trigger-will-execute-only-for-boxes-listed-below": "Le trigger ne se déclenchera que pour les @.lower:boxes listées ci-dessous",
	"the-type-of-the-register-to-use": "Le type de registre à utiliser",
	"the-value-is-not-a-valid-URL-address": "La valeur n'est pas une adresse URL valide",
	"then": "Alors",
	"this-connector-doesnt-have-any-trigger": "Ce connecteur n'a pas encore de triggers",
	"this-device-does-not-have-access-to-heating-optimizer": "Cette @.lower:box n'a pas accès à l'optimiseur de relance. Contactez le support, s'il vous plaît.",
	"this-property-isnt-receiving-any-redirections": "Cette propriété ne reçoit aucune redirection",
	"this-property-isnt-redirecting-its-values": "Cette propriété ne redirige pas ses valeurs",
	"this-property-receives-values-from-properties-listed-below": "Cette propriété reçoit des valeurs des propriétés répertoriées ci-dessous",
	"this-property-will-redirect-all-values-to-properties-listed-below": "Cette propriété redirigera toutes les valeurs vers les propriétés répertoriées ci-dessous",
	"this-will-archive-connecor-and-triggers-attached-you-will-no-longer-receive-data-through-the-connector": "Le connecteur \"{connector}\" sera archivé ainsi que les triggers qui y sont rattachés. Vous ne recevrez plus de données sur le connecteur.",
	"this-will-delete-x-properties-from-gateway": "Cela supprimera 1 propriété de la passerelle | Cela supprimera {x} propriétés de la passerelle",
	"this-will-delete-x-properties-past-values-will-be-deleted": "Ceci supprimera 1 propriété. Toutes les anciennes valeurs de la propriété seront supprimées. | Cela supprimera {x} propriétés. Toutes les anciennes valeurs des propriétés seront supprimées.",
	"thursday": "Jeudi",
	"tile-alone": "Valeur unique",
	"tile-configuration-link": "Configurer la propriété",
	"tile-history-link": "Voir les dernières valeurs",
	"time": "Heure",
	"time-to-reach": "Il est temps d'atteindre le confort",
	"times": "fois",
	"title": "Titre",
	"tls-certificate": "Certificat TLS",
	"to": "À",
	"to-create-data-stream-have-at-least-one-connector-one-trigger-connectors-specify-link-infrastructures": "Pour créer un data stream, que se soit un webhook ou une connexion MQTT cloud to cloud, vous devez créer au moins un connecteur et un trigger. Un connecteur spécifie un lien vers votre infrastructure.",
	"to-list-equipment-properties-available-select-box-connector": "Pour lister toutes les propriétés disponibles des équipements, sélectionner le connecteur de la @.lower:box",
	"toast.alarm-saved": "Alarme créée",
	"toast.hub-received-command": "@.capitalize:client-name-hub a reçu la commande",
	"toast.scan-bacnet-devices-in-progress-percentage": "Scan des appareils BACnet en cours ({percentage}%)",
	"toast.waiting-for-hardware-connection": "Tentative de connexion du @.capitalize:client-name-hub à notre serveur, veuillez patienter",
	"toast.weekly-schedule.days-copied-successfully": "Le programme a été appliqué avec succès aux jours sélectionnés",
	"today": "Aujourd'hui",
	"token-validity-period": "Période de validité du token",
	"tooltip-alarm-status": "<strong class='has-text-white'>Acquitter</strong> : indiquer l'alarme comme \"acquittée\". Aucune nouvelle notification ne sera envoyée sauf si l'alarme se déclenche à nouveau après 24h <br /><br /> <strong class='has-text-white'>Rouvrir</strong> : l'alarme sera ouverte à nouveau. Ne modifie pas le statut des alertes associées à l'alarme",
	"tooltip-wmbus-device-type": "Chaîne hexadécimale de 2 caractères trouvée sur l'étiquette ou la documentation de l'appareil",
	"tooltip-wmbus-dib": "Concaténez les DIFs et DIFEs en hexadécimal. Exemple : avec DIF=01 DIF=02 DIFE=03 DIFE=04, utilisez 01020304",
	"tooltip-wmbus-encryption": "Indique si l'appareil utilise le chiffrement (profil A)",
	"tooltip-wmbus-id-number": "Aussi appelé \"Numéro de série\", numéro à 8 chiffres figurant sur l'étiquette de l'appareil",
	"tooltip-wmbus-mode": "En écoutant les capteurs wM-Bus de ce mode, utilisez \"T & C\"si vous avez à la fois des capteurs T et C",
	"tooltip-wmbus-physical-connector": "wM-Bus et LoRaWAN utilisent le même connecteur physique",
	"tooltip-wmbus-version-number": "Aussi appelé \"Protocol Version\", chaîne hexadécimale de 2 caractères trouvée sur l'étiquette de l'appareil ou la documentation",
	"tooltip-wmbus-vib": "Concaténez à la fois les VIFs et les VIFEs en hexadécimal. Exemple : avec VIF=01 VIF=02 VIFE=03 VIFE=04, utilisez 01020304",
	"tooltip.advanced-config-error": "Pour créer l'équipement, éditez la configuration.",
	"tooltip.bacnetscan.select-device-to-add-properties": "Sélectionner l'équipement pour afficher les propriétés disponibles",
	"tooltip.bacnetscan.total-raw-properties": "Nombre total de propriétés scannées",
	"tooltip.bacnetscan.total-selectable-properties": "Propriétés sélectionnables",
	"tooltip.bacnetscan.total-selected-properties": "Propriétés sélectionnées",
	"tooltip.box-timezone": "Le planning s'exécutera selon l'heure locale définie dans la @.lower:{'box'}.",
	"tooltip.edit-advanced-config": "Editer la configuration avancée",
	"tooltip.last-read-value-data-time": "Dernière valeur lue : {value} {unit}{asterisk}, {dateTime}",
	"tooltip.last-written-value-data-time": "Dernière valeur écrite depuis la console par un utilisateur : {value} {unit}{asterisk}, {dateTime}",
	"tooltip.lorawan-codec.manufacturer-and-product-reference": "Associer le modèle correspondant à votre équipement pour activer le décodage automatique des trames LoRaWAN",
	"tooltip.satellite-rate-plan.parent-box": "Vous activez une @.lower:box avec une licence Satellite. Vous devez sélectionner la @.lower:box parente ayant une licence Medium ou Large, située sur le même site et déjà activée. Votre @.lower:box satellite sera alors rattachée à la @.lower:box parente.",
	"tooltip.schedules-exceptions.edit": "Modifier l'exception",
	"tooltip.schedules-exceptions.move-down": "Descendre",
	"tooltip.schedules-exceptions.move-up": "Monter",
	"tooltip.schedules-exceptions.remove": "Supprimer de la sélection",
	"tooltip.schedules-properties.remove": "Supprimer de la sélection",
	"tooltip.schedules-properties.remove-property": "Retirer du planning",
	"tooltip.schedules.live-data-calendar-icon": "Cette propriété est contrôlée par le planning {schedules}. | Cette propriété est contrôlée par les plannings : {schedules}.",
	"tooltip.schedules.setpoint-scaling": "Si une mise à l'échelle de type “ax + b” est appliquée dans la configuration de la propriété, alors elle sera visible dans cette colonne. A savoir :<br />- La valeur est uniquement mise à l'échelle quand elle est lue sur la console<br />- La mise à l'échelle n'est pas prise en compte à l'écriture de la valeur<br />- A l'intérieur de la box (redirection), la mise à l'échelle n'est pas prise en compte",
	"total-properties": "Propriétés totales :",
	"trigger-alert-based-on": "Déclencheur",
	"trigger-saved": "Trigger enregistré",
	"trigger-type": "Type de trigger",
	"triggers-define-required-call-connector-and-what-values-send": "Un trigger liste les conditions nécessaires pour appeler le connecteur avec les informations désirées.",
	"try-again": "Réessayer",
	"tuesday": "Mardi",
	"type": "Type",
	"type-licence-to-attach-to-device": "Type de licence à rattacher à la box",
	"tz.local": "Heure locale",
	"tz.utc": "Heure UTC",
	"udp-port": "Port UDP",
	"udp-port-custom": "Port UDP personnalisé",
	"udp-port-custom-help": "Numéro du port (ex : 50808)",
	"unique-id": "ID Unique",
	"unit": "Unité",
	"unknown": "Nouveau",
	"unknown-status": "Le statut ne peut pas être déterminé",
	"unpair": "Dissocier",
	"update": "Mettre à jour",
	"update-archive-request": "Modifier la demande d'archive {name}",
	"update-hub": "Mettre à jour la @.lower:hub",
	"update-name": "Appliquer les modifications aux passerelles",
	"update-name-equipment-in-gateway": "Mettre à jour le nom de l'équipement dans les passerelles",
	"update-properties": "Mettre à jour les propriétés",
	"update-property-changes-in-gateway": "Appliquer les modifications de la propriété aux passerelles",
	"update-the-scan": "Mettre à jour le scan",
	"update-the-trigger": "Mettre à jour le trigger",
	"update-your-password": "Mise à jour du mot de passe",
	"updated": "Mis à jour",
	"uplink-topic": "Uplink topic",
	"uplink-topic-for-alarms": "Uplink topic pour alarms",
	"uplink-topic-for-events": "Uplink topic pour events",
	"uplink-topic-for-values": "Uplink topic pour values",
	"upload-configuration": "Charger une configuration",
	"upload-configuration-will-delete-current-after-send-hub": "Charger une nouvelle configuration dans {deviceName}, supprimera et remplacera la configuration actuelle une fois envoyée.",
	"url": "URL",
	"use-mask-identification-number": "Utiliser un masque sur le numéro d'identification",
	"use-old-scan": "Utiliser l'ancien scan",
	"use-previous-scan": "Utiliser ce scan",
	"use-single-bit": "Lire un seul bit",
	"user": "Utilisateur",
	"user-information": "Information utilisateur",
	"user-management": "Gestion des utilisateurs",
	"user-profile": "Profil de l'utilisateur",
	"user-profile-updated-with-success": "Profil utilisateur mis à jour avec succès",
	"user-saved": "Utilisateur enregistré",
	"username": "Nom d'utilisateur",
	"username-used-in-the-authentication": "Le nom d'utilisateur utilisé dans l'authentification",
	"validate": "Valider",
	"validate-recipient": "Valider ce destinataire",
	"validations.value.required": "La valeur est requise",
	"validator.check-your-email-address": "Vérifiez votre adresse email",
	"value": "Valeur",
	"value-before-last-value": "Précédente valeur reçue le :",
	"value-from-property-at-scan-time": "Valeur de la propriété au moment du scan {time}",
	"value-most-not-have-more-than-characters": "La valeur ne doit pas comporter plus de {length} caractères",
	"value-must-be-a-decimal": "La valeur doit être une décimale",
	"value-must-be-an-integer": "La valeur doit être un integer",
	"value-must-be-between": "La valeur doit être comprise entre {min} et {max}",
	"value-must-be-numeric": "La valeur doit être numérique",
	"value-must-have-at-least-characters": "La valeur doit comporter au moins {length} caractères",
	"value-must-have-x-characters": "La valeur doit comporter {characters} caractères",
	"value-not-accepted": "Valeur non acceptée",
	"value-of-nv-index": "La valeur de NV Index",
	"value-of-snvt-type-index": "La valeur de SNVT Type Index",
	"value-should-be": "La valeur doit être {value}",
	"value-type-function": "Type de valeur (fonction)",
	"values": "Valeurs",
	"values-route": "Route values",
	"values-url": "URL des valeurs",
	"vendor-specific-apn-link": "Le lien APN spécifique au fournisseur",
	"verifiation-code": "Le code de vérification",
	"verification-code": "Code de vérification",
	"version": "Version",
	"version-history": "Historique des versions",
	"version-number": "Numéro de version",
	"views.account-settings.views.service-accounts.service-accounts.add-service-account": "Ajouter un compte de service",
	"views.account-settings.views.service-accounts.views.service-account.description": "Description",
	"views.account-settings.views.service-accounts.views.service-account.username": "Nom d'utilisateur",
	"views.account-settings.views.users.users.failed-get-users": "Impossible d'obtenir la liste des utilisateurs.",
	"views.auth.activation.backlogin": "Connectez vous ici",
	"views.auth.activation.backlogin.question": "Vous avez déjà un compte ?",
	"views.auth.activation.confidential": "En activant mon compte, j'accepte la ",
	"views.auth.activation.confidential-underline": "politique de confidentialité et les conditions d'utilisation.",
	"views.auth.activation.failed-account": "Si votre compte existe déjà,",
	"views.auth.activation.failed-account-backLogin": "connectez-vous ici",
	"views.auth.activation.failed-username-point1": "Vérifiez votre adresse email",
	"views.auth.activation.failed-username-point2": "Assurez-vous auprès de l'administrateur de votre organisation que vos accès ont été initialisés",
	"views.auth.activation.introduction": "C'est la première fois que vous accédez à la console ? Commencez par activer votre compte.",
	"views.auth.activation.log-to-proceed": "Activer votre compte",
	"views.auth.activation.opt-in-newsletter": "Recevoir des informations sur les nouvelles fonctionnalités par email (1  par trimestre).",
	"views.auth.activation.optin": "Recevoir des informations sur les nouvelles fonctionnalités par email (1 par trimestre)",
	"views.auth.email-sent-with-link-reset-password": "Nous avons envoyé votre lien de réinitialisation de mot de passe par e-mail!",
	"views.auth.inform-valid-email": "Entrez une adresse e-mail valide",
	"views.auth.login.failed-account": "Si c'est votre première visite,",
	"views.auth.login.failed-account-backActivation": "activez votre compte ici",
	"views.auth.login.failed-login": "Ops! Échec de la connexion! Vérifiez vos informations d'identification!",
	"views.auth.login.failed-username-point1": "Corrigez votre adresse email ou mot de passe",
	"views.auth.login.log-to-proceed": "Connectez-vous à votre compte",
	"views.auth.login.password": "Mot de passe",
	"views.auth.login.password-confirm": "Confirmez le mot de passe",
	"views.auth.login.password-min-8-chars": "Votre mot de passe doit avoir au moins 8 caractères",
	"views.auth.login.passwords-dont-match": "Les mots de passe ne sont pas identiques",
	"views.auth.request-new-password.backlogin": "Revenir à la connexion",
	"views.auth.request-new-password.password": "Réinitialiser le mot de passe",
	"views.auth.request-new-password.reset-password-email-sent-p1": "Le lien de réinitialisation de mot de passe a été envoyé à votre adresse email.",
	"views.auth.request-new-password.reset-password-email-sent-p2": "Vous le recevrez dans les 5 minutes. Pensez à vérifier votre boite de courriers indésirables.",
	"views.auth.request-new-password.subtitle": "Indiquez votre adresse email, vous recevrez un lien pour réinitialiser votre mot de passe.",
	"views.auth.request-new-password.title": "Mot de passe oublié ?",
	"views.auth.reset-password.backlogin": "Revenir à la connexion",
	"views.auth.reset-password.loginsystem": "Se connecter",
	"views.auth.reset-password.reset": "Réinitialiser le mot de passe",
	"views.auth.reset-password.success": "Votre mot de passe a été réinitialisé. Vous pouvez vous connecter.",
	"views.auth.reset-password.title": "Réinitialiser le mot de passe",
	"views.auth.setup.account-configured-ready-to-use": "Vous pouvez maintenant vous connecter à la console.",
	"views.auth.setup.add-users-to-organization": "Ajoutez des utilisateurs à votre Organisation",
	"views.auth.setup.back": "Retour à la connexion",
	"views.auth.setup.click-to-go-user-console": "Se connecter",
	"views.auth.setup.code": "Entrez le code que vous avez reçu par Email",
	"views.auth.setup.code-sent-to-email": "Le nouveau code a été envoyé à {email}",
	"views.auth.setup.code.check-email": "Vérifiez votre email",
	"views.auth.setup.code.failed": "Le code est incorrect. Vérifiez le ou ",
	"views.auth.setup.code.failed.new-code": "demandez un nouveau code.",
	"views.auth.setup.code.get-new-code": "Recevoir un nouveau code",
	"views.auth.setup.code.introduction": "Nous vous avons envoyé un code de confirmation à {email}.",
	"views.auth.setup.code.introduction-to-enter": "Veuillez le saisir ci-dessous pour confirmer votre adresse e-mail.",
	"views.auth.setup.code.introduction.without-email": "Nous vous avons envoyé un code de confirmation.",
	"views.auth.setup.contacts": "Choisissez les contacts de votre Organisation",
	"views.auth.setup.continue": "Continuer",
	"views.auth.setup.create-password": "Créez un mot de passe pour sécuriser la connexion",
	"views.auth.setup.failed-requesting-new-code": "Nous ne pouvons pas envoyer le code à {email}. Contactez-nous à contact{'@'}wattsense.com",
	"views.auth.setup.failed-saving-user": "Échec de l'enregistrement {user}",
	"views.auth.setup.finish.title": "Compte activé",
	"views.auth.setup.inform-valid-email": "Entrez une adresse e-mail valide",
	"views.auth.setup.inform-valid-name": "Entrez un nom",
	"views.auth.setup.is-user-admin": "Administrateur de l'organisation ?",
	"views.auth.setup.organization": "Dites-nous en plus sur votre organisation",
	"views.auth.setup.organization-name": "Nom de votre Organisation",
	"views.auth.setup.request-new-code": "Vous n'avez pas reçu le code ou est-il expiré? Cliquez ici pour en obtenir un nouveau!",
	"views.auth.setup.set-your-password-below": "Veuillez maintenant définir votre mot de passe.",
	"views.auth.setup.skip": "Passer",
	"views.auth.setup.try-again": "Oops! Merci de réessayer",
	"views.auth.setup.user-name": "Nom complet",
	"views.auth.setup.user-remove": "Supprimer",
	"views.auth.setup.users-saved": "Utilisateurs créés",
	"views.auth.username.password.failed-title": "Une erreur est survenue",
	"views.box-list-map.box-list-map.failed-getting-devices": "Échec d'obtention de la liste des @.lower:boxes",
	"views.box-list-map.components.map.location": "Ajouter / Changer l'address",
	"views.box-list-map.components.map.zoom": "Zoom",
	"views.box-list-map.components.search-address.address-not-found": "Adresse introuvable",
	"views.box-list.box-list.failed-get-box-list": "Impossible d'obtenir la liste des @.lower:{'boxes'}.",
	"views.box-list.box-list.failed-get-box-location": "Impossible d'obtenir la localisation de la @.lower:{'box'}.",
	"views.box-list.box-list.failed-get-search-location": "Impossible d'obtenir la localisation de la recherche.",
	"views.box-list.box-list.search": "Rechercher une adresse",
	"views.box-list.box-list.search-for-box": "Rechercher une @.lower:box (nom, device id ou hardware id)",
	"views.box-list.components.dialog-active-box.box-plan-addonsmax": "Plugins : ",
	"views.box-list.components.dialog-active-box.box-plan-datapoints": "Points max : ",
	"views.box-list.components.dialog-active-box.box-plan-properties": "Points inclus : ",
	"views.box-list.components.inactive-device.inactive-box": "@.capitalize:box Inactive",
	"views.box.box.failed-get-box-info": "Échec d'obtention des informations de la @.lower:box",
	"views.box.components.box-nav.box-nav.configuration": "Configuration",
	"views.box.components.box-nav.box-nav.graph": "Graphiques",
	"views.box.components.box-nav.box-nav.logs": "Logs",
	"views.box.components.dialog-edit-box-geolocation.dialog-edit-box-geolocation.box-geolocation-changed": "Le géolocalisation de la @.lower:box a changé",
	"views.box.components.dialog-edit-box-geolocation.dialog-edit-box-geolocation.failed-saving-new-geolocation": "Échec de la sauvegarde de la nouvelle géolocalisation",
	"views.box.components.dialog-edit-box-name.dialog-edit-box-name.box-name-changed": "Le nom de la @.lower:box a changé",
	"views.box.old-config": "Il semble que votre boîte soit obsolète. Veuillez contacter notre équipe pour mettre à jour votre @.lower:{'box'}.",
	"views.box.views.configuration.components.footer-buttons.cancel-sent-changes": "Annuler les modifications envoyées",
	"views.box.views.configuration.components.footer-buttons.cant-send-configuration-box-not-online": "Pas autorisé à envoyer la configuration à la @.lower:box car elle n'est pas en ligne",
	"views.box.views.configuration.components.footer-buttons.failed-getting-command-details": "Échec d'obtention des détails de la commande",
	"views.box.views.configuration.components.footer-buttons.failed-getting-device-information": "Impossible d'obtenir l'état de la @.lower:box",
	"views.box.views.configuration.components.footer-buttons.failed-reverting-changes": "Échec de l'annulation des changements",
	"views.box.views.configuration.components.footer-buttons.failed-saving-configuration": "Échec de l'envoi de la configuration à la @.lower:box",
	"views.box.views.configuration.components.footer-buttons.message-revert-sent-changes": "Annuler les modifications envoyées (elles n'ont pas encore été appliquées à la @.lower:{'hub'})?",
	"views.box.views.configuration.components.footer-buttons.new-configuration-in-box": "La nouvelle configuration est dans la @.lower:box !",
	"views.box.views.configuration.components.modal-publish-draft.comment": "Écrire un commentaire ce nouveau paramètre envoyé à la @.lower:box",
	"views.box.views.configuration.components.modal-publish-draft.placehoder": "Une description de la révision. Utile pour lister les changements apportés à la révision.",
	"views.box.views.configuration.components.modal-publish-draft.send-to-box": "Envoyer à la @.lower:box",
	"views.box.views.configuration.components.modal-publish-draft.title": "Envoyer la configuration à la @.lower:box",
	"views.box.views.configuration.components.tabs.connectors": "Connecteurs",
	"views.box.views.configuration.components.tabs.equipment": "Équipements",
	"views.box.views.configuration.components.tabs.gateways": "Passerelles",
	"views.box.views.configuration.components.tabs.networks": "Réseaux",
	"views.box.views.configuration.views.connectors.components.panel-connector.tooltip-ipv4-method": "Le type de configuration IP: manuel pour spécifier manuellement l'IP, ou DHCP",
	"views.box.views.configuration.views.connectors.connectors-list.failed-adding-new-connector-to-draft": "Échec de l'enregistrement du connecteur {connector} dans la configuration brouillon",
	"views.box.views.configuration.views.connectors.connectors-list.failed-get-draft-current-config": "Échec d'obtention de connecteur à partir de la configuration actuelle / brouillon",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.duplicate-to-box": "Dupliquer dans la @.lower:box",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.select-box-to-duplicate": "Sélectionnez la @.lower:box dans laquelle vous souhaitez dupliquer cet équipement",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.to-which-box-duplicate": "Dans quelle @.lower:box souhaitez-vous dupliquer?",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.to-which-network-add-box": "À quel réseau souhaitez-vous ajouter la @.lower:box dupliquée?",
	"views.box.views.configuration.views.equipment.components.panel-equipment.device-identifier": "Identifiant de périphérique unique fourni par le fabricant",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups": "Groupes d'équipements",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.add": "Ajouter le groupe",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.all": "Tous les équipements",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.group-name": "Nom du groupe",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.group-name-mandatory": "Le nom du groupe est obligatoire.",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.hint": "Pour déplacer un équipement vers un groupe, cliquez sur le menu déroulant à droite",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.no-equipment": "Pas d'équipement",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.ungrouped": "Aucun groupe",
	"views.box.views.configuration.views.equipment.equipment-list.ask-delete-this-equipment": "Êtes-vous certain de vouloir supprimer cet équipement?",
	"views.box.views.configuration.views.equipment.equipment-list.equipment-network-updated": "Réseau de l'équipement mis à jour",
	"views.box.views.configuration.views.equipment.equipment-list.equipment-saved": "Équipement enregistré",
	"views.box.views.configuration.views.equipment.equipment-list.failed-get-draft-current-config": "Échec d'obtention de la configuration draft/current de l'équipement",
	"views.box.views.configuration.views.equipment.equipment-list.failed-updating-equipment": "Échec de la mise à jour de l'équipement",
	"views.box.views.configuration.views.equipment.equipment-list.failed-updating-network": "Échec de la mise à jour du réseau de l'équipement",
	"views.box.views.configuration.views.equipment.equipment-list.remember-send-to-box": "Ne pas oublier de sauvegarder sur la @.lower:box",
	"views.box.views.configuration.views.equipment.equipment-list.scan-save-configuration": "Pour utiliser ce réseau dans le Scan, il faut sauvegarder la configuration sur la @.lower:box .",
	"views.box.views.configuration.views.gateways.failed-get-draft-current-config": "Échec d'obtention de la configuration actuelle / provisoire pour les passerelles",
	"views.box.views.configuration.views.gateways.gateway-deleted": "Passerelle supprimée",
	"views.box.views.configuration.views.networks.components.connector.baudrate": "Baudrate",
	"views.box.views.configuration.views.networks.components.connector.data-bits": "Nombre de Data bits",
	"views.box.views.configuration.views.networks.components.connector.failed-getting-infos-from-connector": "Impossible d'obtenir des informations du connecteur",
	"views.box.views.configuration.views.networks.components.connector.parity": "Parité",
	"views.box.views.configuration.views.networks.components.connector.stop-bits": "Nombre de bits de stop",
	"views.box.views.configuration.views.networks.components.connector.you-have-to-select-field": "Vous devez sélectionner un {field}",
	"views.box.views.configuration.views.networks.components.network-row.device-number": "Numéro d'appareil",
	"views.box.views.configuration.views.networks.components.network-row.segment-number": "Numéro de segment",
	"views.box.views.configuration.views.networks.components.panel-network.device-instance": "@.capitalize:box device instance",
	"views.box.views.configuration.views.networks.components.panel-network.domain": "Domaine",
	"views.box.views.configuration.views.networks.components.panel-network.failed-saving-network": "Échec de la sauvegarde du réseau",
	"views.box.views.configuration.views.networks.components.panel-network.mode": "Mode",
	"views.box.views.configuration.views.networks.components.panel-network.mode-placeholder": "Sélectionnez le mode dans lequel ce réseau fonctionnera",
	"views.box.views.configuration.views.networks.components.panel-network.network-saved": "Réseau enregistré",
	"views.box.views.configuration.views.networks.components.panel-network.node": "Node",
	"views.box.views.configuration.views.networks.components.panel-network.placeholder-device-instance": "Une device instance pour ce réseau. Cette device instance doit être unique sur la @.lower:box .",
	"views.box.views.configuration.views.networks.components.panel-network.placeholder-frequency": "Sélectionnez la fréquence",
	"views.box.views.configuration.views.networks.components.panel-network.subnet": "Sous-réseau",
	"views.box.views.configuration.views.networks.components.panel-network.timeout": "Timeout",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-device-number": "Le device number de la @.lower:box",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-domain": "Le domaine de la @.lower:box sur le réseau LON IP",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-individual-address": "L'adresse individuelle de la boîte. Au format A.L.D, ex: 1.2.3",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-internal-address": "Les adresses utilisée en interne sur la boîte. Au format A.L.D; ex: 1.2.3",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-node": "Le node de la @.lower:box sur le réseau LON IP",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-placeholder-frequency": "Sélectionnez la fréquence d'installation de l'équipement LoRa.",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-placeholder-region": "Sélectionnez la région d'installation de l'équipement LoRa.",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-port": "Le port sur lequel ce réseau va écouter",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-segment-number": "Le numéro de segment de la @.lower:box elle-même",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-subnet": "Le sous-réseau de la @.lower:box sur le réseau LON IP",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-timeout": "Temps maximum pour la demande de traitement en ms",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-udp-port": "Port UDP attendu. Cette valeur est unique pour un connecteur physique spécifique.",
	"views.box.views.configuration.views.networks.network-list.failed-deleting-network": "Échec de la suppression du réseau",
	"views.box.views.configuration.views.networks.network-list.failed-get-draft-current-config": "Échec d'obtention d'équipement à partir de la configuration actuelle / brouillon",
	"views.box.views.configuration.views.networks.network-list.network-deleted": "Réseau supprimé",
	"views.box.views.configuration.views.networks.network-list.search-network": "Rechercher un réseau",
	"views.box.views.configuration.views.notifications.alarm-deleted": "Notification d'événement supprimée",
	"views.box.views.configuration.views.notifications.components.form-recipient.recipient-type": "Type de destinataire",
	"views.box.views.configuration.views.notifications.components.form-recipient.recipient-type-tooltip": "Où le destinataire recevra l'alarme?\nPar e-mail ou sur une chaîne Slack?",
	"views.box.views.configuration.views.notifications.components.panel-alarm.failed-saving": "Échec de l'enregistrement de la notification d'événement",
	"views.box.views.configuration.views.notifications.components.panel-alarm.recipient": "Destinataire",
	"views.box.views.configuration.views.notifications.components.panel-alarm.recipient-tooltip": "Où / à qui l'alarme sera-t-elle envoyée?",
	"views.box.views.configuration.views.notifications.components.panel-alarm.saved": "Notification d'événement enregistrée avec succès",
	"views.box.views.configuration.views.notifications.components.panel-alarm.title": "Configurer la notification d'événements",
	"views.box.views.configuration.views.notifications.components.panel-alarm.type": "Type d'événement",
	"views.box.views.configuration.views.notifications.components.panel-alarm.type-tooltip": "Type d'événement : lorsque la @.lower:box se connecte ou se déconnecte",
	"views.box.views.configuration.views.notifications.create-new-recipient": "Créer un nouveau destinataire",
	"views.box.views.configuration.views.notifications.failed-deleting-alarm": "Échec de la suppression de la notification d'événement",
	"views.box.views.configuration.views.notifications.failed-getting-recipients": "Échec d'obtention des destinataires",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-data-point-type": "Identificateur de type de point de donnée KNX au format \"xx.yyyy\", où: xx: le numéro principal; yyyy: le sous-numéro",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-group-address": "L'adresse de groupe à 3 niveaux où accéder à cette propriété.Format \"xxx / yyy / zzz\", où: xxx: le groupe principal; yyy: le groupe intermédiaire; zzz: le sous-groupe",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-object-index": "L'index d'objet de la propriété à lire",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-property-index": "L'index de propriété de la propriété à lire",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-start-index": "L'index de début de la propriété à lire",
	"views.box.views.configuration.views.properties.components.panels.failed-slug": "Échec de la création du slug. Essayez de changer le nom de la propriété (en supprimant les caractères spéciaux) ou contactez-nous.",
	"views.box.views.configuration.views.properties.components.panels.timer_error": "L'intervalle doit être supérieur à {seconds} secondes",
	"views.box.views.configuration.views.properties.components.panels.title": "Propriété {title}",
	"views.box.views.configuration.views.properties.components.panels.tooltip-unit": "L'unité d'ingénierie de cette propriété.",
	"views.box.views.configuration.views.properties.failed-information-equipment": "Impossible d'obtenir des informations de l'équipement",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.send-configuration": "Envoyer la configuration à la @.lower:box pour appliquer les modifications de propriétés",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.show-less": "Cliquez pour afficher moins",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.show-more": "Cliquez pour afficher plus",
	"views.box.views.configuration.views.properties.properties.list-properties": "Liste des propriétés pour {equipment}",
	"views.box.views.configuration.views.properties.properties.slug-duplicated-error": "Le slug de la propriété est déjà utilisé.Changez-le, s'il vous plaît (vous le trouverez dans Advanced)",
	"views.box.views.graph.graph.export": "Exporter",
	"views.box.views.graph.graph.select-least-one-property": "Sélectionnez au moins une propriété dans la liste ci-dessous",
	"views.box.views.graph.graph.select-range": "Sélectionnez une période",
	"views.box.views.logs.components.tabs.campaigns": "Campagnes",
	"views.box.views.logs.components.tabs.commands": "Commandes",
	"views.box.views.logs.components.tabs.events": "Événements",
	"views.box.views.logs.modal-commands-details.body": "Corps de message",
	"views.box.views.logs.modal-commands-details.commandid": "ID de commande",
	"views.box.views.logs.modal-commands-details.commandtype": "Type",
	"views.box.views.logs.modal-commands-details.createdby": "Créé par",
	"views.box.views.logs.modal-commands-details.date": "Date",
	"views.box.views.logs.modal-commands-details.deviceid": "Device ID",
	"views.box.views.logs.modal-commands-details.last": "Dernière mise à jour",
	"views.box.views.logs.modal-commands-details.retry": "Nombre de tentatives",
	"views.box.views.logs.modal-commands-details.status": "Etat",
	"views.box.views.logs.modal-events-details.code": "Code",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.last-value": "Dernière valeur définie",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.new-value": "Nouvelle valeur",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.title": "Définir la valeur de la propriété",
	"views.box.views.properties.views.properties.components.property-graph.no-available-properties": "Aucune valeur de propriété à afficher",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.info-equipment": "Je souhaite ajouter l'équipement {equipment} à la liste.\tAutre information :",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.inform-equipment-connect": "Veuillez nous informer quel est le matériel (marque, modèle et autres informations utiles) que vous souhaitez relier à la @.lower:box .",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.placeholder": "Marque, modèle ou autre information utile de l'équipement",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.problem-submiting-request": "La demande n'a pas été envoyée. Réessayez plus tard.",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.request": "Demander",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.request-add-equipment": "Demander l'ajout d'un équipement",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.specify-equipment": "Vous devez spécifier quel équipement vous souhaitez que nous ajoutions",
	"views.box.views.wizard-configuration.components.dialog-saving.add-another": "Ajouter un autre équipement",
	"views.box.views.wizard-configuration.components.dialog-saving.check-configuration": "Voir la configuration",
	"views.box.views.wizard-configuration.components.dialog-saving.hold-on": "Mise à jour de la configuration",
	"views.box.views.wizard-configuration.components.dialog-saving.problem-saving": "Il y a eu un soucis d'enregistrement! Que souhaitez-vous faire ?",
	"views.box.views.wizard-configuration.components.dialog-saving.remaining": "Il restera à enregistrer les modifications dans la box.",
	"views.box.views.wizard-configuration.components.dialog-saving.save": "Sauvegardé !",
	"views.box.views.wizard-configuration.components.dialog-saving.wait": "Merci de patienter pendant la mise à jour",
	"views.box.views.wizard-configuration.components.filters.all": "Tous",
	"views.box.views.wizard-configuration.components.filters.equipment": "Équipement",
	"views.box.views.wizard-configuration.components.properties-filters.read": "Lire",
	"views.box.views.wizard-configuration.components.properties-filters.search-for-properties-or-equipment": "Rechercher des propriétés ou des équipements",
	"views.box.views.wizard-configuration.components.properties-filters.write": "Écrire",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.failed-get-network-config": "Impossible d'obtenir la configuration du réseau",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.went-wrong": "Quelque chose d'anormal s'est produit de notre côté. Essayez à nouveau.",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.which-connector-plugged": "A quel connecteur l'équipement est-il branché ?",
	"views.box.views.wizard-configuration.steps.configure-connector-serial.connector-warning-message": "Attention, la modification de cette configuration affectera tous les autres équipements connectés à ce connecteur.",
	"views.box.views.wizard-configuration.steps.configure-network-knx.title": "Configurer les adresses KNX dans la @.lower:box - Configuration du réseau KNX",
	"views.box.views.wizard-configuration.steps.select-equipment.ask-request-equipment": "Nous n'avons pas encore cet équipement. Souhaiteriez-vous que nous le rajoutions?",
	"views.box.views.wizard-configuration.steps.select-equipment.field-required": "Le champ {fieldName} est obligatoire",
	"views.box.views.wizard-configuration.steps.select-equipment.field-validation": "Le champ {fieldName} doit être entre {validationmin} et {validationmax}",
	"views.box.views.wizard-configuration.steps.select-equipment.number-required": "Le champ {fieldName} doit être un nombre",
	"views.box.views.wizard-configuration.steps.select-equipment.request-it": "Faire la demande",
	"views.box.views.wizard-configuration.steps.select-equipment.search-brand-model": "Vous pouvez rechercher la marque et / ou le modèle de l'équipement",
	"views.box.views.wizard-configuration.steps.select-equipment.select-protocol": "Quel est le protocole de communication pour l'équipement ?",
	"views.box.views.wizard-configuration.wizard-configuration.send-to-box": "Enregistrer sur la @.lower:box",
	"views.file-resources-management.edit-file": "Editer le fichier",
	"views.file-resources-management.failed-getting-files": "Échec d'obtention de la liste des fichiers",
	"views.file-resources-management.failed-uploading-file": "Échec du téléchargement du fichier",
	"views.file-resources-management.last-modified": "Mis à jour à",
	"views.file-resources-management.title": "Gestion de fichiers",
	"views.file-resources-management.upload-new-file": "Importer un nouveau fichier",
	"views.organization.access-management.boxes-privileges.boxes-permissions": "Accès par box",
	"views.organization.access-management.boxes-privileges.description-boxes-permissions": "Définissez le type d'accès par box pour une gestion plus précise des droits.",
	"views.organization.access-management.panel-user.description-organizations-permissions": "Définissez le type d'accès aux organisations. Les droits s'appliquent automatiquement aux boxes de l'organisation et de ses sous-organisations.",
	"views.organization.access-management.panel-user.organizations-permissions": "Accès par organisation",
	"views.organization.access-management.roles.administrative": "Gestion administrative",
	"views.organization.access-management.roles.administrative-description": "Gestion des organisations et sous-organisations",
	"views.organization.access-management.roles.alarm-access": "Gestion des alertes",
	"views.organization.access-management.roles.boxes-access": "Accès aux @.lower:boxes",
	"views.organization.access-management.roles.boxes-access-description": "Accès au données, tags, connecteurs, alarmes",
	"views.organization.access-management.roles.boxes-management": "Gestion des @.lower:boxes",
	"views.organization.access-management.roles.boxes-management-description": "Activation et Configuration des @.lower:boxes",
	"views.organization.access-management.roles.connectors-configuration": "Configuration des Connecteurs",
	"views.organization.access-management.roles.connectors-configuration-description": "MQTT, Webhooks, cannaux Slack, Compte Programmatique (Clef d'Api)",
	"views.organization.access-management.roles.metadata-configuration": "Gestion des métadonnées",
	"views.organization.access-management.roles.metadata-configuration-description": "Gestion des Sites, Groupes de @.lower:boxes",
	"views.organization.access-management.roles.users-management": "Gestion des Utilisateurs",
	"views.organization.components.notifications.form-email.email": "Email",
	"views.organization.components.notifications.form-slack.channel": "Canal",
	"views.organization.components.notifications.form-slack.url": "URL de l'API Slack",
	"views.organization.components.notifications.form-slack.username": "Nom d'utilisateur",
	"views.organization.components.service-accounts.list-api-keys.add-a-p-i-key": "Ajouter une clé API",
	"views.organization.components.service-accounts.list-api-keys.api-key-deleted": "Clé API supprimée",
	"views.organization.components.service-accounts.list-api-keys.api-keys": "Clés API",
	"views.organization.components.service-accounts.list-api-keys.failed-deleting-a-p-i-key": "Échec de la suppression de la clé API",
	"views.organization.components.service-accounts.list-api-keys.key": "Clé",
	"views.organization.components.service-accounts.list-api-keys.secret": "Secret",
	"views.organization.components.service-accounts.panel-create-api-key.advanced-options": "Options avancées",
	"views.organization.components.service-accounts.panel-create-api-key.api-key-created": "Clé Api créée",
	"views.organization.components.service-accounts.panel-create-api-key.create-api-key": "Ajouter une clé API",
	"views.organization.components.service-accounts.panel-create-api-key.description": "Description",
	"views.organization.components.service-accounts.panel-create-api-key.download-a-p-i-key": "Télécharger la clé",
	"views.organization.components.service-accounts.panel-create-api-key.expire-date": "Date d'expiration",
	"views.organization.components.service-accounts.panel-create-api-key.expire-in-hours": "Expire en heures",
	"views.organization.components.service-accounts.panel-create-api-key.failed-creating-a-new-api-key": "Échec de la création d'une nouvelle clé de l'API",
	"views.organization.components.service-accounts.panel-create-api-key.field-expire-in-hours-must-be-a-number->-1": "Le champ Expire en heures doit être un nombre > 1",
	"views.organization.components.service-accounts.panel-create-api-key.key": "Clé",
	"views.organization.components.service-accounts.panel-create-api-key.save-key-message": "Merci de copier le SECRET dans un endroit sécurisé. S'il est perdu il ne peux pas être récupéré !",
	"views.organization.components.service-accounts.panel-create-api-key.secret": "Secret",
	"views.organization.components.service-accounts.panel-create-api-key.tooltip-expire-hours": "Dans combien de temps après la création cette clé API doit-elle expirer?",
	"views.organization.components.service-accounts.panel-create-service-account.create-service-account": "Créer une compte de service",
	"views.organization.components.service-accounts.panel-create-service-account.error-prefix": "Le préfixe ne doit contenir que des caractères alphanumériques avec des tirets facultatifs",
	"views.organization.components.service-accounts.panel-create-service-account.failed-creating-service-account": "Échec de la création d'un nouveau compte de service",
	"views.organization.components.service-accounts.panel-create-service-account.password": "Mot de passe",
	"views.organization.components.service-accounts.panel-create-service-account.prefix": "Préfixe",
	"views.organization.components.service-accounts.panel-create-service-account.service-account-created": "Compte de service créé",
	"views.organization.components.service-accounts.panel-create-service-account.tooltip-password": "Le mot de passe pour vous connecter avec ce compte de service",
	"views.organization.components.service-accounts.panel-create-service-account.tooltip-prefix": "Le préfixe du nom d'utilisateur de ce compte de service. Ce préfixe doit être unique. Le nom d'utilisateur final aura la forme prefix{'@'}organizationId.svc.acct.wattsense.com",
	"views.organization.components.service-accounts.service-accounts-list.prefix": "Préfixe",
	"views.organization.components.service-accounts.service-accounts-list.qtt-apikeys": "Clés API",
	"views.user-profile.profile.language": "La langue",
	"views.user-profile.profile.name": "Nom",
	"views.user-profile.profile.newpassword": "Nouveau mot de passe",
	"virtual-properties.calculate-consumption": "Calculer une consommation",
	"virtual-properties.calculate-consumption.description": "Écart de valeurs sur un intervalle de temps.",
	"virtual-properties.calculate-multiple": "Calcul associant plusieurs propriétés",
	"virtual-properties.calculate-multiple.description": "Opérations arithmétiques entre plusieurs propriétés.",
	"virtual-properties.checkbox-create-another-property-after-save": "Créer une autre propriété virtuelle après celle-ci",
	"virtual-properties.consumption-interval": "Quel intervalle de consommation ?",
	"virtual-properties.consumption-interval-tooltip": "La consommation est calculée pour chaque intervalle avec cette formule : différence entre la dernière valeur connue de la propriété sur l'intervalle et la première valeur connue sur le même intervalle.",
	"virtual-properties.create-virtual-property": "Créer une propriété virtuelle",
	"virtual-properties.data-transmition-frequency-interval-label": "Fréquence de remontée des données ou intervalle :",
	"virtual-properties.edit-virtual-property": "Editer une propriété virtuelle",
	"virtual-properties.failed-deleting-property": "Échec de la suppression de la propriété virtuelle",
	"virtual-properties.failed-saving": "Échec de l'enregistrement de la propriété virtuelle",
	"virtual-properties.failed-saving-property": "Échec de la création de la propriété virtuelle",
	"virtual-properties.failed-updating-property": "Échec de la mise à jour de la propriété virtuelle",
	"virtual-properties.last-value-label": "Dernière valeur :",
	"virtual-properties.other-calculation": "Autre calcul",
	"virtual-properties.property-created": "Propriété virtuelle enregistrée",
	"virtual-properties.property-deleted": "Propriété virtuelle supprimée",
	"virtual-properties.property-updated": "Propriété virtuelle mise à jour",
	"virtual-properties.property-value": "Valeur de la propriété",
	"virtual-properties.received-at-label": "Reçu le :",
	"virtual-properties.search-by-name": "Rechercher par nom",
	"virtual-properties.select-properties-tooltip": "Choix de la propriété à partir de laquelle la consommation est calculée.",
	"virtual-properties.text-empty-state": "Créer de nouvelles propriétés calculées sur la base de propriétés existantes. Réservé pour le moment aux calculs de différence entre deux index.",
	"virtual-properties.virtual-properties": "Propriétés virtuelles",
	"virtual-properties.what-would-you-like-to-do": "Que souhaitez-vous faire ?",
	"virtual-property-cant-refresh": "Les valeurs des propriétés virtuelles sont actualisées automatiquement. Elles ne peuvent pas être rafraichies manuellement.",
	"virtual-property-created-but-not-activated-yet-go-to-configuration-and-save": "La propriété virtuelle a été créée, mais n'est pas encore activée. Dans l'écran  “Configuration”, cliquez sur “Enregistrer les modifications\" pour l'appliquer.",
	"virtual-property.error.missing-value": "Le calcul ne peut pas être réalisé car au moins une des propriétés n’a pas reçu de valeur.",
	"virtual-property.error.technical-issue": "Le calcul a échoué en raison d'un problème technique. <br> Détail technique : {errorMessage}",
	"virtual-property.error.uncalculable": "Le calcul ne peut pas être réalisé. <br> Détail technique : {errorMessage}",
	"virtual-property.error.wrong-type": "Le calcul ne peut pas être réalisé car la valeur d’au moins une des propriétés n’est pas un nombre.",
	"virtual-property.scaling-message-property-with-scaling": "La mise à l'échelle appliquée sur cette propriété n'est pas prise en compte pour le calcul de la propriété virtuelle. | La mise à l'échelle des propriétés sélectionnées n'est pas prise en compte dans le calcul des propriétés virtuelles.",
	"virtual-property.warn.scaling": "Prendre en compte la mise à l’échelle des propriétés sélectionnées.",
	"virtual-property.warn.scaling.no-properties.1": "Actuellement, aucune mise à l'échelle n'est appliquée aux propriétés sélectionnées.",
	"virtual-property.warn.scaling.no-properties.2": "Si cette option est active, toute mise à l'échelle ultérieure sera prise en compte.",
	"virtual-property.warn.scaling.properties": "Propriétés avec une mise à l'échelle (ax+b) :",
	"wait": "Attendre",
	"wait-for-the-new-scan": "Attendre la fin du nouveau scan",
	"wait-last-value": "En attente de la dernière valeur",
	"wait-until-receive-last-scan": "Attendez jusqu'à ce que la dernière analyse soit reçue",
	"waiting-for-data-received": "En attente de réception de données",
	"waiting-for-pairing": "En attente d’appairage",
	"waiting-for-scan": "En attente de scan",
	"waiting-for-the-hub": "En attente de la @.lower:hub",
	"warning-message-gms-provider": "Le réseau GSM que nous utilisons est actuellement instable. Les données envoyées vers notre cloud peuvent être impactées",
	"was-not-received-by-box": "n'a pas été reçu par la @.lower:box",
	"wattsense-headquarter": "Bureaux Wattsense",
	"we-will-try-for-another": "Nous essaierons encore pour",
	"webhooks": "Webhooks",
	"wednesday": "Mercredi",
	"week": "Semaine",
	"weekday": "Jour de la semaine",
	"weekly": "Hebdomadaire",
	"welcome": "Bienvenue",
	"what-configuration-from-equipment-for-box-communicate-with-it": "Quelle est la configuration de l'équipement pour que la @.lower:box puisse communiquer avec lui ?",
	"what-do-you-want-to-do-next": "Que voulez-vous faire ensuite ?",
	"what-would-like-to-do-next": "Que souhaitez-vous faire ensuite?",
	"when-it-ends": "Quand ça se termine?",
	"which-connector-equipment-is-plugged": "À quel connecteur avez-vous branché l'équipement ?",
	"windows": "Windows",
	"windows-instructions": "Instructions Windows",
	"wmbus-dib": "DIF et DIFE concaténés",
	"wmbus-physical-connector": "Antenne radio LoRaWAN",
	"wmbus-vib": "VIF et VIFE concaténés",
	"write": "Écrire",
	"write-function": "Fonction d'écriture",
	"write-only": "Écriture seule",
	"write-only-desc": "Autoriser uniquement l'écriture des valeurs depuis le cloud (écriture seule)",
	"wrong-file-extension": "Extension de fichier non valide. Seuls les fichiers .{format} sont acceptés.",
	"wrong-file-format": "Le format de votre fichier n'est pas conforme",
	"wrong-file-header": "L'entête du fichier n'est pas au bon format",
	"ws-data-table.no-records-to-display": "Aucun enregistrement à afficher",
	"ws-data-table.rows-of-page-are-selected": "1 ligne est sélectionnée au total. | {qtt} lignes sont sélectionnées au total.",
	"ws-data-table.select-all-available-rows": "Sélectionner toutes les lignes. | Sélectionner toutes les lignes ({qtt}).",
	"ws-form-treeselect.no-results": "Pas de résultats",
	"ws-recipient.without-access.help-msg": "Indiquer l'adresse e-mail de ce destinataire",
	"ws-recipient.without-access.placeholder": "ex. : nom.prenom{'@'}entreprise.com",
	"x-days": "jour | jours",
	"x-equipments": "{n} équipement | {n} équipements",
	"x-equipments-added": "{n} équipement ajouté | {n} équipements ajoutés",
	"x-other-equipments": "{count} autres équipements",
	"x-other-properties": "{count} autres propriétés",
	"x-properties-added": "{n} propriété ajoutée | {n} propriétés ajoutées",
	"x-property-selected": "Aucune propriété n'a été sélectionnée | {n} propriété a été sélectionnée | {n} propriétés ont été sélectionnées",
	"x-years": "ans | an | ans",
	"xlsx-file-format": "Format accepté : .xlsx",
	"y-axis": "Axe Y",
	"year": "Année",
	"yearly": "Annuel",
	"yes": "Oui",
	"you-can-upload-a-file-clicking-here": "Vous pouvez télécharger un fichier {0}",
	"you-dont-have-access-to-organization": "Vous n'avez pas accès à l'organisation",
	"you-dont-have-tags": "Vous n'avez pas de tags.",
	"your-email": "Votre email",
	"your-email.placeholder": "john{'@'}doe.com",
	"your-equipment": "Votre équipement",
	"your-phone": "Votre numéro de téléphone {optional}",
	"zero-organizations-found-with-term": "0 organisation trouvée avec le terme {term}"
}